import React, { useRef, useState, useEffect, useCallback, useMemo, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { Minus, Plus, Search, ArrowRoundedRightup, Checkmark, AlertCircleFilled, CancelCircleFilled, InfoCircle, ArrowRoundedLeft, ArrowRoundedRight, Close, InfoCircleFilled, ArrowLeft, ArrowRight, Calendar, Load, Location, ArrowDown, CheckmarkCircleFilled, ArrowRoundedUp, ArrowRoundedDown, Mail, Sms, SocialWhatsapp, SocialX, SocialFacebook, File as File$1, Delete, BookmarkFilled, Bookmark } from '@aok/icon-functional';
import Icon, { File } from '@aok/icon-linear';
import DatePicker, { registerLocale } from 'react-datepicker';
import ReactDOM from 'react-dom';
import { Picture } from '@aok/image';
import { useKeenSlider } from 'keen-slider/react.js';
import { Swiper, SwiperSlide } from 'swiper/react';

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function ownKeys$1(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2$1(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) {
      _defineProperty$1(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : String(i);
}
function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _excluded$g = ["className", "children", "accordionId"];
var Accordion = function Accordion(_ref) {
  var className = _ref.className,
    children = _ref.children,
    accordionId = _ref.accordionId,
    rest = _objectWithoutProperties$1(_ref, _excluded$g);
  var elementCount = React.Children.toArray(children).length;
  return /*#__PURE__*/React.createElement("ul", _extends$1({
    id: accordionId,
    className: "accordion ".concat(className)
  }, rest), React.Children.map(children, function (child, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index,
      className: "accordionElementWrapper"
    }, /*#__PURE__*/React.cloneElement(child, {
      isLastElement: index === elementCount - 1
    }));
  }));
};
Accordion.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  accordionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Accordion.defaultProps = {
  className: '',
  children: /*#__PURE__*/React.createElement("p", null, "Kein Accordion Element gesetzt")
};
var Accordion$1 = Accordion;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var _excluded$f = ["text", "tag", "id", "className", "children", "lang"];
var Headline = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var text = _ref.text,
    tag = _ref.tag,
    id = _ref.id,
    className = _ref.className,
    children = _ref.children,
    lang = _ref.lang,
    rest = _objectWithoutProperties(_ref, _excluded$f);
  var HeadlineTag = "".concat(tag);
  if (!text && !children) {
    return null;
  }
  if (children) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeadlineTag, _extends({
      ref: ref,
      id: id,
      lang: lang,
      className: "headline ".concat(className)
    }, rest), children));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeadlineTag, _extends({
    ref: ref,
    id: id,
    lang: lang,
    className: "headline ".concat(className),
    dangerouslySetInnerHTML: {
      __html: text
    }
  }, rest)));
});
Headline.propTypes = {
  tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p']),
  text: PropTypes.string,
  id: PropTypes.string,
  lang: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};
Headline.defaultProps = {
  tag: 'p',
  className: ''
};
var HeadlineContext = /*#__PURE__*/React.createContext({
  level: 1,
  tag: 'h1',
  disabled: false
});
var HeadlineLevel = function HeadlineLevel(props) {
  var MAX_LEVEL = 6;
  var increaseLevel = function increaseLevel(level, disabled) {
    if (disabled) {
      return {
        tag: 'p',
        disabled: disabled
      };
    }
    var newLevel = Math.min(level + 1, MAX_LEVEL);
    return {
      level: newLevel,
      tag: "h".concat(newLevel),
      disabled: disabled
    };
  };
  return /*#__PURE__*/React.createElement(HeadlineContext.Consumer, null, function (_ref) {
    var level = _ref.level,
      disabled = _ref.disabled;
    return /*#__PURE__*/React.createElement(HeadlineContext.Provider, {
      value: increaseLevel(level, disabled)
    }, props.children);
  });
};
var ContextHeadline = function ContextHeadline(props) {
  return /*#__PURE__*/React.createElement(HeadlineContext.Consumer, null, function (_ref2) {
    var tag = _ref2.tag;
    return /*#__PURE__*/React.createElement(Headline, _objectSpread2(_objectSpread2({}, props), {}, {
      tag: props.tag || tag
    }));
  });
};
ContextHeadline.propTypes = {
  tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p']),
  text: PropTypes.string,
  id: PropTypes.string,
  lang: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};
var TextBlock = function TextBlock(_ref) {
  var headline = _ref.headline,
    text = _ref.text,
    className = _ref.className,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement("div", {
    className: "textBlock ".concat(className),
    "data-cy": testId
  }, headline && /*#__PURE__*/React.createElement(ContextHeadline, headline), /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: "".concat(text ? text : '')
    }
  }));
};
TextBlock.propTypes = {
  headline: PropTypes.shape(ContextHeadline.propTypes),
  text: PropTypes.string,
  className: PropTypes.string,
  testId: PropTypes.string
};
TextBlock.defaultProps = {
  className: ''
};
({
  text: PropTypes.string
});

var labelVisibilityState = {
  SHOW: 'show',
  HIDE: 'hide',
  FLOATING: 'floating'
};
var bgVariant = {
  LIGHT: 'light',
  DARK: 'dark',
  STRUCTURE: 'structure',
  SAND: 'sand',
  PASTEL_BLUE: 'pastel-blue',
  ERROR: 'error'
};
var position = {
  LEFT: 'left',
  RIGHT: 'right'
};
var align = {
  START: 'start',
  CENTER: 'center',
  END: 'end'
};
var direction = {
  UP: 'up',
  DOWN: 'down'
};
var size = {
  SMALL: 'small',
  LARGE: 'large'
};
var StatusNotificationVariant = {
  INFO: 'info',
  ERROR: 'error',
  SUCCESS: 'success'
};
var SocialMediaChannel = {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  X: 'x',
  WHATSAPP: 'whatsapp',
  MAIL: 'mail',
  SMS: 'sms'
};
var RadioButtonType = {
  CARD: 'card',
  DEFAULT: 'default'
};
var CheckboxButtonType = {
  CARD: 'card',
  DEFAULT: 'default'
};

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

var classnames = createCommonjsModule(function (module) {
/* global define */

(function () {

  var hasOwn = {}.hasOwnProperty;
  function classNames() {
    var classes = [];
    for (var i = 0; i < arguments.length; i++) {
      var arg = arguments[i];
      if (!arg) continue;
      var argType = typeof arg;
      if (argType === 'string' || argType === 'number') {
        classes.push(arg);
      } else if (Array.isArray(arg)) {
        if (arg.length) {
          var inner = classNames.apply(null, arg);
          if (inner) {
            classes.push(inner);
          }
        }
      } else if (argType === 'object') {
        if (arg.toString === Object.prototype.toString) {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        } else {
          classes.push(arg.toString());
        }
      }
    }
    return classes.join(' ');
  }
  if (module.exports) {
    classNames.default = classNames;
    module.exports = classNames;
  } else {
    window.classNames = classNames;
  }
})();
});

var buttonType = {
  LABEL: 'label',
  HEADLINE: 'headline'
};
var AccordionElement = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var label = _ref.label,
    headline = _ref.headline,
    className = _ref.className,
    buttonClassName = _ref.buttonClassName,
    collapseClassName = _ref.collapseClassName,
    settings = _ref.settings,
    children = _ref.children,
    isLastElement = _ref.isLastElement,
    onToggle = _ref.onToggle,
    isInitiallyOpen = _ref.isInitiallyOpen,
    hideChildrenWhenClosed = _ref.hideChildrenWhenClosed,
    testId = _ref.testId,
    accordionElementId = _ref.accordionElementId;
  var contentRef = useRef(null);
  var _useState = useState(isInitiallyOpen || false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState('0px'),
    _useState4 = _slicedToArray(_useState3, 2),
    maxHeight = _useState4[0],
    setMaxHeight = _useState4[1]; // initial maxHeight

  var handleToggle = function handleToggle() {
    var newOpenState = !isOpen;
    if (onToggle) onToggle(newOpenState);
    setIsOpen(newOpenState);
  };
  var updateMaxHeight = function updateMaxHeight() {
    setMaxHeight(isOpen ? "".concat(contentRef.current.scrollHeight, "px") : '0px');
  };
  useEffect(function () {
    if (contentRef.current) {
      updateMaxHeight();
      var _handleToggle = function _handleToggle() {
        updateMaxHeight();
      };
      contentRef.current.addEventListener('toggle', _handleToggle, true);
      if (typeof window !== 'undefined' && typeof ResizeObserver !== 'undefined') {
        var resizeObserver = new ResizeObserver(updateMaxHeight);
        resizeObserver.observe(contentRef.current);
        return function () {
          resizeObserver.disconnect();
        };
      }
    }
  }, [isOpen]);
  var renderLabel = function renderLabel() {
    if (typeof label === 'string') return /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: label
      }
    });else return label;
  };
  var elementClasses = classnames({
    '-light': settings.bgVariant === bgVariant.LIGHT,
    '-dark': settings.bgVariant === bgVariant.DARK,
    '-structure': settings.bgVariant === bgVariant.STRUCTURE,
    'bg-ffffff': settings.bgVariant === bgVariant.LIGHT,
    'bg-transparent': settings.bgVariant === bgVariant.STRUCTURE,
    'text-293033': settings.bgVariant === bgVariant.LIGHT || settings.bgVariant === bgVariant.STRUCTURE,
    'bg-005e3f text-ffffff': settings.bgVariant === bgVariant.DARK,
    'border-dfe3e6': settings.bgVariant === bgVariant.LIGHT,
    'border-4d7e6e': settings.bgVariant === bgVariant.DARK,
    'border-c7ccd1': settings.bgVariant === bgVariant.STRUCTURE,
    'last:border-b-2': isLastElement
  });
  var buttonClasses = classnames('flex items-start justify-between p-16 w-full text-left font-buenos-aires font-semibold text-16 leading-24', {
    '1000:hover:text-07983e': settings.bgVariant === bgVariant.LIGHT,
    '1000:hover:text-18ab42': settings.bgVariant === bgVariant.STRUCTURE,
    '1000:hover:text-50eb5d': settings.bgVariant === bgVariant.DARK
  });
  var iconClasses = classnames('mt-4 ml-16 shrink-0 relative w-16 h-16 fill-current plusMinusIconButton');
  var renderChildren = function renderChildren() {
    if (!isOpen && hideChildrenWhenClosed) {
      return null;
    } else {
      return children;
    }
  };
  var renderOpenCloseIcon = function renderOpenCloseIcon() {
    return isOpen ? /*#__PURE__*/React.createElement(Minus, {
      className: iconClasses
    }) : /*#__PURE__*/React.createElement(Plus, {
      className: iconClasses
    });
  };
  var ButtonContent = function ButtonContent() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, settings.buttonType !== buttonType.LABEL ? /*#__PURE__*/React.createElement(HeadlineLevel, null, /*#__PURE__*/React.createElement(ContextHeadline, {
      tag: headline.tag,
      className: "".concat(buttonClassName, " ").concat(buttonClasses)
    }, headline.text, renderOpenCloseIcon())) : /*#__PURE__*/React.createElement("span", {
      className: "".concat(buttonClasses, " ").concat(buttonClassName)
    }, renderLabel(), renderOpenCloseIcon()));
  };
  return /*#__PURE__*/React.createElement("div", {
    id: accordionElementId,
    ref: ref,
    className: "accordionElement border-t-2 ".concat(className, " ").concat(elementClasses),
    "data-cy": testId,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("summary", {
    className: "outline-0 cursor-pointer group",
    onClick: handleToggle
  }, /*#__PURE__*/React.createElement(ButtonContent, null)), /*#__PURE__*/React.createElement("div", {
    ref: contentRef,
    className: classnames('accordion-content', _defineProperty$1({
      open: isOpen
    }, collapseClassName, collapseClassName)),
    style: {
      maxHeight: maxHeight,
      overflow: 'hidden'
    }
  }, renderChildren()));
});
AccordionElement.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  headline: PropTypes.shape({
    tag: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
  }),
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  collapseClassName: PropTypes.string,
  hasCollapsePadding: PropTypes.bool,
  settings: PropTypes.shape({
    buttonType: PropTypes.oneOf(Object.values(buttonType)),
    bgVariant: PropTypes.oneOf([bgVariant.DARK, bgVariant.LIGHT, bgVariant.STRUCTURE])
  }),
  children: PropTypes.node,
  onToggle: PropTypes.func,
  isLastElement: PropTypes.bool,
  isInitiallyOpen: PropTypes.bool,
  hideChildrenWhenClosed: PropTypes.bool,
  testId: PropTypes.string,
  accordionElementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AccordionElement.defaultProps = {
  className: '',
  buttonClassName: '',
  collapseClassName: '',
  hasCollapsePadding: true,
  settings: {
    buttonType: buttonType.LABEL,
    bgVariant: bgVariant.LIGHT
  },
  isLastElement: true,
  hideChildrenWhenClosed: false
};
var AccordionElement$1 = AccordionElement;

var radioButtonPropTypes = PropTypes.shape({
  additionalLabel: PropTypes.string,
  label: PropTypes.string,
  popover: PropTypes.node,
  props: PropTypes.object,
  required: PropTypes.bool,
  "abstract": PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});
var autocompletePropTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  infoLabel: PropTypes.string,
  list: PropTypes.array,
  additionalList: PropTypes.array,
  additionalListLabel: PropTypes.string,
  ariaLabel: PropTypes.string,
  variant: PropTypes.string,
  id: PropTypes.string,
  additionalListId: PropTypes.string,
  hasMinimalistDesign: PropTypes.bool,
  shouldReceiveFocus: PropTypes.bool,
  onSelect: PropTypes.func,
  onShouldHideAutocompleteList: PropTypes.func
};
var autocompleteDefaultProps = {
  className: '',
  label: '',
  list: [],
  variant: bgVariant.LIGHT,
  ariaLabel: 'Vorschlagsliste',
  id: 'autocomplete',
  hasMinimalistDesign: false,
  shouldReceiveFocus: false,
  onSelect: function onSelect() {},
  onShouldHideAutocompleteList: function onShouldHideAutocompleteList() {}
};
var searchFieldPropTypes = {
  label: PropTypes.string,
  inputProps: PropTypes.shape({
    type: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    required: PropTypes.bool
  }),
  ariaDescribedby: PropTypes.string,
  error: PropTypes.string,
  variant: PropTypes.oneOf([bgVariant.LIGHT, bgVariant.DARK]),
  buttonIsDisabled: PropTypes.bool,
  labelVisibility: PropTypes.oneOf(Object.values(labelVisibilityState)),
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  onBlurInput: PropTypes.func,
  onChangeInput: PropTypes.func,
  onFocusInput: PropTypes.func,
  onKeyDownInput: PropTypes.func,
  onKeyUpInput: PropTypes.func,
  onDeleteButtonClick: PropTypes.func,
  onSubmitButtonClick: PropTypes.func,
  popover: PropTypes.node,
  id: PropTypes.string,
  hideErrorMessage: PropTypes.bool,
  searchButtonVariant: PropTypes.oneOf([size.SMALL, size.LARGE]),
  handleErrorExternally: PropTypes.bool,
  hasVerticalAlignedElems: PropTypes.bool,
  isLocationSearch: PropTypes.bool,
  isEmptyInputAllowed: PropTypes.bool,
  submitButtonLabel: PropTypes.string
};
var searchFieldDefaultProps = {
  label: 'Label nicht gesetzt',
  inputProps: {
    name: 'Name nicht gesetzt',
    type: 'number'
  },
  labelVisibility: labelVisibilityState.FLOATING,
  variant: bgVariant.LIGHT,
  searchButtonVariant: size.SMALL,
  hasVerticalAlignedElems: false,
  isLocationSearch: false,
  isEmptyInputAllowed: true,
  error: 'Bitte geben Sie ein Suchbegriff ein',
  submitButtonLabel: 'Suchen',
  className: '',
  handleErrorExternally: false,
  hasSearchButton: true,
  onBlurInput: function onBlurInput() {},
  onChangeInput: function onChangeInput() {},
  onFocusInput: function onFocusInput() {},
  onKeyUpInput: function onKeyUpInput() {},
  onKeyDownInput: function onKeyDownInput() {},
  onDeleteButtonClick: function onDeleteButtonClick() {},
  onSubmitButtonClick: function onSubmitButtonClick() {}
};

// Mapping of non-printable keycodes relevant for the autocomplete
var keys = {
  esc: 'Escape',
  tab: 'Tab',
  enter: 'Enter',
  up: 'ArrowUp',
  down: 'ArrowDown'
};

// Implementation is based on https://adamsilver.io/blog/building-an-accessible-autocomplete-control/
/**
 * @type React.FC<autocompletePropTypes>
 */
var AutocompleteList = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    label = _ref.label,
    infoLabel = _ref.infoLabel,
    list = _ref.list,
    additionalList = _ref.additionalList,
    additionalListLabel = _ref.additionalListLabel,
    variant = _ref.variant,
    id = _ref.id,
    ariaLabel = _ref.ariaLabel,
    onSelect = _ref.onSelect,
    onShouldHideAutocompleteList = _ref.onShouldHideAutocompleteList,
    hasMinimalistDesign = _ref.hasMinimalistDesign,
    inputRef = _ref.inputRef;
  var listItemsRef = useRef([]); // elements are accessible by listItemsRef.current[n]
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    activeItemIndex = _useState2[0],
    setActiveItemIndex = _useState2[1];
  var _useState3 = useState(additionalList ? list.concat(additionalList) : list),
    _useState4 = _slicedToArray(_useState3, 1),
    listElements = _useState4[0];
  var spacingClasses = classnames({
    'px-32 py-8': hasMinimalistDesign,
    'py-16 ml-16 mr-30 1000:mr-48': !hasMinimalistDesign
  });
  var textColorClasses = classnames({
    'text-293033 hover:text-18ab42 focus:text-18ab42': variant === bgVariant.LIGHT && !hasMinimalistDesign,
    'text-ffffff hover:text-50eb5d focus:text-50eb5d': variant === bgVariant.DARK && !hasMinimalistDesign,
    'text-293033 hover:bg-eefaea focus:bg-eefaea': variant === bgVariant.LIGHT && hasMinimalistDesign,
    'text-ffffff hover:bg-eefaea focus:bg-eefaea': variant === bgVariant.DARK && hasMinimalistDesign
  });
  var borderColor = classnames({
    'border-dfe3e6': variant === bgVariant.LIGHT && !hasMinimalistDesign,
    'border-4d7e6e': variant === bgVariant.DARK && !hasMinimalistDesign
  });
  var wrapperClasses = classnames({
    'bg-ffffff': variant === bgVariant.LIGHT,
    'bg-005e3f': variant === bgVariant.DARK
  });
  var handleUpKey = useCallback(function (activeResultIndex, inputIsFocused) {
    if (inputIsFocused) {
      listItemsRef.current[listItemsRef.current.length - 1].focus();
      setActiveItemIndex(listItemsRef.current.length - 1);
    } else {
      if (activeResultIndex === 0) {
        var _inputRef$current;
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
      } else {
        listItemsRef.current[activeResultIndex - 1].focus();
        setActiveItemIndex(activeResultIndex - 1);
      }
    }
  }, [listItemsRef, setActiveItemIndex, inputRef]);
  var handleDownKey = useCallback(function (activeResultIndex, inputIsFocused) {
    if (inputIsFocused) {
      listItemsRef.current[0].focus();
      setActiveItemIndex(0);
    } else {
      if (activeResultIndex === listItemsRef.current.length - 1) {
        var _inputRef$current2;
        (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.focus();
      } else {
        listItemsRef.current[activeResultIndex + 1].focus();
        setActiveItemIndex(activeResultIndex + 1);
      }
    }
  }, [listItemsRef, setActiveItemIndex, inputRef]);
  var handleEnterKey = useCallback(function (event, activeResultIndex) {
    if (listItemsRef.current[activeResultIndex]) {
      onSelect(event, listElements[activeResultIndex]);
    }
  }, [listItemsRef, listElements, onSelect]);
  var onKeyDown = useCallback(function (event) {
    var inputIsFocused = inputRef && document.activeElement === inputRef.current;
    var activeResultIndex = listItemsRef.current.findIndex(function (child) {
      return child === document.activeElement;
    });
    switch (event.key) {
      case keys.up:
        event.preventDefault();
        handleUpKey(activeResultIndex, inputIsFocused);
        break;
      case keys.down:
        event.preventDefault();
        handleDownKey(activeResultIndex, inputIsFocused);
        break;
      case keys.enter:
        event.preventDefault();
        handleEnterKey(event, activeResultIndex);
        break;
      case keys.tab:
      case keys.esc:
        onShouldHideAutocompleteList();
        break;
    }
  }, [handleUpKey, handleDownKey, handleEnterKey, onShouldHideAutocompleteList, inputRef]);
  useEffect(function () {
    if (list && (list === null || list === void 0 ? void 0 : list.length) > 0 || additionalList && (additionalList === null || additionalList === void 0 ? void 0 : additionalList.length) > 0) {
      document.body.addEventListener('keydown', onKeyDown);
    } else {
      document.body.removeEventListener('keydown', onKeyDown);
    }
    return function () {
      document.body.removeEventListener('keydown', onKeyDown);
    };
  }, [list, additionalList, onKeyDown]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(wrapperClasses)
  }, label && /*#__PURE__*/React.createElement("span", {
    className: "".concat(hasMinimalistDesign ? 'px-32 mb-8 mt-24' : 'px-16 mt-32', " text-12 leading-18 text-293033 block")
  }, label), /*#__PURE__*/React.createElement("ul", {
    id: id,
    ref: ref,
    role: "listbox",
    "aria-label": ariaLabel,
    className: "".concat(className, " w-full ").concat(!hasMinimalistDesign ? 'pr-30 1000:pr-48' : '')
  }, list.map(function (entry, index) {
    return /*#__PURE__*/React.createElement("li", {
      ref: function ref(el) {
        return listItemsRef.current[index] = el;
      },
      role: "option",
      tabIndex: -1 // to prevent tabbing through the list; only arrow up/down should be allowed
      ,
      "aria-selected": activeItemIndex === index,
      onClick: function onClick(e) {
        return onSelect(e, entry);
      },
      key: "".concat(id, "-").concat(index),
      className: "\n                  flex flex-row w-full items-start leading-24\n                  focus:outline-0 cursor-pointer\n                  ".concat(spacingClasses, "\n                  ").concat(!hasMinimalistDesign && index !== 0 ? 'border-t-2 -mt-2 pt-18' : '', "\n                  ").concat(textColorClasses, " ").concat(borderColor, "\n                ")
    }, !hasMinimalistDesign && /*#__PURE__*/React.createElement(Search, {
      className: "fill-current mr-8 w-16 h-16 relative top-2 shrink-0"
    }), /*#__PURE__*/React.createElement("span", {
      className: "autocomplete text-left",
      dangerouslySetInnerHTML: {
        __html: entry
      }
    }));
  }), !!additionalList && additionalList.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, !!additionalListLabel && /*#__PURE__*/React.createElement("li", {
    role: "option",
    "aria-label": additionalListLabel,
    className: "additionalListLabel focus-visible:outline-0 flex items-center pl-16 py-16 -mr-16 1000:py-24"
  }, /*#__PURE__*/React.createElement("hr", {
    className: "border-t border-dotted border-dfe3e6 h-1 flex-1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "additionalListLabel font-regular text-12 leading-18 text-6d767c mx-6 w-auto flex-shrink-0"
  }, additionalListLabel), /*#__PURE__*/React.createElement("hr", {
    className: "border-t border-dotted border-dfe3e6 h-1 flex-1"
  })), additionalList.map(function (entry, index) {
    return /*#__PURE__*/React.createElement("li", {
      ref: function ref(el) {
        return listItemsRef.current[index + list.length] = el;
      },
      role: "option",
      tabIndex: -1 // to prevent tabbing through the list; only arrow up/down should be allowed
      ,
      "aria-selected": activeItemIndex === index,
      onClick: function onClick(e) {
        return onSelect(e, entry);
      },
      key: "".concat(id, "-").concat(index),
      className: "\n                      flex flex-row items-start w-full leading-24\n                      focus:outline-0 cursor-pointer\n                      ".concat(spacingClasses, "\n                      ").concat(!hasMinimalistDesign && index !== 0 ? 'border-t-2 -mt-2 pt-18' : '', "\n                      ").concat(textColorClasses, " ").concat(borderColor, "\n                    ")
    }, !hasMinimalistDesign && /*#__PURE__*/React.createElement(ArrowRoundedRightup, {
      className: "fill-current mr-8 w-16 h-16 relative top-2 shrink-0"
    }), /*#__PURE__*/React.createElement("span", {
      className: "flex flex-col items-start 760:flex-row 760:justify-between w-full"
    }, /*#__PURE__*/React.createElement("span", {
      className: "autocomplete text-left",
      dangerouslySetInnerHTML: {
        __html: entry
      }
    }), infoLabel && /*#__PURE__*/React.createElement("span", {
      className: "mt-8 border border-afb6bc rounded-4 py-2 px-8 font-semibold text-12 leading-18 text-6d767c w-auto 760:mt-0"
    }, infoLabel)));
  }))), /*#__PURE__*/React.createElement("div", {
    "aria-live": "polite",
    role: "status",
    className: "sr-only"
  }, "".concat(list.length + (additionalList === null || additionalList === void 0 ? void 0 : additionalList.length), " ").concat(list.length === 1 ? 'Ergebnis' : 'Ergebnisse', " gefunden.")));
});
AutocompleteList.propTypes = _objectSpread2$1({}, autocompletePropTypes);
AutocompleteList.defaultProps = _objectSpread2$1({}, autocompleteDefaultProps);
var AutocompleteList$1 = AutocompleteList;

function createRandomID() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "".concat(prefix, "-").concat(Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1));
}

var CheckboxIndicator = function CheckboxIndicator(_ref) {
  var variant = _ref.variant,
    hasError = _ref.hasError,
    disabled = _ref.disabled,
    className = _ref.className,
    checkMarkClassName = _ref.checkMarkClassName;
  var checkmarkFill = classnames({
    '#40484D': (variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE) && !disabled,
    '#AFB6BC': (variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE) && disabled,
    '#ffffff': variant === bgVariant.DARK && !disabled,
    '#98A1A6': variant === bgVariant.DARK && disabled
  });
  var variantBoxClasses = classnames({
    'border': !hasError,
    'border-828b91': (variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE) && !hasError && !disabled,
    'bg-dfe3e6 border-dfe3e6': (variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE) && !hasError && disabled,
    'bg-ffffff': (variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE) && !disabled,
    'border-2': hasError,
    'border-eb0047': (variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE) && hasError,
    'bg-005e3f': variant === bgVariant.DARK,
    'border-98e692': variant === bgVariant.DARK && !hasError && !disabled,
    'bg-586167 border-586167': variant === bgVariant.DARK && !hasError && disabled,
    'border-f580a3': variant === bgVariant.DARK && hasError
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "checkbox-btn frame absolute \n          block w-24 h-24\n          rounded-4\n          ".concat(className, "\n          ").concat(variantBoxClasses, "\n          ")
  }), /*#__PURE__*/React.createElement("span", {
    className: "checkmark absolute pointer-events-none ".concat(checkMarkClassName, " ")
  }, /*#__PURE__*/React.createElement(Checkmark, {
    fill: checkmarkFill,
    className: "w-16 h-16"
  })));
};
CheckboxIndicator.propTypes = {
  variant: PropTypes.oneOf(Object.values(bgVariant)),
  hasError: PropTypes.bool,
  className: PropTypes.string,
  checkMarkClassName: PropTypes.string,
  disabled: PropTypes.bool
};
CheckboxIndicator.defaultProps = {
  variant: bgVariant.LIGHT,
  className: '',
  checkMarkClassName: ''
};
var CheckboxIndicator$1 = CheckboxIndicator;

var baseCheckboxPropTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.node,
  hint: PropTypes.string,
  icon: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputProps: PropTypes.shape({
    // & ...rest of input attributes
    checked: PropTypes.bool,
    required: PropTypes.bool
  }),
  initiallyChecked: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onChange: PropTypes.func,
  testId: PropTypes.string,
  "abstract": PropTypes.string
};
var Checkbox = function Checkbox(_ref) {
  var ariaDescribedby = _ref.ariaDescribedby,
    className = _ref.className,
    dir = _ref.dir,
    disabled = _ref.disabled,
    errorMessage = _ref.errorMessage,
    hasGroupError = _ref.hasGroupError,
    globalErrorMessageId = _ref.globalErrorMessageId,
    hint = _ref.hint,
    id = _ref.id,
    initiallyChecked = _ref.initiallyChecked,
    inputProps = _ref.inputProps,
    label = _ref.label,
    name = _ref.name,
    onChange = _ref.onChange,
    popover = _ref.popover,
    testId = _ref.testId,
    values = _ref.values,
    variant = _ref.variant,
    isEasyLanguagePage = _ref.isEasyLanguagePage;
  var _useState = useState(typeof (inputProps === null || inputProps === void 0 ? void 0 : inputProps.checked) === 'boolean'),
    _useState2 = _slicedToArray(_useState, 1),
    isControlled = _useState2[0]; // allow checkbox to be controlled by parent component
  var _useState3 = useState(initiallyChecked),
    _useState4 = _slicedToArray(_useState3, 2),
    isChecked = _useState4[0],
    setIsChecked = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isMultiLine = _useState6[0],
    setIsMultiLine = _useState6[1];
  var errorRef = useRef(null);
  var _useState7 = useState(function () {
      return id || createRandomID('checkbox');
    }),
    _useState8 = _slicedToArray(_useState7, 1),
    checkboxId = _useState8[0];
  var _useState9 = useState(function () {
      return id ? "".concat(id, "-error") : createRandomID('error');
    }),
    _useState10 = _slicedToArray(_useState9, 1),
    errorMessageId = _useState10[0];
  var hasError = !!errorMessage || hasGroupError;
  var checkboxLabel = 'string' === typeof label ? "".concat(label).concat(inputProps !== null && inputProps !== void 0 && inputProps.required ? '*' : '') : label;
  var checkboxLabelIsString = 'string' === typeof label;
  var ariaDescribedbyIds = useMemo(function () {
    switch (true) {
      case !!hasGroupError && !!errorMessage && !!ariaDescribedby:
        return "".concat(ariaDescribedby, " ").concat(errorMessageId, " ").concat(globalErrorMessageId);
      case !!errorMessage && !!ariaDescribedby:
        return "".concat(ariaDescribedby, " ").concat(errorMessageId);
      case !!hasGroupError && !!ariaDescribedby:
        return "".concat(ariaDescribedby, " ").concat(globalErrorMessageId);
      case !!hasGroupError && !!errorMessage:
        return "".concat(errorMessageId, " ").concat(globalErrorMessageId);
      case !!hasGroupError:
        return globalErrorMessageId;
      case !!errorMessage:
        return errorMessageId;
      default:
        return ariaDescribedby;
    }
  }, [errorMessage, errorMessageId, ariaDescribedby, hasGroupError, globalErrorMessageId]);
  var variantOuterClasses = classnames({
    'checkbox-gray-on-white': variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE,
    'checkbox-white-on-green': variant !== bgVariant.LIGHT && variant !== bgVariant.STRUCTURE
  });
  var labelClasses = classnames({
    'text-293033': variant === bgVariant.STRUCTURE && !disabled || variant === bgVariant.LIGHT && !disabled && isEasyLanguagePage || variant === bgVariant.LIGHT && !disabled && !isEasyLanguagePage,
    'text-afb6bc': variant === bgVariant.LIGHT && disabled,
    'text-98a1a6': (variant === bgVariant.STRUCTURE || variant === bgVariant.DARK) && disabled,
    'text-ffffff': variant === bgVariant.DARK && !disabled
  });
  var errorMessageClasses = classnames({
    'text-eb0047': variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE,
    'text-ffffff': variant !== bgVariant.LIGHT && variant !== bgVariant.STRUCTURE,
    'fill-f580a3': variant === bgVariant.DARK && !disabled
  });
  var onInputChange = function onInputChange(e) {
    if (!isControlled) setIsChecked(e.target.checked);
    onChange(e);
  };
  useEffect(function () {
    setIsChecked(initiallyChecked);
  }, [initiallyChecked]);
  useEffect(function () {
    var element = errorRef.current;
    if (element) {
      var elementHeight = element.offsetHeight;
      var lineHeight = parseFloat(getComputedStyle(element).lineHeight);
      var numberOfLines = Math.round(elementHeight / lineHeight);
      setIsMultiLine(numberOfLines > 1);
    }
  }, [errorMessage]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(variantOuterClasses, " -m-4 relative flex flex-col ").concat(className),
    "data-cy": testId
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: name,
    value: values.unchecked,
    checked: (isControlled ? !inputProps.checked : !isChecked) || false,
    disabled: (isControlled ? inputProps.checked : isChecked) || false,
    readOnly: true
  }), /*#__PURE__*/React.createElement("input", _extends$1({
    "aria-describedby": ariaDescribedbyIds,
    id: checkboxId,
    type: "checkbox",
    className: "".concat(hasError ? 'error' : '', " sr-only"),
    name: name,
    value: values.checked,
    checked: (isControlled ? inputProps.checked : isChecked) || false,
    disabled: disabled,
    onChange: onInputChange
  }, inputProps)), /*#__PURE__*/React.createElement("label", {
    className: "".concat(disabled ? '' : 'cursor-pointer', " p-4"),
    htmlFor: checkboxId
  }, /*#__PURE__*/React.createElement(CheckboxIndicator$1, {
    disabled: disabled,
    hasError: hasError,
    variant: variant,
    className: "".concat(dir === 'rtl' ? 'right-4 ' : 'left-4', " top-4"),
    checkMarkClassName: "".concat(dir === 'rtl' ? 'right-8 ' : 'left-8', " top-8")
  }), checkboxLabelIsString ? /*#__PURE__*/React.createElement("span", {
    className: "select-none flex items-center \n                ".concat(dir === 'rtl' ? 'mr-32 ' : 'ml-32', "\n                ").concat(isEasyLanguagePage ? 'leading-32' : 'leading-24', "\n                ").concat(labelClasses),
    dangerouslySetInnerHTML: {
      __html: checkboxLabel
    }
  }) : /*#__PURE__*/React.createElement("span", {
    className: "select-none flex items-center \n                ".concat(dir === 'rtl' ? 'mr-32 ' : 'ml-32', " \n                ").concat(isEasyLanguagePage ? 'leading-32' : 'leading-24', "\n                ").concat(labelClasses, "\n              ")
  }, checkboxLabel)), popover && /*#__PURE__*/React.createElement("div", {
    className: "h-24 flex items-center"
  }, popover)), hint && /*#__PURE__*/React.createElement("span", {
    className: "font-regular text-586167 \n            ".concat(dir === 'rtl' ? 'pr-36' : 'pl-36', " \n            ").concat(isEasyLanguagePage ? 'text-14 leading-26' : 'text-12 leading-18', "\n            ").concat(labelClasses, "\n          ")
  }, hint), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "".concat(isMultiLine ? "items-start" : "items-center", " flex mt-8 ml-4")
  }, /*#__PURE__*/React.createElement(AlertCircleFilled, {
    className: "\n              min-w-[16px] w-16 h-16 fill-current transition-opacity duration-350 ease-in-out\n              ".concat(dir === 'rtl' ? 'left-48 mr-4' : 'right-48', "\n              ").concat(errorMessageClasses, "\n              ").concat(errorMessage && !disabled ? 'opacity-100' : 'opacity-0', "\n              ").concat(isEasyLanguagePage && isMultiLine ? 'mt-4' : '', "\n            ")
  }), /*#__PURE__*/React.createElement("span", {
    id: errorMessageId,
    ref: errorRef,
    className: "\n              ".concat(dir === 'rtl' ? 'pr-8' : 'pl-8', " \n              ").concat(isEasyLanguagePage ? 'text-14 leading-26' : 'text-12 leading-18', "\n              ").concat(errorMessageClasses, "\n            "),
    "aria-live": "assertive",
    dangerouslySetInnerHTML: typeof errorMessage === 'string' ? {
      __html: errorMessage
    } : undefined
  }, typeof errorMessage !== 'string' ? errorMessage : undefined)));
};
Checkbox.propTypes = _objectSpread2$1(_objectSpread2$1({}, baseCheckboxPropTypes), {}, {
  ariaDescribedby: PropTypes.string,
  dir: PropTypes.oneOf(['rtl', 'ltr']),
  hasGroupError: PropTypes.bool,
  globalErrorMessageId: PropTypes.string,
  name: PropTypes.string,
  values: PropTypes.shape({
    checked: PropTypes.string,
    unchecked: PropTypes.string
  }),
  variant: PropTypes.oneOf(Object.values(bgVariant)),
  isEasyLanguagePage: PropTypes.bool
});
Checkbox.defaultProps = {
  className: '',
  dir: 'ltr',
  disabled: false,
  hasGroupError: false,
  initiallyChecked: false,
  label: 'Label nicht gesetzt',
  name: 'Name nicht gesetzt',
  onChange: function onChange() {},
  values: {
    checked: '1',
    unchecked: '0'
  },
  variant: bgVariant.LIGHT,
  isEasyLanguagePage: false
};
var Checkbox$1 = Checkbox;

var ClickableCardCheckbox = function ClickableCardCheckbox(_ref) {
  var ariaDescribedby = _ref.ariaDescribedby,
    className = _ref.className,
    dir = _ref.dir,
    disabled = _ref.disabled,
    errorMessage = _ref.errorMessage,
    hasGroupError = _ref.hasGroupError,
    globalErrorMessageId = _ref.globalErrorMessageId,
    icon = _ref.icon,
    id = _ref.id,
    initiallyChecked = _ref.initiallyChecked,
    inputProps = _ref.inputProps,
    label = _ref.label,
    name = _ref.name,
    onChange = _ref.onChange,
    testId = _ref.testId,
    _abstract = _ref["abstract"],
    values = _ref.values,
    variant = _ref.variant;
  var _useState = useState(initiallyChecked),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  var _useState3 = useState(function () {
      return id || createRandomID('checkbox');
    }),
    _useState4 = _slicedToArray(_useState3, 1),
    checkboxId = _useState4[0];
  var _useState5 = useState(function () {
      return id ? "".concat(id, "-error") : createRandomID('error');
    }),
    _useState6 = _slicedToArray(_useState5, 1),
    errorMessageId = _useState6[0];
  var hasError = !!errorMessage || hasGroupError;
  var ariaDescribedbyIds = useMemo(function () {
    switch (true) {
      case !!hasGroupError && !!errorMessage && !!ariaDescribedby:
        return "".concat(ariaDescribedby, " ").concat(errorMessageId, " ").concat(globalErrorMessageId);
      case !!errorMessage && !!ariaDescribedby:
        return "".concat(ariaDescribedby, " ").concat(errorMessageId);
      case !!hasGroupError && !!ariaDescribedby:
        return "".concat(ariaDescribedby, " ").concat(globalErrorMessageId);
      case !!hasGroupError && !!errorMessage:
        return "".concat(errorMessageId, " ").concat(globalErrorMessageId);
      case !!hasGroupError:
        return globalErrorMessageId;
      case !!errorMessage:
        return errorMessageId;
      default:
        return ariaDescribedby;
    }
  }, [errorMessage, errorMessageId, ariaDescribedby, hasGroupError, globalErrorMessageId]);
  var variantOuterClasses = classnames({
    'checkbox-gray-on-white': variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE,
    'checkbox-white-on-green': variant !== bgVariant.LIGHT && variant !== bgVariant.STRUCTURE
  });
  var onInputChange = function onInputChange(e) {
    setIsChecked(e.target.checked);
    onChange(e);
  };
  useEffect(function () {
    setIsChecked(initiallyChecked);
  }, [initiallyChecked]);
  return /*#__PURE__*/React.createElement("div", {
    className: "clickable-card-checkbox h-full relative flex flex-col ".concat(variantOuterClasses, " ").concat(className),
    "data-cy": testId
  }, /*#__PURE__*/React.createElement("input", _extends$1({
    id: checkboxId,
    type: "checkbox",
    className: "".concat(hasGroupError ? 'error' : '', " sr-only peer"),
    name: name,
    value: values.checked,
    checked: isChecked,
    disabled: disabled,
    onChange: onInputChange,
    "aria-describedby": ariaDescribedbyIds
  }, inputProps)), /*#__PURE__*/React.createElement("label", {
    className: "relative outline\n          flex flex-col flex-wrap flex-1\n          min-h-32 w-full\n          rounded-6\n          text-16 leading-24 p-24 \n          peer-checked:bg-eefaea\n          peer-focus-visible:ring-1 peer-focus-visible:ring-18ab42 peer-focus-visible:ring-offset-4\n          ".concat(icon ? 'items-center' : '', "\n          ").concat(disabled ? 'cursor-not-allowed' : 'cursor-pointer peer-hover:outline-18ab42 peer-hover:outline-2', "\n          ").concat(hasError ? 'shadow-red-primary border border-eb0047 outline-none' : 'outline-c7ccd1 outline-1 peer-checked:outline-18ab42', "\n        "),
    htmlFor: checkboxId
  }, icon && /*#__PURE__*/React.createElement(Icon, {
    className: "fill-current p-12 w-64 h-64 overflow-visible rounded-full ".concat(disabled ? 'text-6d767c' : 'text-005e3f'),
    name: icon
  }), /*#__PURE__*/React.createElement("p", {
    className: "font-semibold ".concat(icon ? ' mt-16' : '', " ").concat(disabled ? 'text-6d767c' : 'text-293033'),
    dangerouslySetInnerHTML: {
      __html: label
    }
  }), _abstract && /*#__PURE__*/React.createElement("p", {
    className: "mt-8 ".concat(disabled ? 'text-6d767c' : 'text-586167')
  }, _abstract), /*#__PURE__*/React.createElement(CheckboxIndicator$1, {
    disabled: disabled,
    hasError: hasError,
    variant: variant,
    className: "".concat(dir === 'rtl' ? 'left-24 ' : 'right-24', " top-24"),
    checkMarkClassName: "".concat(dir === 'rtl' ? 'left-28 ' : 'right-28', "  top-28")
  })));
};
ClickableCardCheckbox.propTypes = _objectSpread2$1(_objectSpread2$1({}, baseCheckboxPropTypes), {}, {
  hasGroupError: PropTypes.bool,
  globalErrorMessageId: PropTypes.string,
  ariaDescribedby: PropTypes.string,
  name: PropTypes.string,
  values: PropTypes.shape({
    checked: PropTypes.string,
    unchecked: PropTypes.string
  }),
  variant: PropTypes.oneOf(Object.values(bgVariant)),
  dir: PropTypes.oneOf(['rtl', 'ltr'])
});
ClickableCardCheckbox.defaultProps = {
  className: '',
  disabled: false,
  initiallyChecked: false,
  label: 'Label nicht gesetzt',
  name: 'Name nicht gesetzt',
  hasGroupError: false,
  onChange: function onChange() {},
  values: {
    checked: '1',
    unchecked: '0'
  },
  variant: bgVariant.LIGHT,
  dir: 'ltr'
};
var ClickableCardCheckbox$1 = ClickableCardCheckbox;

var CheckboxButtonGroup = function CheckboxButtonGroup(_ref) {
  var buttonOuterClasses = _ref.buttonOuterClasses,
    buttonWrapperClassName = _ref.buttonWrapperClassName,
    checkboxButtons = _ref.checkboxButtons,
    checkboxButtonType = _ref.checkboxButtonType,
    className = _ref.className,
    dir = _ref.dir,
    disabled = _ref.disabled,
    errorMessage = _ref.errorMessage,
    errorMessageClassName = _ref.errorMessageClassName,
    groupLabel = _ref.groupLabel,
    groupLabelClassName = _ref.groupLabelClassName,
    groupName = _ref.groupName,
    id = _ref.id,
    labelVisibility = _ref.labelVisibility,
    onChange = _ref.onChange,
    popover = _ref.popover,
    testId = _ref.testId,
    variant = _ref.variant,
    ariaDescribedby = _ref.ariaDescribedby,
    checkedItems = _ref.checkedItems;
  var _useState = useState(checkedItems),
    _useState2 = _slicedToArray(_useState, 2),
    values = _useState2[0],
    setValues = _useState2[1];
  var _useState3 = useState(function () {
      return id || createRandomID('checkbox');
    }),
    _useState4 = _slicedToArray(_useState3, 1),
    checkboxButtonGroupId = _useState4[0];
  var _useState5 = useState(function () {
      return id ? "".concat(id, "-error-global") : createRandomID('error');
    }),
    _useState6 = _slicedToArray(_useState5, 1),
    globalErrorMessageId = _useState6[0];
  var checkboxGroupLabel = 'string' === typeof groupLabel ? "".concat(groupLabel).concat(checkboxButtons[0].required ? '*' : '') : groupLabel;
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isMultiline = _useState8[0],
    setIsMultiline = _useState8[1];
  var errorRef = useRef(null);
  var groupLabelClasses = classnames({
    'text-40484d': variant === bgVariant.LIGHT,
    'text-293033': variant === bgVariant.STRUCTURE,
    'text-ffffff': variant === bgVariant.DARK,
    'relative': labelVisibility === labelVisibilityState.SHOW,
    'sr-only': labelVisibility === labelVisibilityState.HIDE
  });
  var errorMsgClasses = classnames({
    'text-eb0047': variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE,
    'text-ffffff': variant === bgVariant.DARK
  });
  var iconErrorClass = classnames({
    'text-eb0047': variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE,
    'text-f580a3': variant === bgVariant.DARK
  });
  var handleValuesChange = function handleValuesChange(_ref2) {
    var target = _ref2.target;
    var newValues = _toConsumableArray(values);
    if (newValues.includes(target.value)) {
      newValues = newValues.filter(function (item) {
        return item !== target.value;
      });
    } else {
      newValues.push(target.value);
    }
    setValues(newValues);
    onChange(newValues);
  };
  var elementProps = {
    ariaDescribedby: ariaDescribedby,
    buttonWrapperClassName: buttonWrapperClassName,
    dir: dir,
    disabled: disabled,
    globalErrorMessageId: globalErrorMessageId,
    groupName: groupName,
    onChange: handleValuesChange,
    variant: variant
  };
  useEffect(function () {
    setValues(checkedItems);
  }, [checkedItems]);
  useEffect(function () {
    var element = errorRef.current;
    if (element) {
      var elementHeight = element.offsetHeight;
      var lineHeight = parseFloat(getComputedStyle(element).lineHeight);
      var numberOfLines = Math.round(elementHeight / lineHeight);
      setIsMultiline(numberOfLines > 1);
    }
  }, [errorMessage]);
  return /*#__PURE__*/React.createElement("fieldset", {
    className: className,
    "data-cy": testId
  }, groupLabel && /*#__PURE__*/React.createElement("div", {
    className: "\n            flex text-16 leading-24\n            ".concat(groupLabelClasses, "\n            ").concat(groupLabelClassName, "\n      ")
  }, /*#__PURE__*/React.createElement("legend", null, checkboxGroupLabel), popover), /*#__PURE__*/React.createElement("ul", {
    className: buttonOuterClasses
  }, checkboxButtons.map(function (checkboxButton, index) {
    var checkboxKey = "".concat(index, "_").concat(checkboxButton.value);
    if (checkboxButtonType === CheckboxButtonType.DEFAULT) {
      return /*#__PURE__*/React.createElement("li", {
        className: buttonWrapperClassName,
        key: index
      }, /*#__PURE__*/React.createElement(Checkbox$1, _extends$1({
        id: "".concat(checkboxButtonGroupId, "-").concat(index),
        name: groupName,
        className: index !== 0 ? 'mt-12' : null,
        values: {
          checked: checkboxButton.value,
          unchecked: ''
        },
        initiallyChecked: checkedItems.length ? values.includes(checkboxButton.value) : false,
        hasGroupError: !!errorMessage
      }, elementProps, checkboxButton)));
    } else {
      return /*#__PURE__*/React.createElement("li", {
        key: checkboxKey,
        className: buttonWrapperClassName
      }, /*#__PURE__*/React.createElement(ClickableCardCheckbox$1, _extends$1({
        id: "".concat(checkboxButtonGroupId, "-").concat(index),
        name: groupName,
        values: {
          checked: checkboxButton.value,
          unchecked: ''
        },
        initiallyChecked: checkedItems.length ? values.includes(checkboxButton.value) : false,
        hasGroupError: !!errorMessage
      }, elementProps, checkboxButton)));
    }
  })), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "".concat(isMultiline ? "items-start" : "items-center", " flex mt-8")
  }, /*#__PURE__*/React.createElement(AlertCircleFilled, {
    className: "\n              min-w-[16px] w-16 h-16 fill-current transition-opacity duration-350 ease-in-out\n              ".concat(dir === 'rtl' ? 'left-48' : 'right-48', "\n              ").concat(iconErrorClass, "\n              ").concat(errorMessage && !disabled ? 'opacity-100' : 'opacity-0', "\n            ")
  }), /*#__PURE__*/React.createElement("p", {
    id: globalErrorMessageId,
    ref: errorRef,
    className: "text-12 leading-18 mx-8 ".concat(errorMsgClasses, " ").concat(errorMessageClassName),
    dangerouslySetInnerHTML: typeof errorMessage === 'string' ? {
      __html: errorMessage
    } : undefined
  }, typeof errorMessage !== 'string' ? errorMessage : undefined)));
};
CheckboxButtonGroup.propTypes = {
  buttonOuterClasses: PropTypes.string,
  buttonWrapperClassName: PropTypes.string,
  checkboxButtons: PropTypes.arrayOf(PropTypes.shape(baseCheckboxPropTypes)),
  checkboxButtonType: PropTypes.oneOf([CheckboxButtonType.CARD, CheckboxButtonType.DEFAULT]),
  className: PropTypes.string,
  dir: PropTypes.oneOf(['rtl', 'ltr']),
  disabled: PropTypes.bool,
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  errorMessageClassName: PropTypes.string,
  groupLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  groupLabelClassName: PropTypes.string,
  groupName: PropTypes.string,
  id: PropTypes.string,
  labelVisibility: PropTypes.oneOf(Object.values(labelVisibilityState)),
  onChange: PropTypes.func,
  popover: PropTypes.element,
  testId: PropTypes.string,
  variant: PropTypes.oneOf(Object.values(bgVariant)),
  checkedItems: PropTypes.arrayOf(PropTypes.string)
};
CheckboxButtonGroup.defaultProps = {
  buttonWrapperClassName: '',
  checkboxButtons: [],
  checkboxButtonType: CheckboxButtonType.DEFAULT,
  className: '',
  dir: 'ltr',
  errorMessageClassName: '',
  groupLabelClassName: '',
  onChange: function onChange() {},
  variant: bgVariant.LIGHT,
  checkedItems: []
};
var CheckboxButtonGroup$1 = CheckboxButtonGroup;

var _excluded$e = ["title", "value", "backgroundVariant", "className", "onClick", "disabled", "count", "isActive", "hideCloseButtonWhenInactive", "showCloseButton", "showInfoIcon", "size", "resetText"];
var chipSizeVariant = {
  XSMALL: 'xsmall',
  SMALL: 'small',
  LARGE: 'large'
};
var Chip = function Chip(_ref) {
  var title = _ref.title,
    value = _ref.value,
    backgroundVariant = _ref.backgroundVariant,
    className = _ref.className,
    _onClick = _ref.onClick,
    disabled = _ref.disabled,
    count = _ref.count,
    isActive = _ref.isActive,
    hideCloseButtonWhenInactive = _ref.hideCloseButtonWhenInactive,
    showCloseButton = _ref.showCloseButton,
    showInfoIcon = _ref.showInfoIcon,
    size = _ref.size,
    resetText = _ref.resetText,
    rest = _objectWithoutProperties$1(_ref, _excluded$e);
  var _useState = useState(value || title),
    _useState2 = _slicedToArray(_useState, 1),
    chipValue = _useState2[0];
  var textClasses = classnames({
    'text-004730': !disabled && (backgroundVariant === bgVariant.LIGHT && !isActive || backgroundVariant === bgVariant.DARK && isActive || backgroundVariant === bgVariant.STRUCTURE && !isActive),
    'text-ffffff': !disabled && (backgroundVariant === bgVariant.LIGHT && isActive || backgroundVariant === bgVariant.DARK && !isActive || backgroundVariant === bgVariant.STRUCTURE && isActive),
    'text-828b91': disabled,
    'text-16 leading-24': size === chipSizeVariant.LARGE,
    'text-14 leading-18': size === chipSizeVariant.SMALL,
    'text-12 leading-18': size === chipSizeVariant.XSMALL
  });
  var iconClasses = classnames({
    'text-005e3f': !disabled && backgroundVariant === bgVariant.LIGHT || bgVariant.STRUCTURE || backgroundVariant.DARK && !isActive,
    'text-ffffff': !disabled && (backgroundVariant === bgVariant.LIGHT && isActive || backgroundVariant === bgVariant.DARK && !isActive || backgroundVariant === bgVariant.STRUCTURE && isActive),
    'text-828b91': disabled
  });
  var wrapperClasses = classnames({
    'border-afb6bc bg-ffffff hover:bg-dfe3e6': backgroundVariant === bgVariant.LIGHT && !isActive && !disabled,
    'border-afb6bc bg-ffffff hover:bg-dfe3e6 hover:border-dfe3e6': backgroundVariant === bgVariant.DARK && isActive && !disabled,
    'border-586167 bg-586167': (backgroundVariant !== bgVariant.LIGHT || bgVariant.STRUCTURE && backgroundVariant === bgVariant.DARK) && isActive && disabled,
    'border-dfe3e6 bg-dfe3e6': (backgroundVariant === bgVariant.LIGHT || bgVariant.STRUCTURE && backgroundVariant !== bgVariant.DARK) && isActive && disabled,
    'border-005e3f bg-005e3f hover:bg-004730 hover:border-004730': (backgroundVariant === bgVariant.LIGHT || backgroundVariant === bgVariant.STRUCTURE) && isActive && !disabled,
    'border-afb6bc bg-ffffff': backgroundVariant === bgVariant.LIGHT && disabled && !isActive,
    'border-ffffff bg-005e3f hover:bg-007141': backgroundVariant === bgVariant.DARK && !isActive && !disabled,
    'border-828b91 bg-005e3f': backgroundVariant === bgVariant.DARK && disabled && !isActive,
    'border-afb6bc bg-e8f4f2 hover:bg-dfe3e6 hover:border-98a1a6 focus-visible:border-98a1a6': backgroundVariant === bgVariant.STRUCTURE && !isActive && !disabled,
    'border-98a1a6 bg-e8f4f2': backgroundVariant === bgVariant.STRUCTURE && disabled && !isActive,
    'px-22 py-6 rounded-16': size === chipSizeVariant.SMALL,
    'px-14 py-4 rounded-16': size === chipSizeVariant.XSMALL,
    'px-24 py-8 rounded-32': size === chipSizeVariant.LARGE
  });
  var renderCloseButton = function renderCloseButton() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, (isActive || !hideCloseButtonWhenInactive && !isActive) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, resetText), /*#__PURE__*/React.createElement(CancelCircleFilled, {
      className: "w-12 h-12 fill-current ml-8 transition ease-in-out duration-350 group-enabled:group-hover:scale-120 ".concat(iconClasses)
    })));
  };
  var renderInfoIcon = function renderInfoIcon() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, (isActive || !hideCloseButtonWhenInactive && !isActive) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, resetText), /*#__PURE__*/React.createElement(InfoCircle, {
      className: "w-16 h-16 fill-current ml-8 transition ease-in-out duration-350 group-enabled:group-hover:scale-120 ".concat(iconClasses)
    })));
  };
  return /*#__PURE__*/React.createElement("button", _extends$1({
    className: "inline-flex items-center\n        cursor-pointer group w-auto\n        border-2 \n        focus-visible:outline focus-visible:outline-1 focus-visible:outline-18ab42 focus-visible:outline-offset-4\n        ".concat(wrapperClasses, " ").concat(className, "\n      "),
    onClick: function onClick() {
      return _onClick(chipValue);
    },
    disabled: disabled,
    "aria-checked": isActive,
    role: "switch"
  }, rest), /*#__PURE__*/React.createElement("span", {
    className: "font-buenos-aires-text font-semibold ".concat(textClasses)
  }, title), count != null ? /*#__PURE__*/React.createElement("span", {
    className: "ml-4 font-buenos-aires-text font-semibold text-12 leading-18 ".concat(textClasses)
  }, "(".concat(count, ")")) : /*#__PURE__*/React.createElement(React.Fragment, null, showCloseButton ? renderCloseButton() : showInfoIcon ? renderInfoIcon() : null));
};
Chip.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  count: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  backgroundVariant: PropTypes.oneOf([bgVariant.LIGHT, bgVariant.DARK, bgVariant.STRUCTURE]),
  isActive: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  showInfoIcon: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(chipSizeVariant)),
  resetText: PropTypes.string
};
Chip.defaultProps = {
  title: 'Titel wurde nicht gesetzt',
  backgroundVariant: bgVariant.LIGHT,
  className: '',
  onClick: function onClick(value) {
    console.log(value);
  },
  disabled: false,
  isActive: false,
  showCloseButton: true,
  showInfoIcon: false,
  size: chipSizeVariant.SMALL,
  resetText: 'Tag entfernen'
};
var Chip$1 = Chip;

var MODE$1 = {
  DEFAULT: 'default',
  LOOP: 'loop'
};
var NumberedPaginationShort = function NumberedPaginationShort(_ref) {
  var className = _ref.className,
    count = _ref.count,
    current = _ref.current,
    onChangeCallback = _ref.onChangeCallback,
    variant = _ref.variant,
    staticLabels = _ref.staticLabels,
    mode = _ref.mode,
    dir = _ref.dir;
  var navigateForward = function navigateForward() {
    if (mode === MODE$1.LOOP && current === count) {
      current = 1;
      onChangeCallback(current, 'forward');
    } else if (current < count) {
      onChangeCallback(current + 1, 'forward');
    }
  };
  var navigateBackward = function navigateBackward() {
    if (mode === MODE$1.LOOP && current === 1) {
      current = count;
      onChangeCallback(current, 'forward');
    } else if (current > 1) {
      onChangeCallback(current - 1, 'backward');
    }
  };
  var leftNav = '';
  var rightNav = '';
  var leftArrow = '';
  var rightArrow = '';
  switch (mode) {
    case MODE$1.LOOP:
      leftArrow = dir === 'rtl' ? 'group-hover:-scale-125 group-focus-visible:-scale-125' : 'group-hover:scale-125 group-focus-visible:scale-125';
      rightArrow = dir === 'rtl' ? 'group-hover:-scale-125 group-focus-visible:-scale-125' : 'group-hover:scale-125 group-focus-visible:scale-125';
      if (variant === bgVariant.LIGHT) {
        leftNav = 'text-6d767c hover:text-18ab42 focus-visible:text-18ab42';
        rightNav = 'text-6d767c hover:text-18ab42 focus-visible:text-18ab42';
      } else if (variant === bgVariant.DARK) {
        leftNav = 'text-ffffff hover:text-50eb5d focus-visible:text-50eb5d';
        rightNav = 'text-ffffff hover:text-50eb5d focus-visible:text-50eb5d';
      }
      break;
    case MODE$1.DEFAULT:
    default:
      if (current !== 1) {
        leftArrow = dir === 'rtl' ? 'group-hover:-scale-125 group-focus-visible:-scale-125' : 'group-hover:scale-125 group-focus-visible:scale-125';
      }
      if (current !== count) {
        rightArrow = dir === 'rtl' ? 'group-hover:-scale-125 group-focus-visible:-scale-125' : 'group-hover:scale-125 group-focus-visible:scale-125';
      }
      if (variant === bgVariant.LIGHT) {
        leftNav = classnames({
          'text-afb6bc cursor-default': current === 1,
          'text-6d767c hover:text-18ab42 focus-visible:text-18ab42': current !== 1
        });
        rightNav = classnames({
          'text-afb6bc cursor-default': current === count,
          'text-6d767c hover:text-18ab42 focus-visible:text-18ab42': current !== count
        });
      } else if (variant === bgVariant.DARK) {
        leftNav = classnames({
          'text-c7ccd1 cursor-default': current === 1,
          'text-ffffff hover:text-50eb5d focus-visible:text-50eb5d': current !== 1
        });
        rightNav = classnames({
          'text-c7ccd1 cursor-default': current === count,
          'text-ffffff hover:text-50eb5d focus-visible:text-50eb5d': current !== count
        });
      }
      break;
  }
  var textClasses = classnames({
    'text-6d767c': variant === bgVariant.LIGHT,
    'text-ffffff': variant === bgVariant.DARK
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, count > 0 && current > 0 && /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " flex")
  }, /*#__PURE__*/React.createElement("button", {
    className: "".concat(leftNav, " w-30 h-30 rounded-3 outline-0 focus-visible:shadow-green-outline group"),
    onClick: navigateBackward,
    title: staticLabels.paginationLeftTitle,
    "aria-label": staticLabels.paginationLeftAriaLabel,
    disabled: mode === MODE$1.DEFAULT && current === 1
  }, /*#__PURE__*/React.createElement(ArrowRoundedLeft, {
    className: "".concat(leftArrow, " ").concat(dir === 'rtl' ? '-scale-100' : '', " w-16 h-16 fill-current mx-auto transition-all")
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(textClasses, " ml-10 mr-10 mt-4 font-semibold")
  }, "".concat(current < 10 ? '0' + current.toString() : current, "/").concat(count < 10 ? '0' + count.toString() : count)), /*#__PURE__*/React.createElement("button", {
    className: "".concat(rightNav, " w-30 h-30 rounded-3 outline-0 focus-visible:shadow-green-outline group"),
    onClick: navigateForward,
    title: staticLabels.paginationRightTitle,
    "aria-label": staticLabels.paginationRightAriaLabel,
    disabled: mode === MODE$1.DEFAULT && current === count
  }, /*#__PURE__*/React.createElement(ArrowRoundedRight, {
    className: "".concat(rightArrow, " ").concat(dir === 'rtl' ? '-scale-100' : '', " w-16 h-16 fill-current mx-auto transition-all")
  }))));
};
NumberedPaginationShort.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  onChangeCallback: PropTypes.func,
  count: PropTypes.number,
  current: PropTypes.number,
  staticLabels: PropTypes.shape({
    paginationLeftTitle: PropTypes.string,
    paginationRightTitle: PropTypes.string,
    paginationDotTitle: PropTypes.string,
    paginationLeftAriaLabel: PropTypes.string,
    paginationRightAriaLabel: PropTypes.string
  }),
  dir: PropTypes.oneOf(['rtl', 'ltr']),
  mode: PropTypes.oneOf([MODE$1.DEFAULT, MODE$1.LOOP])
};
NumberedPaginationShort.defaultProps = {
  className: '',
  variant: bgVariant.LIGHT,
  onChangeCallback: function onChangeCallback() {},
  staticLabels: {
    paginationLeftTitle: 'Navigation zur vorherigen Seite',
    paginationRightTitle: 'Navigation zur nächsten Seite',
    paginationDotTitle: 'Navigation zu Seite',
    paginationLeftAriaLabel: 'zurückblättern',
    paginationRightAriaLabel: 'vorblättern'
  },
  dir: 'ltr',
  mode: MODE$1.DEFAULT
};
var NumberedPaginationShort$1 = NumberedPaginationShort;

var MODE = {
  DEFAULT: 'default',
  LOOP: 'loop'
};
var DottedPagination = function DottedPagination(_ref) {
  var className = _ref.className,
    count = _ref.count,
    current = _ref.current,
    onChangeCallback = _ref.onChangeCallback,
    variant = _ref.variant,
    id = _ref.id,
    staticLabels = _ref.staticLabels,
    mode = _ref.mode,
    dir = _ref.dir;
  var navigateForward = function navigateForward() {
    if (mode === MODE.LOOP && current === count) {
      current = 1;
      onChangeCallback(current, 'forward');
    } else if (current < count) {
      onChangeCallback(current + 1, 'forward');
    }
  };
  var navigateBackward = function navigateBackward() {
    if (mode === MODE.LOOP && current === 1) {
      current = count;
      onChangeCallback(current, 'forward');
    } else if (current > 1) {
      onChangeCallback(current - 1, 'backward');
    }
  };
  var navigateToIndex = function navigateToIndex(index) {
    onChangeCallback(index + 1, 'toIndex');
  };
  var leftNav = '';
  var rightNav = '';
  var leftArrow = '';
  var rightArrow = '';
  switch (mode) {
    case MODE.LOOP:
      leftArrow = dir === 'rtl' ? 'group-hover:-scale-125 group-focus-visible:-scale-125' : 'group-hover:scale-125 group-focus-visible:scale-125';
      rightArrow = dir === 'rtl' ? 'group-hover:-scale-125 group-focus-visible:-scale-125' : 'group-hover:scale-125 group-focus-visible:scale-125';
      if (variant === bgVariant.LIGHT) {
        leftNav = 'text-6d767c hover:text-18ab42 focus-visible:text-18ab42';
        rightNav = 'text-6d767c hover:text-18ab42 focus-visible:text-18ab42';
      } else if (variant === bgVariant.DARK) {
        leftNav = 'text-ffffff hover:text-50eb5d focus-visible:text-50eb5d';
        rightNav = 'text-ffffff hover:text-50eb5d focus-visible:text-50eb5d';
      }
      break;
    case MODE.DEFAULT:
    default:
      if (current !== 1) {
        leftArrow = dir === 'rtl' ? 'group-hover:-scale-125 group-focus-visible:-scale-125' : 'group-hover:scale-125 group-focus-visible:scale-125';
      }
      if (current !== count) {
        rightArrow = dir === 'rtl' ? 'group-hover:-scale-125 group-focus-visible:-scale-125' : 'group-hover:scale-125 group-focus-visible:scale-125';
      }
      if (variant === bgVariant.LIGHT) {
        leftNav = classnames({
          'text-afb6bc cursor-default': current === 1,
          'text-6d767c hover:text-18ab42 focus-visible:text-18ab42': current !== 1
        });
        rightNav = classnames({
          'text-afb6bc cursor-default': current === count,
          'text-6d767c hover:text-18ab42 focus-visible:text-18ab42': current !== count
        });
      } else if (variant === bgVariant.DARK) {
        leftNav = classnames({
          'text-c7ccd1 cursor-default': current === 1,
          'text-ffffff hover:text-50eb5d focus-visible:text-50eb5d': current !== 1
        });
        rightNav = classnames({
          'text-c7ccd1 cursor-default': current === count,
          'text-ffffff hover:text-50eb5d focus-visible:text-50eb5d': current !== count
        });
      }
      break;
  }
  var currDotClasses = classnames('w-32 ', {
    'bg-18ab42': variant === bgVariant.LIGHT,
    'bg-50eb5d': variant === bgVariant.DARK
  });
  var dotClasses = classnames('w-12 group-hover:scale-133 group-focus-visible:scale-133', {
    'bg-6d767c group-hover:bg-18ab42 group-focus-visible:bg-18ab42': variant === bgVariant.LIGHT,
    'bg-ffffff group-hover:bg-50eb5d group-focus-visible:bg-50eb5d': variant === bgVariant.DARK
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, count > 0 && current > 0 && /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " flex")
  }, /*#__PURE__*/React.createElement("button", {
    className: "".concat(leftNav, " w-28 h-28 mx-4 rounded-3 outline-0 focus-visible:shadow-green-outline group "),
    onClick: navigateBackward,
    title: staticLabels.paginationLeftTitle,
    "aria-label": staticLabels.paginationLeftAriaLabel,
    disabled: mode === MODE.DEFAULT && current === 1
  }, /*#__PURE__*/React.createElement(ArrowRoundedLeft, {
    className: "".concat(leftArrow, " ").concat(dir === 'rtl' ? '-scale-100' : '', " w-16 h-16 fill-current mx-auto transition-all")
  })), count > 0 ? new Array(count).fill(undefined).map(function (_, index) {
    return /*#__PURE__*/React.createElement("button", {
      key: "".concat(id, "-").concat(index),
      onClick: function onClick() {
        return navigateToIndex(index);
      },
      title: "".concat(staticLabels.paginationDotTitle, " ").concat(index + 1),
      "aria-label": "".concat(staticLabels.paginationDotTitle, " ").concat(index + 1),
      disabled: current === index + 1,
      className: "".concat(index + 1 !== count && dir !== 'rtl' ? 'mr-4' : '', " ").concat(index + 1 !== count && dir === 'rtl' ? 'ml-4' : '', " ").concat(index + 1 === current ? '' : 'focus-visible:shadow-green-outline', " outline-0 rounded-full self-center group p-4 group")
    }, /*#__PURE__*/React.createElement("span", {
      className: "block h-12 transition-all rounded-full ".concat(index + 1 === current ? "".concat(currDotClasses) : "".concat(dotClasses))
    }));
  }) : null, /*#__PURE__*/React.createElement("button", {
    className: "".concat(rightNav, " w-28 h-28 mx-4 rounded-3 outline-0 focus-visible:shadow-green-outline group "),
    onClick: navigateForward,
    title: staticLabels.paginationRightTitle,
    "aria-label": staticLabels.paginationRightAriaLabel,
    disabled: mode === MODE.DEFAULT && current === count
  }, /*#__PURE__*/React.createElement(ArrowRoundedRight, {
    className: "".concat(rightArrow, " ").concat(dir === 'rtl' ? '-scale-100' : '', " w-16 h-16 fill-current mx-auto transition-all")
  }))));
};
DottedPagination.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  onChangeCallback: PropTypes.func,
  count: PropTypes.number,
  current: PropTypes.number,
  id: PropTypes.string,
  staticLabels: PropTypes.shape({
    paginationLeftTitle: PropTypes.string,
    paginationRightTitle: PropTypes.string,
    paginationDotTitle: PropTypes.string,
    paginationLeftAriaLabel: PropTypes.string,
    paginationRightAriaLabel: PropTypes.string
  }),
  dir: PropTypes.oneOf(['rtl', 'ltr']),
  mode: PropTypes.oneOf([MODE.DEFAULT, MODE.LOOP])
};
DottedPagination.defaultProps = {
  className: '',
  variant: bgVariant.LIGHT,
  onChangeCallback: function onChangeCallback() {},
  id: 'dotted-pagination',
  staticLabels: {
    paginationLeftTitle: 'Vorheriger Abschnitt',
    paginationRightTitle: 'Nächster Abschnitt',
    paginationDotTitle: 'Zum Abschnitt',
    paginationLeftAriaLabel: 'Vorheriger Abschnitt',
    paginationRightAriaLabel: 'Nächster Abschnitt'
  },
  dir: 'ltr',
  mode: MODE.DEFAULT
};
var DottedPagination$1 = DottedPagination;

var CombinedPagination = function CombinedPagination(props) {
  var count = props.count;
  if (count > 3) {
    return /*#__PURE__*/React.createElement(NumberedPaginationShort$1, props);
  } else {
    return /*#__PURE__*/React.createElement(DottedPagination$1, props);
  }
};
CombinedPagination.defaultProps = {
  count: 0
};
CombinedPagination.propTypes = {
  count: PropTypes.number
};
var CombinedPagination$1 = CombinedPagination;

var formatDistanceLocale$2 = {
  lessThanXSeconds: {
    standalone: {
      one: 'weniger als 1 Sekunde',
      other: 'weniger als {{count}} Sekunden'
    },
    withPreposition: {
      one: 'weniger als 1 Sekunde',
      other: 'weniger als {{count}} Sekunden'
    }
  },
  xSeconds: {
    standalone: {
      one: '1 Sekunde',
      other: '{{count}} Sekunden'
    },
    withPreposition: {
      one: '1 Sekunde',
      other: '{{count}} Sekunden'
    }
  },
  halfAMinute: {
    standalone: 'halbe Minute',
    withPreposition: 'halben Minute'
  },
  lessThanXMinutes: {
    standalone: {
      one: 'weniger als 1 Minute',
      other: 'weniger als {{count}} Minuten'
    },
    withPreposition: {
      one: 'weniger als 1 Minute',
      other: 'weniger als {{count}} Minuten'
    }
  },
  xMinutes: {
    standalone: {
      one: '1 Minute',
      other: '{{count}} Minuten'
    },
    withPreposition: {
      one: '1 Minute',
      other: '{{count}} Minuten'
    }
  },
  aboutXHours: {
    standalone: {
      one: 'etwa 1 Stunde',
      other: 'etwa {{count}} Stunden'
    },
    withPreposition: {
      one: 'etwa 1 Stunde',
      other: 'etwa {{count}} Stunden'
    }
  },
  xHours: {
    standalone: {
      one: '1 Stunde',
      other: '{{count}} Stunden'
    },
    withPreposition: {
      one: '1 Stunde',
      other: '{{count}} Stunden'
    }
  },
  xDays: {
    standalone: {
      one: '1 Tag',
      other: '{{count}} Tage'
    },
    withPreposition: {
      one: '1 Tag',
      other: '{{count}} Tagen'
    }
  },
  aboutXWeeks: {
    standalone: {
      one: 'etwa 1 Woche',
      other: 'etwa {{count}} Wochen'
    },
    withPreposition: {
      one: 'etwa 1 Woche',
      other: 'etwa {{count}} Wochen'
    }
  },
  xWeeks: {
    standalone: {
      one: '1 Woche',
      other: '{{count}} Wochen'
    },
    withPreposition: {
      one: '1 Woche',
      other: '{{count}} Wochen'
    }
  },
  aboutXMonths: {
    standalone: {
      one: 'etwa 1 Monat',
      other: 'etwa {{count}} Monate'
    },
    withPreposition: {
      one: 'etwa 1 Monat',
      other: 'etwa {{count}} Monaten'
    }
  },
  xMonths: {
    standalone: {
      one: '1 Monat',
      other: '{{count}} Monate'
    },
    withPreposition: {
      one: '1 Monat',
      other: '{{count}} Monaten'
    }
  },
  aboutXYears: {
    standalone: {
      one: 'etwa 1 Jahr',
      other: 'etwa {{count}} Jahre'
    },
    withPreposition: {
      one: 'etwa 1 Jahr',
      other: 'etwa {{count}} Jahren'
    }
  },
  xYears: {
    standalone: {
      one: '1 Jahr',
      other: '{{count}} Jahre'
    },
    withPreposition: {
      one: '1 Jahr',
      other: '{{count}} Jahren'
    }
  },
  overXYears: {
    standalone: {
      one: 'mehr als 1 Jahr',
      other: 'mehr als {{count}} Jahre'
    },
    withPreposition: {
      one: 'mehr als 1 Jahr',
      other: 'mehr als {{count}} Jahren'
    }
  },
  almostXYears: {
    standalone: {
      one: 'fast 1 Jahr',
      other: 'fast {{count}} Jahre'
    },
    withPreposition: {
      one: 'fast 1 Jahr',
      other: 'fast {{count}} Jahren'
    }
  }
};
var formatDistance$4 = function formatDistance(token, count, options) {
  var result;
  var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale$2[token].withPreposition : formatDistanceLocale$2[token].standalone;
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return 'vor ' + result;
    }
  }
  return result;
};
var formatDistance$5 = formatDistance$4;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var dateFormats$2 = {
  full: 'EEEE, do MMMM y',
  // Montag, 7. Januar 2018
  long: 'do MMMM y',
  // 7. Januar 2018
  medium: 'do MMM y',
  // 7. Jan. 2018
  short: 'dd.MM.y' // 07.01.2018
};
var timeFormats$2 = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$2 = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$4 = {
  date: buildFormatLongFn({
    formats: dateFormats$2,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$2,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$2,
    defaultWidth: 'full'
  })
};
var formatLong$5 = formatLong$4;

var formatRelativeLocale$2 = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: 'P'
};
var formatRelative$4 = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale$2[token];
};
var formatRelative$5 = formatRelative$4;

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

var eraValues$2 = {
  narrow: ['v.Chr.', 'n.Chr.'],
  abbreviated: ['v.Chr.', 'n.Chr.'],
  wide: ['vor Christus', 'nach Christus']
};
var quarterValues$2 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1. Quartal', '2. Quartal', '3. Quartal', '4. Quartal']
};

// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues$2 = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
  wide: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
};

// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
var formattingMonthValues = {
  narrow: monthValues$2.narrow,
  abbreviated: ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'],
  wide: monthValues$2.wide
};
var dayValues$2 = {
  narrow: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
  short: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  abbreviated: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
  wide: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
};

// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var dayPeriodValues$2 = {
  narrow: {
    am: 'vm.',
    pm: 'nm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachm.',
    evening: 'Abend',
    night: 'Nacht'
  },
  abbreviated: {
    am: 'vorm.',
    pm: 'nachm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    night: 'Nacht'
  },
  wide: {
    am: 'vormittags',
    pm: 'nachmittags',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    night: 'Nacht'
  }
};
var formattingDayPeriodValues$1 = {
  narrow: {
    am: 'vm.',
    pm: 'nm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachm.',
    evening: 'abends',
    night: 'nachts'
  },
  abbreviated: {
    am: 'vorm.',
    pm: 'nachm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachmittags',
    evening: 'abends',
    night: 'nachts'
  },
  wide: {
    am: 'vormittags',
    pm: 'nachmittags',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachmittags',
    evening: 'abends',
    night: 'nachts'
  }
};
var ordinalNumber$2 = function ordinalNumber(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + '.';
};
var localize$4 = {
  ordinalNumber: ordinalNumber$2,
  era: buildLocalizeFn({
    values: eraValues$2,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$2,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$2,
    formattingValues: formattingMonthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$2,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$2,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: 'wide'
  })
};
var localize$5 = localize$4;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern$2 = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern$2 = /\d+/i;
var matchEraPatterns$2 = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var parseEraPatterns$2 = {
  any: [/^v/i, /^n/i]
};
var matchQuarterPatterns$2 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
};
var parseQuarterPatterns$2 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$2 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var parseMonthPatterns$2 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$2 = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var parseDayPatterns$2 = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns$2 = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var parseDayPeriodPatterns$2 = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i // will never be matched. Night is matched by `pm`
  }
};
var match$4 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$2,
    parsePattern: parseOrdinalNumberPattern$2,
    valueCallback: function valueCallback(value) {
      return parseInt(value);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$2,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$2,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$2,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$2,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$2,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$2,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$2,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$2,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$2,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns$2,
    defaultParseWidth: 'any'
  })
};
var match$5 = match$4;

/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */
var locale$2 = {
  code: 'de',
  formatDistance: formatDistance$5,
  formatLong: formatLong$5,
  formatRelative: formatRelative$5,
  localize: localize$5,
  match: match$5,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4
  }
};
var de = locale$2;

var formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: {
      regular: 'mniej niż sekunda',
      past: 'mniej niż sekundę',
      future: 'mniej niż sekundę'
    },
    twoFour: 'mniej niż {{count}} sekundy',
    other: 'mniej niż {{count}} sekund'
  },
  xSeconds: {
    one: {
      regular: 'sekunda',
      past: 'sekundę',
      future: 'sekundę'
    },
    twoFour: '{{count}} sekundy',
    other: '{{count}} sekund'
  },
  halfAMinute: {
    one: 'pół minuty',
    twoFour: 'pół minuty',
    other: 'pół minuty'
  },
  lessThanXMinutes: {
    one: {
      regular: 'mniej niż minuta',
      past: 'mniej niż minutę',
      future: 'mniej niż minutę'
    },
    twoFour: 'mniej niż {{count}} minuty',
    other: 'mniej niż {{count}} minut'
  },
  xMinutes: {
    one: {
      regular: 'minuta',
      past: 'minutę',
      future: 'minutę'
    },
    twoFour: '{{count}} minuty',
    other: '{{count}} minut'
  },
  aboutXHours: {
    one: {
      regular: 'około godziny',
      past: 'około godziny',
      future: 'około godzinę'
    },
    twoFour: 'około {{count}} godziny',
    other: 'około {{count}} godzin'
  },
  xHours: {
    one: {
      regular: 'godzina',
      past: 'godzinę',
      future: 'godzinę'
    },
    twoFour: '{{count}} godziny',
    other: '{{count}} godzin'
  },
  xDays: {
    one: {
      regular: 'dzień',
      past: 'dzień',
      future: '1 dzień'
    },
    twoFour: '{{count}} dni',
    other: '{{count}} dni'
  },
  aboutXWeeks: {
    one: 'około tygodnia',
    twoFour: 'około {{count}} tygodni',
    other: 'około {{count}} tygodni'
  },
  xWeeks: {
    one: 'tydzień',
    twoFour: '{{count}} tygodnie',
    other: '{{count}} tygodni'
  },
  aboutXMonths: {
    one: 'około miesiąc',
    twoFour: 'około {{count}} miesiące',
    other: 'około {{count}} miesięcy'
  },
  xMonths: {
    one: 'miesiąc',
    twoFour: '{{count}} miesiące',
    other: '{{count}} miesięcy'
  },
  aboutXYears: {
    one: 'około rok',
    twoFour: 'około {{count}} lata',
    other: 'około {{count}} lat'
  },
  xYears: {
    one: 'rok',
    twoFour: '{{count}} lata',
    other: '{{count}} lat'
  },
  overXYears: {
    one: 'ponad rok',
    twoFour: 'ponad {{count}} lata',
    other: 'ponad {{count}} lat'
  },
  almostXYears: {
    one: 'prawie rok',
    twoFour: 'prawie {{count}} lata',
    other: 'prawie {{count}} lat'
  }
};
function declensionGroup(scheme, count) {
  if (count === 1) {
    return scheme.one;
  }
  var rem100 = count % 100;

  // ends with 11-20
  if (rem100 <= 20 && rem100 > 10) {
    return scheme.other;
  }
  var rem10 = rem100 % 10;

  // ends with 2, 3, 4
  if (rem10 >= 2 && rem10 <= 4) {
    return scheme.twoFour;
  }
  return scheme.other;
}
function declension(scheme, count, time) {
  var group = declensionGroup(scheme, count);
  var finalText = typeof group === 'string' ? group : group[time];
  return finalText.replace('{{count}}', String(count));
}
var formatDistance$2 = function formatDistance(token, count, options) {
  var scheme = formatDistanceLocale$1[token];
  if (!(options !== null && options !== void 0 && options.addSuffix)) {
    return declension(scheme, count, 'regular');
  }
  if (options.comparison && options.comparison > 0) {
    return 'za ' + declension(scheme, count, 'future');
  } else {
    return declension(scheme, count, 'past') + ' temu';
  }
};
var formatDistance$3 = formatDistance$2;

var dateFormats$1 = {
  full: 'EEEE, do MMMM y',
  long: 'do MMMM y',
  medium: 'do MMM y',
  short: 'dd.MM.y'
};
var timeFormats$1 = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$1 = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: 'full'
  })
};
var formatLong$3 = formatLong$2;

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
  requiredArgs(2, arguments);
  var dateLeftStartOfWeek = startOfUTCWeek(dirtyDateLeft, options);
  var dateRightStartOfWeek = startOfUTCWeek(dirtyDateRight, options);
  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

var adjectivesLastWeek = {
  masculine: 'ostatni',
  feminine: 'ostatnia'
};
var adjectivesThisWeek = {
  masculine: 'ten',
  feminine: 'ta'
};
var adjectivesNextWeek = {
  masculine: 'następny',
  feminine: 'następna'
};
var dayGrammaticalGender = {
  0: 'feminine',
  1: 'masculine',
  2: 'masculine',
  3: 'feminine',
  4: 'masculine',
  5: 'masculine',
  6: 'feminine'
};
function dayAndTimeWithAdjective(token, date, baseDate, options) {
  var adjectives;
  if (isSameUTCWeek(date, baseDate, options)) {
    adjectives = adjectivesThisWeek;
  } else if (token === 'lastWeek') {
    adjectives = adjectivesLastWeek;
  } else if (token === 'nextWeek') {
    adjectives = adjectivesNextWeek;
  } else {
    throw new Error("Cannot determine adjectives for token ".concat(token));
  }
  var day = date.getUTCDay();
  var grammaticalGender = dayGrammaticalGender[day];
  var adjective = adjectives[grammaticalGender];
  return "'".concat(adjective, "' eeee 'o' p");
}
var formatRelativeLocale$1 = {
  lastWeek: dayAndTimeWithAdjective,
  yesterday: "'wczoraj o' p",
  today: "'dzisiaj o' p",
  tomorrow: "'jutro o' p",
  nextWeek: dayAndTimeWithAdjective,
  other: 'P'
};
var formatRelative$2 = function formatRelative(token, date, baseDate, options) {
  var format = formatRelativeLocale$1[token];
  if (typeof format === 'function') {
    return format(token, date, baseDate, options);
  }
  return format;
};
var formatRelative$3 = formatRelative$2;

var eraValues$1 = {
  narrow: ['p.n.e.', 'n.e.'],
  abbreviated: ['p.n.e.', 'n.e.'],
  wide: ['przed naszą erą', 'naszej ery']
};
var quarterValues$1 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['I kw.', 'II kw.', 'III kw.', 'IV kw.'],
  wide: ['I kwartał', 'II kwartał', 'III kwartał', 'IV kwartał']
};
var monthValues$1 = {
  narrow: ['S', 'L', 'M', 'K', 'M', 'C', 'L', 'S', 'W', 'P', 'L', 'G'],
  abbreviated: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
  wide: ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień']
};
var monthFormattingValues = {
  narrow: ['s', 'l', 'm', 'k', 'm', 'c', 'l', 's', 'w', 'p', 'l', 'g'],
  abbreviated: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
  wide: ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia']
};
var dayValues$1 = {
  narrow: ['N', 'P', 'W', 'Ś', 'C', 'P', 'S'],
  short: ['nie', 'pon', 'wto', 'śro', 'czw', 'pią', 'sob'],
  abbreviated: ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'],
  wide: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota']
};
var dayFormattingValues = {
  narrow: ['n', 'p', 'w', 'ś', 'c', 'p', 's'],
  short: ['nie', 'pon', 'wto', 'śro', 'czw', 'pią', 'sob'],
  abbreviated: ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'],
  wide: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota']
};
var dayPeriodValues$1 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'półn.',
    noon: 'poł',
    morning: 'rano',
    afternoon: 'popoł.',
    evening: 'wiecz.',
    night: 'noc'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'północ',
    noon: 'południe',
    morning: 'rano',
    afternoon: 'popołudnie',
    evening: 'wieczór',
    night: 'noc'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'północ',
    noon: 'południe',
    morning: 'rano',
    afternoon: 'popołudnie',
    evening: 'wieczór',
    night: 'noc'
  }
};
var dayPeriodFormattingValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'o półn.',
    noon: 'w poł.',
    morning: 'rano',
    afternoon: 'po poł.',
    evening: 'wiecz.',
    night: 'w nocy'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'o północy',
    noon: 'w południe',
    morning: 'rano',
    afternoon: 'po południu',
    evening: 'wieczorem',
    night: 'w nocy'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'o północy',
    noon: 'w południe',
    morning: 'rano',
    afternoon: 'po południu',
    evening: 'wieczorem',
    night: 'w nocy'
  }
};
var ordinalNumber$1 = function ordinalNumber(dirtyNumber, _options) {
  return String(dirtyNumber);
};
var localize$2 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: 'wide',
    formattingValues: monthFormattingValues,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: 'wide',
    formattingValues: dayFormattingValues,
    defaultFormattingWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: 'wide',
    formattingValues: dayPeriodFormattingValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$3 = localize$2;

var matchOrdinalNumberPattern$1 = /^(\d+)?/i;
var parseOrdinalNumberPattern$1 = /\d+/i;
var matchEraPatterns$1 = {
  narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
  abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
  wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
var parseEraPatterns$1 = {
  any: [/^p/i, /^n/i]
};
var matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
  wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
var parseQuarterPatterns$1 = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [/^I kw/i, /^II kw/i, /^III kw/i, /^IV kw/i]
};
var matchMonthPatterns$1 = {
  narrow: /^[slmkcwpg]/i,
  abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
  wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
var parseMonthPatterns$1 = {
  narrow: [/^s/i, /^l/i, /^m/i, /^k/i, /^m/i, /^c/i, /^l/i, /^s/i, /^w/i, /^p/i, /^l/i, /^g/i],
  any: [/^st/i, /^lu/i, /^mar/i, /^k/i, /^maj/i, /^c/i, /^lip/i, /^si/i, /^w/i, /^p/i, /^lis/i, /^g/i]
};
var matchDayPatterns$1 = {
  narrow: /^[npwścs]/i,
  short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
  abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
  wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
var parseDayPatterns$1 = {
  narrow: [/^n/i, /^p/i, /^w/i, /^ś/i, /^c/i, /^p/i, /^s/i],
  abbreviated: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pt/i, /^so/i],
  any: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pi/i, /^so/i]
};
var matchDayPeriodPatterns$1 = {
  narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
  any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
var parseDayPeriodPatterns$1 = {
  narrow: {
    am: /^a$/i,
    pm: /^p$/i,
    midnight: /pó(ł|l)n/i,
    noon: /po(ł|l)/i,
    morning: /rano/i,
    afternoon: /po\s*po(ł|l)/i,
    evening: /wiecz/i,
    night: /noc/i
  },
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /pó(ł|l)n/i,
    noon: /po(ł|l)/i,
    morning: /rano/i,
    afternoon: /po\s*po(ł|l)/i,
    evening: /wiecz/i,
    night: /noc/i
  }
};
var match$2 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: 'any'
  })
};
var match$3 = match$2;

/**
 * @type {Locale}
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
 * @author Just RAG [@justrag]{@link https://github.com/justrag}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
 */
var locale$1 = {
  code: 'pl',
  formatDistance: formatDistance$3,
  formatLong: formatLong$3,
  formatRelative: formatRelative$3,
  localize: localize$3,
  match: match$3,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4
  }
};
var pl = locale$1;

var useKeyboardFocusHelper = function useKeyboardFocusHelper() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isKeyboard = _useState2[0],
    setIsKeyboard = _useState2[1];
  var handleKeyPress = function handleKeyPress() {
    setIsKeyboard(true);
  };
  var handleClick = function handleClick() {
    setIsKeyboard(false);
  };
  useEffect(function () {
    document.addEventListener('keydown', handleKeyPress);
    document.addEventListener('mousedown', handleClick);
    return function () {
      document.removeEventListener('keydown', handleKeyPress);
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);
  return isKeyboard;
};
function useWindowSize() {
  var _useState5 = useState([0, 0]),
    _useState6 = _slicedToArray(_useState5, 2),
    size = _useState6[0],
    setSize = _useState6[1];
  useLayoutEffect(function () {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return function () {
      return window.removeEventListener('resize', updateSize);
    };
  }, []);
  return size;
}

/**
 * @type React.FC<inputPropTypes>
 */
var InputField = /*#__PURE__*/React.forwardRef(function (_ref, inputRef) {
  var label = _ref.label,
    inputProps = _ref.inputProps,
    ariaDescribedby = _ref.ariaDescribedby,
    error = _ref.error,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    _onFocus = _ref.onFocus,
    _onMouseEnter = _ref.onMouseEnter,
    _onMouseLeave = _ref.onMouseLeave,
    onKeyDown = _ref.onKeyDown,
    onKeyUp = _ref.onKeyUp,
    onDeleteButtonClick = _ref.onDeleteButtonClick,
    disabled = _ref.disabled,
    variant = _ref.variant,
    beforeInputSlot = _ref.beforeInputSlot,
    afterInputSlot = _ref.afterInputSlot,
    labelVisibility = _ref.labelVisibility,
    className = _ref.className,
    outerClassName = _ref.outerClassName,
    popover = _ref.popover,
    showErrorOnBlurOnly = _ref.showErrorOnBlurOnly,
    hideErrorMessage = _ref.hideErrorMessage,
    enableDeleteButton = _ref.enableDeleteButton,
    id = _ref.id,
    testId = _ref.testId,
    dir = _ref.dir,
    hasVerticalAlignedElems = _ref.hasVerticalAlignedElems,
    hasTransparentBorder = _ref.hasTransparentBorder,
    hasNoFocusOutline = _ref.hasNoFocusOutline,
    value = _ref.value,
    isEasyLanguagePage = _ref.isEasyLanguagePage;
  var _useState = useState(error),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    focus = _useState4[0],
    setFocus = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    currentInputText = _useState6[0],
    setCurrentInputText = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    onBlurCalled = _useState8[0],
    setOnBlurCalled = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    inputPlaceholder = _useState10[0],
    setInputPlaceholder = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    keyboardFocus = _useState12[0],
    setKeyboardFocus = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isMultiline = _useState14[0],
    setIsMultiline = _useState14[1];
  var errorRef = useRef(null);
  var isKeyboard = useKeyboardFocusHelper();
  var ref = inputRef ? inputRef : useRef(null);
  var _useState15 = useState(id || createRandomID('inputfield')),
    _useState16 = _slicedToArray(_useState15, 1),
    inputId = _useState16[0];
  var _useState17 = useState(id ? "".concat(id, "-error") : createRandomID('error')),
    _useState18 = _slicedToArray(_useState17, 1),
    errorMessageId = _useState18[0];
  var ariaDescribedbyIds = useMemo(function () {
    switch (true) {
      case !!errorMessage && !!ariaDescribedby && !hideErrorMessage:
        return "".concat(ariaDescribedby, " ").concat(errorMessageId);
      case !!errorMessage && !hideErrorMessage:
        return errorMessageId;
      default:
        return ariaDescribedby;
    }
  }, [errorMessage, errorMessageId, ariaDescribedby]);
  var inputFieldWrapperClasses = '';
  var inputFieldClasses = '';
  var outerClasses = '';
  var labelClasses = '';
  var errorClasses = '';
  var errorFill = '';
  var inputPadding;
  if (dir === 'rtl') {
    inputPadding = "".concat(beforeInputSlot ? '' : 'pr-16', " ").concat(afterInputSlot ? '' : 'pl-16');
  } else {
    inputPadding = "".concat(beforeInputSlot ? '' : 'pl-16', " ").concat(afterInputSlot ? '' : 'pr-16');
  }
  if (variant === bgVariant.LIGHT) {
    inputFieldClasses = "placeholder-6d767c ".concat(disabled ? 'text-6d767c' : 'text-293033', " ");
    if (disabled) {
      outerClasses = 'border-6d767c bg-dfe3e6';
    } else if (errorMessage) {
      outerClasses = "bg-ffffff\n        ".concat(!hasVerticalAlignedElems ? 'shadow-red-primary border border-eb0047' : 'shadow-blackTransparent border border-transparent p-12');
      inputFieldWrapperClasses = "".concat(hasVerticalAlignedElems ? 'border border-eb0047 shadow-red-primary' : '');
    } else if (focus) {
      outerClasses = "\n          border bg-ffffff\n          ".concat(!hasVerticalAlignedElems ? 'shadow-green-primary border-18ab42' : 'shadow-blackTransparent border-transparent p-12', "\n        ");
      inputFieldWrapperClasses = "".concat(hasVerticalAlignedElems ? 'border border-18ab42 shadow-green-primary' : '');
    } else {
      outerClasses = "\n          border bg-ffffff\n          ".concat(!hasVerticalAlignedElems && !hasTransparentBorder && 'border-6d767c border hover:shadow-green-primary hover:border-18ab42', "\n          ").concat(hasVerticalAlignedElems && !hasTransparentBorder && 'border-transparent shadow-blackTransparent p-12', "\n          ").concat(!hasVerticalAlignedElems && hasTransparentBorder && 'border-transparent border hover:shadow-green-primary hover:border-18ab42', "\n        ");
      inputFieldWrapperClasses = "".concat(hasVerticalAlignedElems ? 'border border-transparent hover:shadow-green-primary hover:border-18ab42' : '');
    }
    outerClasses = "".concat(outerClasses, " input-primary transition duration-350 ease-in-out");
    labelClasses = "".concat(labelVisibility === labelVisibilityState.SHOW || currentInputText || focus ? 'text-6d767c' : 'text-transparent', " transition-colors duration-350 ease-in-out");
    errorClasses = 'text-eb0047';
    errorFill = '#eb0047';
  } else {
    inputFieldClasses = "".concat(disabled ? 'text-98a1a6 placeholder-98a1a6' : 'placeholder-98e692 text-ffffff', " ");
    if (disabled) {
      outerClasses = 'border-586167 border bg-586167';
    } else if (errorMessage) {
      outerClasses = 'shadow-red-secondary border border-f580a3';
    } else if (focus) {
      outerClasses = 'shadow-green-secondary border-50eb5d border py-4';
    } else {
      outerClasses = 'border-98e692 border hover:shadow-green-secondary hover:border-50eb5d';
    }
    outerClasses = "".concat(outerClasses, " input-secondary transition duration-350 ease-in-out bg-005e3f");
    labelClasses = "".concat(labelVisibility === labelVisibilityState.SHOW || currentInputText || focus ? 'text-ffffff' : 'text-transparent', " transition-colors duration-350 ease-in-out");
    errorClasses = 'text-ffffff';
    errorFill = '#f580a3';
  }
  var handleInputChange = function handleInputChange(e) {
    setOnBlurCalled(false);
    setCurrentInputText(e.target.value);
    onChange(e);
  };
  var handleInputBlur = function handleInputBlur(e) {
    setOnBlurCalled(true);
    setErrorMessage(error);
    onBlur(e);
    setFocus(false);
    setKeyboardFocus(false);
  };
  var handleDeleteButtonClick = function handleDeleteButtonClick(e) {
    setCurrentInputText('');
    onChange({
      target: {
        value: ''
      }
    }); // simulate change event on input
    onDeleteButtonClick(e);
    if (ref !== null && ref !== void 0 && ref.current) {
      ref.current.value = '';
      ref.current.focus();
    }
  };
  useEffect(function () {
    if (showErrorOnBlurOnly && !onBlurCalled) {
      return;
    }
    setErrorMessage(error);
  }, [error, onBlurCalled, showErrorOnBlurOnly]);
  useEffect(function () {
    if (labelVisibility === labelVisibilityState.FLOATING) setInputPlaceholder(label);else setInputPlaceholder(inputProps === null || inputProps === void 0 ? void 0 : inputProps.placeholder);
  }, [inputProps, label, labelVisibility]);

  // prefill input field
  useEffect(function () {
    setCurrentInputText(value ? value : (inputProps === null || inputProps === void 0 ? void 0 : inputProps.value) || '');
  }, [inputProps, value]);
  useEffect(function () {
    var element = errorRef.current;
    if (element) {
      var elementHeight = element.offsetHeight;
      var lineHeight = parseFloat(getComputedStyle(element).lineHeight);
      var numberOfLines = Math.round(elementHeight / lineHeight);
      setIsMultiline(numberOfLines > 1);
    }
  }, [errorMessage]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className)
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: inputId,
    className: "block\n            ".concat(isEasyLanguagePage ? 'mb-8 leading-26 text-14' : 'mb-4 leading-18 text-12', "\n            ").concat(labelClasses, " ").concat(labelVisibility === labelVisibilityState.HIDE ? 'sr-only' : '', "\n          ")
  }, "".concat(label).concat(inputProps.required ? '*' : '')), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-1 p-4 -m-4 ".concat(keyboardFocus && !hasNoFocusOutline ? 'shadow-green-outline rounded-4' : '')
  }, /*#__PURE__*/React.createElement("div", {
    role: "none",
    className: "\n                ".concat(outerClassName, " ").concat(outerClasses, "\n                ").concat(disabled ? 'cursor-default' : 'cursor-text', "\n                flex rounded-4\n                ").concat(hasVerticalAlignedElems ? 'flex-col h-auto 760:h-72 760:flex-row 760:items-center 760:justify-between' : 'items-center h-48', "\n              ")
  }, !hasVerticalAlignedElems ? /*#__PURE__*/React.createElement(React.Fragment, null, beforeInputSlot, /*#__PURE__*/React.createElement("input", _extends$1({
    ref: ref,
    id: inputId,
    "data-cy": testId,
    className: "\n                      ".concat(inputFieldClasses, "\n                      ").concat(inputPadding, "\n                      w-full border-none outline-0 leading-24 appearance-none bg-transparent py-10 my-2 grow\n                    "),
    "aria-describedby": ariaDescribedbyIds
  }, inputProps, {
    value: currentInputText,
    onBlur: handleInputBlur,
    onChange: handleInputChange,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    disabled: disabled,
    onFocus: function onFocus(event) {
      setFocus(true);
      _onFocus(event);
      if (isKeyboard) {
        setKeyboardFocus(true);
      }
    },
    onMouseEnter: function onMouseEnter(event) {
      _onMouseEnter(event);
    },
    onMouseLeave: function onMouseLeave(event) {
      _onMouseLeave(event);
    },
    placeholder: inputPlaceholder
  })), enableDeleteButton && currentInputText.length > 0 && /*#__PURE__*/React.createElement("button", {
    "aria-label": "Eingabe l\xF6schen",
    onClick: handleDeleteButtonClick,
    className: "outline-none focus-visible:rounded-full focus-visible:ring-1 focus-visible:ring-18ab42 focus-visible:ring-offset-4 focus-visible:ring-offset-ffffff"
  }, /*#__PURE__*/React.createElement(Close, {
    className: "\n                          fill-current w-16 h-16 transition-transform duration-300 hover:scale-125 \n                          ".concat(variant === bgVariant.DARK ? 'text-ffffff' : 'text-6D767C', "\n                        ")
  })), afterInputSlot) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center px-16 w-full ".concat(hasVerticalAlignedElems ? 'rounded-4 ease-in-out duration-350' : '', " ").concat(inputFieldWrapperClasses)
  }, beforeInputSlot, /*#__PURE__*/React.createElement("input", _extends$1({
    ref: ref,
    id: inputId,
    "data-cy": testId,
    className: "\n                      ".concat(inputFieldClasses, "\n                      ").concat(inputPadding, "\n                      w-full border-none outline-0 leading-24 appearance-none bg-transparent py-10 my-2 grow\n                    "),
    "aria-describedby": ariaDescribedbyIds
  }, inputProps, {
    onBlur: handleInputBlur,
    onChange: handleInputChange,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    disabled: disabled,
    onFocus: function onFocus(event) {
      setFocus(true);
      _onFocus(event);
      if (isKeyboard) {
        setKeyboardFocus(true);
      }
    },
    placeholder: inputPlaceholder
  })), enableDeleteButton && currentInputText.length > 0 && /*#__PURE__*/React.createElement("button", {
    "aria-label": "Eingabe l\xF6schen",
    onClick: handleDeleteButtonClick,
    className: "outline-none focus-visible:rounded-full focus-visible:ring-1 focus-visible:ring-18ab42 focus-visible:ring-offset-4 focus-visible:ring-offset-ffffff"
  }, /*#__PURE__*/React.createElement(Close, {
    className: "\n                            fill-current w-16 h-16\n                            ".concat(variant === bgVariant.DARK ? 'text-ffffff' : 'text-293033', "\n                          ")
  })), /*#__PURE__*/React.createElement(InfoCircleFilled, {
    className: "\n                        shrink-0\n                        ".concat(errorMessage && !disabled ? 'opacity-100 w-16 h-16 ml-8' : 'opacity-0 w-0 ml-0', "\n                        transition-opacity duration-350 ease-in-out\n                      "),
    fill: errorFill
  })), afterInputSlot))), popover), !hideErrorMessage && errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "".concat(isMultiline ? 'items-start' : 'items-center', " flex mt-8")
  }, /*#__PURE__*/React.createElement(AlertCircleFilled, {
    className: "\n                        shrink-0\n                        ".concat(errorMessage && !disabled ? 'opacity-100 w-16 h-16' : 'opacity-0 w-0 ml-0', "\n                        transition-opacity duration-350 ease-in-out\n                      "),
    fill: errorFill
  }), /*#__PURE__*/React.createElement("span", {
    id: errorMessageId,
    ref: errorRef,
    "aria-live": "assertive",
    className: "\n              block transition-opacity duration-350 ease-in-out text-12\n              ".concat(errorMessage && !disabled ? 'opacity-100 mx-8' : 'opacity-0 mt-0', "\n              ").concat(isEasyLanguagePage ? 'leading-26 text-14' : 'leading-18 text-12', "\n              ").concat(errorClasses, "\n            "),
    dangerouslySetInnerHTML: {
      __html: errorMessage
    }
  })));
});
var inputPropTypes = {
  label: PropTypes.string,
  inputProps: PropTypes.shape({
    type: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    required: PropTypes.bool
  }),
  ariaDescribedby: PropTypes.string,
  error: PropTypes.string,
  // holds error message
  onBlur: PropTypes.func,
  // triggers input validation
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  labelVisibility: PropTypes.oneOf(Object.values(labelVisibilityState)),
  variant: PropTypes.oneOf([bgVariant.LIGHT, bgVariant.DARK]),
  className: PropTypes.string,
  outerClassName: PropTypes.string,
  showErrorOnBlurOnly: PropTypes.bool,
  // if an error occured/got removed change error state only on blur
  hideErrorMessage: PropTypes.bool,
  id: PropTypes.string,
  testId: PropTypes.string,
  enableDeleteButton: PropTypes.bool,
  onDeleteButtonClick: PropTypes.func,
  afterInputSlot: PropTypes.node,
  beforeInputSlot: PropTypes.node,
  popover: PropTypes.node,
  dir: PropTypes.oneOf(['rtl', 'ltr']),
  hasVerticalAlignedElems: PropTypes.bool,
  hasTransparentBorder: PropTypes.bool,
  hasNoFocusOutline: PropTypes.bool,
  isEasyLanguagePage: PropTypes.bool
};
InputField.propTypes = inputPropTypes;
InputField.defaultProps = {
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onKeyDown: function onKeyDown() {},
  onKeyUp: function onKeyUp() {},
  onDeleteButtonClick: function onDeleteButtonClick() {},
  label: 'Label nicht gesetzt',
  inputProps: {
    name: 'Name nicht gesetzt',
    type: 'text'
  },
  labelVisibility: labelVisibilityState.FLOATING,
  variant: bgVariant.LIGHT,
  className: '',
  outerClassName: '',
  showErrorOnChange: false,
  enableDeleteButton: false,
  dir: 'ltr',
  hasVerticalAlignedElems: false,
  hasTransparentBorder: false,
  hasNoFocusOutline: false,
  isEasyLanguagePage: false
};
var InputField$1 = InputField;

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters$2 = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var formatters$3 = formatters$2;

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return formatters$3.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return formatters$3.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return formatters$3.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return formatters$3.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return formatters$3.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return formatters$3.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return formatters$3.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return formatters$3.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var formatters$1 = formatters;

var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = longFormatters;

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
var formatDistance$1 = formatDistance;

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
var formatRelative$1 = formatRelative;

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale;

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getFullYear();
}

var DatepickerHeader = function DatepickerHeader(_ref) {
  var date = _ref.date,
    locale = _ref.locale,
    decreaseMonth = _ref.decreaseMonth,
    increaseMonth = _ref.increaseMonth,
    prevMonthButtonDisabled = _ref.prevMonthButtonDisabled,
    nextMonthButtonDisabled = _ref.nextMonthButtonDisabled,
    variant = _ref.variant,
    changeYear = _ref.changeYear,
    datepickerHeaderOpt = _ref.datepickerHeaderOpt;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    currentMonth = _useState2[0],
    setCurrentMonth = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    currentYear = _useState4[0],
    setCurrentYear = _useState4[1];
  var datepickerHeaderClasses = classnames({
    'border-828b91': variant === bgVariant.LIGHT,
    'border-afb6bc': variant === bgVariant.DARK
  });
  var buttonClasses = classnames('p-6 border-2 border-transparent rounded-4 focus-visible:outline focus-visible:outline-18ab42', {
    'hover:border-afb6bc': variant === bgVariant.LIGHT,
    'hover:border-ffffff': variant === bgVariant.DARK
  });
  useEffect(function () {
    if (typeof window !== 'undefined') {
      var _window;
      setCurrentMonth(format(date, 'MMMM yyyy', {
        locale: (_window = window) === null || _window === void 0 ? void 0 : _window.__localeData__[locale]
      }));
    }
    setCurrentYear(getYear(date));
  }, [locale, date]);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center py-8 border-b ".concat(datepickerHeaderClasses)
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: decreaseMonth,
    disabled: prevMonthButtonDisabled,
    className: "".concat(prevMonthButtonDisabled ? 'invisible' : '', " ").concat(buttonClasses)
  }, /*#__PURE__*/React.createElement(ArrowLeft, {
    className: "w-16 h-16 fill-current"
  })), datepickerHeaderOpt && datepickerHeaderOpt.years ? /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-16 leading-24 p-4"
  }, currentMonth.slice(0, -5), /*#__PURE__*/React.createElement("select", {
    value: currentYear,
    onChange: function onChange(e) {
      return changeYear(e.target.value);
    },
    className: "ml-4 bg-field"
  }, datepickerHeaderOpt === null || datepickerHeaderOpt === void 0 ? void 0 : datepickerHeaderOpt.years.map(function (_ref2) {
    var value = _ref2.value,
      label = _ref2.label,
      disabled = _ref2.disabled;
    return /*#__PURE__*/React.createElement("option", _extends$1({
      key: value,
      value: value
    }, disabled && {
      disabled: disabled
    }), label);
  }))) : /*#__PURE__*/React.createElement("p", {
    className: "font-semibold text-16 leading-24"
  }, currentMonth), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: increaseMonth,
    disabled: nextMonthButtonDisabled,
    className: "".concat(nextMonthButtonDisabled ? 'invisible' : '', " ").concat(buttonClasses)
  }, /*#__PURE__*/React.createElement(ArrowRight, {
    className: "w-16 h-16 fill-current"
  })));
};
DatepickerHeader.propTypes = {
  date: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  locale: PropTypes.string,
  decreaseMonth: PropTypes.func,
  increaseMonth: PropTypes.func,
  prevMonthButtonDisabled: PropTypes.bool,
  nextMonthButtonDisabled: PropTypes.bool,
  variant: PropTypes.oneOf(Object.values(bgVariant)),
  changeYear: PropTypes.func,
  datepickerHeaderOpt: PropTypes.object
};
DatepickerHeader.defaultProps = {
  date: Date.now(),
  locale: 'de',
  decreaseMonth: function decreaseMonth() {},
  increaseMonth: function increaseMonth() {},
  variant: bgVariant.LIGHT
};
var DatepickerHeader$1 = DatepickerHeader;

registerLocale('de', de);
registerLocale('pl', pl);
var Datepicker = function Datepicker(props) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedDate = _useState2[0],
    setSelectedDate = _useState2[1];
  var className = props.className,
    variant = props.variant,
    disabled = props.disabled,
    lang = props.lang,
    datePickerOptions = props.datePickerOptions,
    inputFieldOptions = props.inputFieldOptions,
    datepickerHeaderOpt = props.datepickerHeaderOpt;
  var iconClasses = classnames('fill-current', {
    'text-40484d': (variant === bgVariant.LIGHT || typeof variant === 'undefined') && !disabled,
    'text-6d767c': (variant === bgVariant.LIGHT || typeof variant === 'undefined') && disabled,
    'text-ffffff': variant === bgVariant.DARK && !disabled,
    '!fill-98a1a6': variant === bgVariant.DARK && disabled
  });

  // Here is a handy list of properties that get passed to the customInput component:
  // see https://github.com/Hacker0x01/react-datepicker/blob/master/src/index.jsx#L1129

  var insertDelimiter = function insertDelimiter(input, delimiter, at) {
    return input.slice(0, at) + delimiter + input.slice(at);
  };
  return /*#__PURE__*/React.createElement(DatePicker, _extends$1({
    wrapperClassName: className,
    calendarClassName: variant === bgVariant.DARK ? '-dark' : '',
    selected: selectedDate,
    disabled: disabled,
    onChangeRaw: function onChangeRaw(event) {
      var value = event.target.value;
      if (typeof value === 'undefined') {
        return;
      }
      var delimiter = value.includes('/') ? '/' : '.';
      if (value.length > 2 && value.charAt(2) !== delimiter) {
        value = insertDelimiter(value, delimiter, 2);
      }
      if (value.length > 5 && value.charAt(5) !== delimiter) {
        value = insertDelimiter(value, delimiter, 5);
      }
      event.target.value = value;
    },
    onChange: function onChange(date) {
      return setSelectedDate(date);
    },
    locale: lang,
    dateFormat: "dd.MM.yyyy",
    popperPlacement: "bottom-start",
    showPopperArrow: false,
    customInput: /*#__PURE__*/React.createElement(InputField$1, _extends$1({}, inputFieldOptions, {
      variant: variant,
      disabled: disabled,
      afterInputSlot: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "w-8"
      }), /*#__PURE__*/React.createElement(Calendar, {
        className: "w-16 h-16 ".concat(iconClasses)
      }), /*#__PURE__*/React.createElement("span", {
        className: "w-16"
      }))
    })),
    renderDayContents: function renderDayContents(_day, date) {
      return /*#__PURE__*/React.createElement("span", null, date.getDate());
    },
    renderCustomHeader: function renderCustomHeader(props) {
      return /*#__PURE__*/React.createElement(DatepickerHeader$1, _extends$1({}, props, {
        locale: lang,
        variant: variant,
        datepickerHeaderOpt: datepickerHeaderOpt
      }));
    }
  }, datePickerOptions));
};
Datepicker.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(Object.values(bgVariant)),
  disabled: PropTypes.bool,
  lang: PropTypes.string,
  datePickerOptions: PropTypes.object,
  inputFieldOptions: PropTypes.object,
  datepickerHeaderOpt: PropTypes.object
};
Datepicker.defaultProps = {
  className: '',
  variant: bgVariant.LIGHT,
  disabled: false,
  lang: 'de',
  datePickerOptions: {},
  inputFieldOptions: {}
};
var Datepicker$1 = Datepicker;

var _excluded$d = ["url", "children"];

/**
 * @type React.FC<InteractiveElementPropTypes>
 */
var InteractiveElement = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var url = props.url,
    children = props.children,
    rest = _objectWithoutProperties$1(props, _excluded$d);
  if (url) {
    return /*#__PURE__*/React.createElement("a", _extends$1({
      ref: ref,
      href: url
    }, rest), children);
  }
  return /*#__PURE__*/React.createElement("button", _extends$1({
    ref: ref
  }, rest), children);
});
var InteractiveElementPropTypes = {
  url: PropTypes.string,
  children: PropTypes.node
};
InteractiveElement.propTypes = InteractiveElementPropTypes;
var InteractiveElement$1 = InteractiveElement;

var _excluded$c = ["backgroundVariant", "buttonSize", "children", "className", "isDisabled", "isIconButton", "isLoading", "onClick", "target", "url"];
var buttonSizeVariant = {
  SMALL: 'small',
  LARGE: 'large',
  DEFAULT: 'default'
};
var buttonVariant = {
  DEFAULT: 'default',
  GREEN: 'green'
};
var ButtonContent = /*#__PURE__*/React.memo(function (_ref) {
  var isLoading = _ref.isLoading,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isLoading ? /*#__PURE__*/React.createElement(Load, {
    className: "absolute loading-icon w-20 h-20 fill-current animate-spin"
  }) : null, /*#__PURE__*/React.createElement("span", {
    className: "".concat(isLoading ? 'opacity-0' : 'opacity-100')
  }, children));
});

/**
 * @type React.FC<buttonPrototypePropTypes>
 */
var ButtonPrototype = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var backgroundVariant = props.backgroundVariant,
    buttonSize = props.buttonSize,
    children = props.children,
    className = props.className,
    isDisabled = props.isDisabled,
    isIconButton = props.isIconButton,
    isLoading = props.isLoading,
    _onClick = props.onClick,
    target = props.target,
    url = props.url,
    rest = _objectWithoutProperties$1(props, _excluded$c);
  var defaultClasses = "flex items-center justify-center rounded outline-0 focus:outline-0\n    font-buenos-aires-text font-semibold leading-24 text-16\n    ".concat(isDisabled || isLoading ? 'disabled cursor-default text-left' : 'cursor-pointer');
  var variantClasses = "rounded\n    ".concat(!isIconButton ? 'px-24 iconButton' : '', "\n    ").concat(backgroundVariant === 'green' && !isDisabled ? 'hover:text-ffffff focus-visible:text-ffffff' : '');
  switch (buttonSize) {
    case buttonSizeVariant.SMALL:
      variantClasses = "".concat(variantClasses, " ").concat(isIconButton ? 'w-40 h-40 p-12' : 'min-h-40 py-8');
      break;
    case buttonSizeVariant.LARGE:
      variantClasses = "".concat(variantClasses, " ").concat(isIconButton ? 'w-56 h-56 p-12' : 'min-h-56 py-8');
      break;
    case buttonSizeVariant.DEFAULT:
    default:
      variantClasses = "".concat(variantClasses, " ").concat(isIconButton ? 'w-48 h-48 p-16' : 'min-h-48 py-12');
      break;
  }
  return /*#__PURE__*/React.createElement(InteractiveElement$1, _extends$1({
    ref: ref,
    url: isDisabled ? null : url,
    className: "".concat(defaultClasses, " ").concat(variantClasses, " ").concat(className, " buttonPrototype\n        ").concat(isLoading ? 'pointer-events-none' : '', "\n      "),
    disabled: isDisabled,
    target: target,
    rel: url && target === '_blank' ? 'noreferrer noopener' : null,
    onClick: function onClick(event) {
      if (!isDisabled && !isLoading && _onClick) {
        _onClick(event);
      }
    },
    tabIndex: isDisabled ? '-1' : '0'
  }, rest), /*#__PURE__*/React.createElement(ButtonContent, {
    isLoading: isLoading
  }, children));
});
var buttonPrototypePropTypes = {
  backgroundVariant: PropTypes.oneOf(Object.values(buttonVariant)),
  buttonSize: PropTypes.oneOf(Object.values(buttonSizeVariant)),
  children: PropTypes.node,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  isIconButton: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  target: PropTypes.string,
  url: PropTypes.string
};
ButtonPrototype.propTypes = buttonPrototypePropTypes;
ButtonPrototype.defaultProps = {
  backgroundVariant: buttonVariant.DEFAULT,
  buttonSize: buttonSizeVariant.DEFAULT,
  className: '',
  isDisabled: false,
  isIconButton: false,
  isLoading: false
};
var ButtonPrototype$1 = ButtonPrototype;

var _excluded$b = ["backgroundVariant", "theme", "variant", "children", "className", "isDisabled", "isLoading", "dataTrackingButtonAction"];
var ButtonTheme$3 = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};

/**
 * @type React.FC<secondaryButtonPropTypes>
 */
var SecondaryButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var backgroundVariant = props.backgroundVariant,
    theme = props.theme,
    variant = props.variant,
    children = props.children,
    className = props.className,
    isDisabled = props.isDisabled,
    isLoading = props.isLoading,
    dataTrackingButtonAction = props.dataTrackingButtonAction,
    rest = _objectWithoutProperties$1(props, _excluded$b);
  var wrapChildrenInSpan = function wrapChildrenInSpan(children) {
    return React.Children.map(children, function (child) {
      if ( /*#__PURE__*/React.isValidElement(child)) {
        if (child.type === 'p') {
          return /*#__PURE__*/React.createElement("span", {
            className: "containerSpan"
          }, wrapChildrenInSpan(child.props.children));
        }
        return /*#__PURE__*/React.cloneElement(child, {
          children: wrapChildrenInSpan(child.props.children)
        });
      }
      if (typeof child === 'string' || typeof child === 'number') {
        return /*#__PURE__*/React.createElement("span", null, child);
      }
      return child;
    });
  };
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    backGroundClass = _useState2[0],
    setBackgroundClass = _useState2[1];
  var secondaryClasses = classnames('outline-none focus-visible:rounded-6 focus-visible:ring-1 focus-visible:ring-18ab42 focus-visible:ring-offset-4', {
    'secondaryGreen': backgroundVariant === 'green',
    'secondaryDefault': backgroundVariant !== 'green' && variant !== bgVariant.DARK,
    'baseState': !isDisabled && !isLoading,
    'secondaryStructure': variant === bgVariant.STRUCTURE && !isDisabled && !isLoading,
    // if button is enabled and not loading
    'text-ffffff shadow-white-outline-2 hover:shadow-white-outline-2 focus-visible:ring-offset-007141': !isDisabled && !isLoading && backgroundVariant === 'green',
    'text-004730 bg-ffffff shadow-secondaryButton': !isDisabled && !isLoading && backgroundVariant !== 'green',
    // if button is disabled
    'shadow-secondaryButtonDisabled': isDisabled && variant !== bgVariant.DARK,
    'text-c7ccd1': isDisabled && backgroundVariant === 'green',
    'text-828b91': isDisabled && backgroundVariant !== 'green',
    // if button is loading
    'bg-007141 shadow-white-outline-2 text-ffffff focus-visible:ring-offset-007141': isLoading && backgroundVariant === 'green',
    'bg-dfe3e6 shadow-secondaryButton text-004730': isLoading && backgroundVariant !== 'green' && variant !== bgVariant.DARK
  });
  var elementVariants = classnames({
    primary: theme === ButtonTheme$3.PRIMARY,
    secondary: theme === ButtonTheme$3.SECONDARY,
    floating: theme === ButtonTheme$3.FLOATING,
    light: variant === bgVariant.LIGHT,
    dark: variant === bgVariant.DARK,
    structure: variant === bgVariant.STRUCTURE
  });
  var interactivityClasses = classnames({
    // styles for disabled
    'cursor-default': isDisabled,
    'text-afb6bc': isDisabled && variant === bgVariant.LIGHT,
    'text-98a1a6': isDisabled && (variant === bgVariant.STRUCTURE || variant === bgVariant.DARK),
    'shadow-dark-gray-outline': isDisabled && variant === bgVariant.DARK,
    // styles for enabled ...
    // 'group cursor-pointer outline-0': !isDisabled,

    'bg-dfe3e6 text-004730 focus-visible:ring-offset-eefaea': variant === bgVariant.STRUCTURE && !isDisabled && backgroundVariant !== 'green',
    'focus-visible:ring-offset-007141 text-ffffff hover:bg-007141': !isDisabled && variant === bgVariant.DARK && backgroundVariant !== 'green',
    'bg-007141 shadow-white-outline-2': isLoading && !isDisabled && variant === bgVariant.DARK
  });
  return /*#__PURE__*/React.createElement(ButtonPrototype$1, _extends$1({
    ref: ref,
    backgroundVariant: backgroundVariant,
    variant: variant,
    className: "".concat(secondaryClasses, " ").concat(elementVariants, " ").concat(interactivityClasses, " ").concat(className, " ").concat(backGroundClass),
    isDisabled: isDisabled,
    isLoading: isLoading,
    "data-tracking-button-action": dataTrackingButtonAction,
    onMouseEnter: function onMouseEnter() {
      setBackgroundClass('background-animation');
    }
  }, rest), wrapChildrenInSpan(children));
});
var secondaryButtonPropTypes = {
  backgroundVariant: PropTypes.oneOf(['default', 'green']),
  children: PropTypes.node,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  dataTrackingButtonAction: PropTypes.string,
  theme: PropTypes.oneOf(Object.values(ButtonTheme$3)),
  variant: PropTypes.oneOf(Object.values(bgVariant))
};
SecondaryButton.propTypes = secondaryButtonPropTypes;
SecondaryButton.defaultProps = {
  backgroundVariant: 'default',
  children: 'Secondary Button',
  className: '',
  isDisabled: false,
  isLoading: false,
  dataTrackingButtonAction: null,
  variant: bgVariant.LIGHT
};
var SecondaryButton$1 = SecondaryButton;

var _excluded$a = ["backgroundVariant", "theme", "variant", "children", "className", "isDisabled", "isLoading", "dataTrackingButtonAction"];
var ButtonTheme$2 = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};

/**
 * @type React.FC<primaryButtonPropTypes>
 */
var PrimaryButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var backgroundVariant = props.backgroundVariant,
    theme = props.theme,
    variant = props.variant,
    children = props.children,
    className = props.className,
    isDisabled = props.isDisabled,
    isLoading = props.isLoading,
    dataTrackingButtonAction = props.dataTrackingButtonAction,
    rest = _objectWithoutProperties$1(props, _excluded$a);
  var wrapChildrenInSpan = function wrapChildrenInSpan(children) {
    return React.Children.map(children, function (child) {
      if ( /*#__PURE__*/React.isValidElement(child)) {
        if (child.type === 'p') {
          return /*#__PURE__*/React.createElement("span", {
            className: "containerSpan"
          }, wrapChildrenInSpan(child.props.children));
        }
        return /*#__PURE__*/React.cloneElement(child, {
          children: wrapChildrenInSpan(child.props.children)
        });
      }
      if (typeof child === 'string' || typeof child === 'number') {
        return /*#__PURE__*/React.createElement("span", null, child);
      }
      return child;
    });
  };
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    backGroundClass = _useState2[0],
    setBackgroundClass = _useState2[1];
  var primaryClasses = classnames('focus-visible:rounded-6 focus-visible:ring-1 focus-visible:ring-offset-4', {
    'primaryGreen': backgroundVariant === 'green',
    'primaryDefault': backgroundVariant !== 'green',
    'baseState': !isDisabled && !isLoading,
    'primaryDark': variant === bgVariant.DARK && !isDisabled && !isLoading,
    'bg-dfe3e6 text-98a1a6': isDisabled && backgroundVariant !== 'green' && variant !== bgVariant.DARK,
    'bg-586167 text-98a1a6': isDisabled && backgroundVariant === 'green',
    'bg-ffffff text-004730 shadow-primaryButtonHover': !isDisabled && isLoading && (variant === bgVariant.STRUCTURE || variant === bgVariant.LIGHT),
    'text-004730 shadow-primaryButtonHover': !isDisabled && !isLoading,
    'bg-91f54a text-004730 focus-visible:ring-offset-007141 hover:bg-transparent hover:text-ffffff shadow-primaryButtonHover': !isDisabled && !isLoading && backgroundVariant === 'green',
    'bg-005e3f text-004730 shadow-primaryButtonHover': backgroundVariant !== 'green' && !isDisabled && isLoading,
    'text-ffffff shadow-primaryButtonHover focus-visible:ring-offset-005e3f': backgroundVariant === 'green' && !isDisabled && isLoading
  });
  var elementVariants = classnames({
    primary: theme === ButtonTheme$2.PRIMARY,
    secondary: theme === ButtonTheme$2.SECONDARY,
    floating: theme === ButtonTheme$2.FLOATING,
    light: variant === bgVariant.LIGHT,
    dark: variant === bgVariant.DARK || backgroundVariant === 'green',
    structure: variant === bgVariant.STRUCTURE
  });
  var interactivityClasses = classnames({
    // styles for disabled
    'cursor-default': isDisabled,
    'bg-dfe3e6 text-98a1a6': variant === bgVariant.STRUCTURE && isDisabled,
    'bg-586167 text-98a1a6': variant === bgVariant.DARK && isDisabled,
    // styles for enabled ...
    'group cursor-pointer outline-0': !isDisabled,
    'bg-dfe3e6 text-004730 focus-visible:ring-offset-ffffff focus-visible:ring-18ab42': variant === bgVariant.LIGHT && backgroundVariant !== 'green' && !isDisabled && !isLoading,
    'bg-dfe3e6 text-004730 focus-visible:ring-offset-eefaea focus-visible:ring-07983e': variant === bgVariant.STRUCTURE && !isDisabled && !isLoading,
    'bg-91f54a text-004730 focus-visible:ring-offset-005e3f focus-visible:ring-18ab42 focus-visible:text-ffffff hover:bg-transparent hover:text-ffffff shadow-primaryButtonHover primaryGreen': (variant === bgVariant.DARK || backgroundVariant === 'green') && !isDisabled && !isLoading,
    'bg-005e3f text-ffffff shadow-primaryButtonHover focus-visible:ring-offset-005e3f focus-visible:ring-18ab42': variant === bgVariant.DARK && isLoading,
    'bg-005e3f text-004730 shadow-primaryButtonHover': variant === bgVariant.DARK && !isDisabled && isLoading
  });
  return /*#__PURE__*/React.createElement(ButtonPrototype$1, _extends$1({
    ref: ref,
    backgroundVariant: backgroundVariant,
    className: "".concat(elementVariants, " ").concat(primaryClasses, " ").concat(interactivityClasses, " ").concat(className, " ").concat(backGroundClass),
    isDisabled: isDisabled,
    isLoading: isLoading,
    "data-tracking-button-action": dataTrackingButtonAction,
    onMouseEnter: function onMouseEnter() {
      setBackgroundClass('background-animation');
    }
  }, rest), wrapChildrenInSpan(children));
});
var primaryButtonPropTypes = {
  backgroundVariant: PropTypes.oneOf(['default', 'green']),
  children: PropTypes.node,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  dataTrackingButtonAction: PropTypes.string,
  theme: PropTypes.oneOf(Object.values(ButtonTheme$2)),
  variant: PropTypes.oneOf(Object.values(bgVariant))
};
PrimaryButton.propTypes = primaryButtonPropTypes;
PrimaryButton.defaultProps = {
  backgroundVariant: 'default',
  children: 'Primary Button',
  className: '',
  isDisabled: false,
  isLoading: false,
  dataTrackingButtonAction: null,
  variant: bgVariant.LIGHT
};
var PrimaryButton$1 = PrimaryButton;

var _excluded$9 = ["children", "label", "className", "windowClassName", "closeBtnVariant", "closeBtnClassName", "closeIconClassName", "onClose", "isOpen", "hideDefaultCloseButton", "disableBGClose", "ariaLabelCloseButton", "dataTrackingButtonAction"];

// generic overlay component using react portals (see https://reactjs.org/docs/portals.html)
var Overlay = function Overlay(_ref) {
  var children = _ref.children,
    label = _ref.label,
    className = _ref.className,
    windowClassName = _ref.windowClassName,
    closeBtnVariant = _ref.closeBtnVariant,
    closeBtnClassName = _ref.closeBtnClassName,
    closeIconClassName = _ref.closeIconClassName,
    onClose = _ref.onClose,
    isOpen = _ref.isOpen,
    hideDefaultCloseButton = _ref.hideDefaultCloseButton,
    disableBGClose = _ref.disableBGClose,
    ariaLabelCloseButton = _ref.ariaLabelCloseButton,
    dataTrackingButtonAction = _ref.dataTrackingButtonAction,
    rest = _objectWithoutProperties$1(_ref, _excluded$9);
  var closeButtonRef = useRef(null);
  var previousActiveElement = useRef(null);
  useEffect(function () {
    if (isOpen) {
      var pageContent = document.getElementById('___gatsby');
      if (pageContent) {
        // hide rest of the page from screenreaders
        pageContent.setAttribute('aria-hidden', 'true');
      }
      // disable bg movement on swiping/scrolling
      document.body.style.overflow = 'hidden';

      // save previous focus; needs to run before focus change
      previousActiveElement.current = document.activeElement;

      // focus close button on opening overlay
      if (!hideDefaultCloseButton) {
        closeButtonRef.current.focus();
      }
      return function () {
        var pageContent = document.getElementById('___gatsby');
        if (pageContent) {
          document.getElementById('___gatsby').removeAttribute('aria-hidden');
        }
        document.body.style.overflow = '';
        if (previousActiveElement !== null && previousActiveElement !== void 0 && previousActiveElement.current) {
          previousActiveElement.current.focus();
        }
      };
    }
  }, [isOpen, hideDefaultCloseButton]);
  if (!isOpen) return null;
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends$1({
    role: "dialog",
    "aria-label": label,
    className: "fixed z-40 flex justify-center items-center top-0 left-0 right-0 bottom-0 overflow-y-scroll ".concat(className)
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "fixed top-0 left-0 right-0 bottom-0 bg-000000 opacity-64",
    onClick: disableBGClose ? undefined : onClose,
    role: "presentation"
  }), /*#__PURE__*/React.createElement("div", {
    className: "overlay-wrapper relative z-40 max-h-screen ".concat(windowClassName)
  }, !hideDefaultCloseButton && /*#__PURE__*/React.createElement("button", {
    type: "button",
    ref: closeButtonRef,
    onClick: onClose,
    title: "Dialog schlie\xDFen",
    "aria-label": ariaLabelCloseButton,
    "data-tracking-button-action": dataTrackingButtonAction,
    className: "\n                z-10 absolute group\n                rounded-full\n                text-center focus-visible:outline focus-visible:outline-1 focus-visible:outline-18ab42 focus-visible:outline-offset-4\n                shadow-blackTransparent\n                ".concat(closeBtnClassName, "\n                ").concat(closeBtnVariant === bgVariant.DARK ? 'text-ffffff bg-000000 bg-opacity-16 hover:bg-opacity-33 focus-visible:bg-opacity-33' : 'text-004730 bg-ffffff    ', "\n              ")
  }, /*#__PURE__*/React.createElement(Close, {
    className: "\n                  inline fill-current\n                  transition ease-in-out duration-350 transform group-hover:scale-125\n                  ".concat(closeIconClassName, "\n                ")
  })), children))), document.body);
};
Overlay.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  className: PropTypes.string,
  windowClassName: PropTypes.string,
  closeBtnClassName: PropTypes.string,
  closeIconClassName: PropTypes.string,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  hideDefaultCloseButton: PropTypes.bool,
  closeBtnVariant: PropTypes.oneOf(Object.values(bgVariant)),
  ariaLabelCloseButton: PropTypes.string,
  dataTrackingButtonAction: PropTypes.string
};
Overlay.defaultProps = {
  label: 'aria-label wurde nicht gesetzt',
  className: '',
  windowClassName: '',
  closeBtnClassName: '',
  closeIconClassName: '',
  closeBtnVariant: bgVariant.DARK,
  onClose: function onClose() {},
  isOpen: false,
  hideDefaultCloseButton: false,
  ariaLabelCloseButton: 'Schließen',
  dataTrackingButtonAction: null
};
var Overlay$1 = Overlay;

var _excluded$8 = ["theme", "headline", "text", "cancelLabel", "actionLabel", "onAction", "onCancel", "onClose", "isOpen"];
var SCROLL_THRESHOLD = 5;
var Dialog = function Dialog(_ref) {
  var theme = _ref.theme,
    headline = _ref.headline,
    text = _ref.text,
    cancelLabel = _ref.cancelLabel,
    actionLabel = _ref.actionLabel,
    onAction = _ref.onAction,
    onCancel = _ref.onCancel,
    onClose = _ref.onClose,
    isOpen = _ref.isOpen,
    rest = _objectWithoutProperties$1(_ref, _excluded$8);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    scrolledOverHeadline = _useState2[0],
    setScrolledOverHeadline = _useState2[1];
  var textRef = useRef();
  var handleInnerScroll = function handleInnerScroll() {
    if (textRef.current.scrollTop > SCROLL_THRESHOLD) {
      setScrolledOverHeadline(true);
    } else {
      setScrolledOverHeadline(false);
    }
  };
  return /*#__PURE__*/React.createElement(Overlay$1, _extends$1({
    onClose: onClose,
    label: headline,
    isOpen: isOpen,
    className: "h-screen",
    windowClassName: "dialog-overlay w-full px-16 600:w-4/5 840:w-13/18 1280:max-w-656 1280:px-0 1280:w-full",
    closeBtnClassName: "w-48 h-48 \n        ".concat(theme === 'portalsuche' ? 'text-005e3f top-16 right-32 840:top-24 840:right-40 1280:right-24' : theme === 'benefit' ? 'text-ff5733 top-8 right-8 600:top-16 600:right-16' : 'top-12 right-28 600:top-24 600:right-36 1280:top-24 1280:right-24'),
    closeIconClassName: "w-16 h-16",
    closeBtnVariant: "light"
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "bg-ffffff rounded-4"
  }, /*#__PURE__*/React.createElement("div", null, theme === 'default' && /*#__PURE__*/React.createElement("div", {
    className: "relative h-60 mr-36 p-16 600:px-24"
  }, /*#__PURE__*/React.createElement("p", {
    className: "".concat(scrolledOverHeadline ? 'opacity-100' : 'opacity-0', " truncate text-20 leading-28 text-005e3f font-buenos-aires font-semibold transition-opacity duration-350")
  }, headline)), /*#__PURE__*/React.createElement("div", {
    ref: textRef,
    onScroll: handleInnerScroll,
    className: "overlay-textblock px-16 600:px-48 840:px-64 840:pt-12 h-full overflow-y-auto ".concat(theme === 'portalsuche' ? 'pb-16' : theme === 'benefit' ? 'pb-40 text-center' : 'pb-24')
  }, theme === 'default' && /*#__PURE__*/React.createElement("p", {
    className: "text-24 leading-32 text-005e3f font-buenos-aires font-semibold"
  }, headline), theme === 'benefit' && /*#__PURE__*/React.createElement("div", {
    className: "mt-64 text-24 leading-32 text-005e3f font-buenos-aires font-semibold"
  }, headline), theme === 'portalsuche' && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-full mt-64 840:mt-80 mb-24"
  }, /*#__PURE__*/React.createElement("label", {
    className: "flex flex-row items-center text-left text-12 leading-18 text-293033 font-semibold border-98a1a6 rounded-4 border py-2 px-8 opacity-80"
  }, /*#__PURE__*/React.createElement(Location, {
    className: "inline fill-current w-12 h-12 mr-4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "-mb-2"
  }, headline))), /*#__PURE__*/React.createElement(TextBlock, {
    className: "".concat(theme === 'portalsuche' ? 'text-center' : 'pt-8'),
    text: text
  })), /*#__PURE__*/React.createElement("div", {
    className: "\n            flex flex-col-reverse gap-y-16 px-16 ".concat(theme === 'portalsuche' ? 'py-16 justify-center 840:pt-24 840:pb-80' : theme === 'benefit' ? 'pb-64 justify-center' : 'py-24 justify-end', "\n            1000:flex-row 600:gap-x-16 600:px-48\n            840:px-64 \n            ")
  }, cancelLabel && onCancel && /*#__PURE__*/React.createElement(SecondaryButton$1, {
    onClick: onCancel
  }, cancelLabel), /*#__PURE__*/React.createElement(PrimaryButton$1, {
    onClick: onAction
  }, actionLabel)))));
};
Dialog.propTypes = {
  theme: PropTypes.string,
  headline: PropTypes.string,
  text: PropTypes.string,
  actionLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onAction: PropTypes.func,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool
};
Dialog.defaultProps = {
  theme: 'default',
  headline: 'Headline wurde nicht gesetzt',
  text: 'Text wurde nicht gesetzt',
  actionLabel: 'Titel wurde nicht gesetzt',
  onAction: function onAction() {},
  onClose: function onClose() {}
};
var Dialog$1 = Dialog;

var Dropdown = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var name = props.name,
    label = props.label,
    testId = props.testId,
    defaultValue = props.defaultValue,
    placeholder = props.placeholder,
    options = props.options,
    ariaDescribedby = props.ariaDescribedby,
    required = props.required,
    onChange = props.onChange,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    onDropdownClick = props.onDropdownClick,
    error = props.error,
    disabled = props.disabled,
    labelVisibility = props.labelVisibility,
    variant = props.variant,
    popover = props.popover,
    className = props.className,
    id = props.id,
    selectProps = props.selectProps,
    hidePlaceholderOptionAfterSelection = props.hidePlaceholderOptionAfterSelection,
    hideErrorMessage = props.hideErrorMessage,
    dir = props.dir,
    hasTransparentBorder = props.hasTransparentBorder,
    hasNoFocusOutline = props.hasNoFocusOutline,
    isEasyLanguagePage = props.isEasyLanguagePage;
  var _useState = useState(error),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFocused = _useState6[0],
    setIsFocused = _useState6[1];
  var _useState7 = useState(defaultValue || ''),
    _useState8 = _slicedToArray(_useState7, 2),
    value = _useState8[0],
    setValue = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isIos = _useState10[0],
    setIsIos = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isMultiline = _useState12[0],
    setIsMultiline = _useState12[1];
  var errorRef = useRef(null);
  var _useState13 = useState(function () {
      return id || createRandomID('dropdown');
    }),
    _useState14 = _slicedToArray(_useState13, 1),
    selectId = _useState14[0];
  var _useState15 = useState(function () {
      return id ? "".concat(id, "-error") : createRandomID('error');
    }),
    _useState16 = _slicedToArray(_useState15, 1),
    errorMessageId = _useState16[0];
  var ariaDescribedbyIds = useMemo(function () {
    switch (true) {
      case !!errorMessage && !!ariaDescribedby:
        return "".concat(ariaDescribedby, " ").concat(errorMessageId);
      case !!errorMessage:
        return errorMessageId;
      default:
        return ariaDescribedby;
    }
  }, [errorMessage, errorMessageId, ariaDescribedby]);
  var labelString = "".concat(label).concat(required ? '*' : '');
  var selectClasses = '';
  var labelClasses = '';
  var errorIconClasses = '';
  var errorTextClasses = '';
  switch (variant) {
    case bgVariant.LIGHT:
    default:
      if (disabled) {
        selectClasses = "bg-dfe3e6 border-dfe3e6";
      } else if (errorMessage) {
        selectClasses = "bg-ffffff border-eb0047 shadow-red-primary";
      } else if (isFocused) {
        selectClasses = "bg-ffffff border-18ab42 shadow-green-outline";
      } else if (hasTransparentBorder) {
        selectClasses = "bg-ffffff border-transparent hover:shadow-green-primary hover:border-18ab42";
      } else {
        selectClasses = "bg-ffffff border-828b91 hover:shadow-green-primary hover:border-18ab42";
      }
      labelClasses = 'text-293033';
      errorIconClasses = 'text-eb0047';
      errorTextClasses = 'text-eb0047';
      if (labelVisibility === labelVisibilityState.FLOATING && !value) {
        selectClasses = "".concat(selectClasses, " transition duration-350 ease-in-out text-6d767c focus-visible:text-ffffff");
      } else if (labelVisibility !== labelVisibilityState.FLOATING && !value && !defaultValue) {
        selectClasses = "".concat(selectClasses, " text-6d767c");
      } else {
        selectClasses = "".concat(selectClasses, " text-293033");
      }
      break;
    case bgVariant.DARK:
      selectClasses = 'bg-005e3f';
      if (disabled) {
        selectClasses = "".concat(selectClasses, " border-586167 text-586167 bg-586167 text-98a1a6");
      } else if (errorMessage) {
        selectClasses = "".concat(selectClasses, " border-f580a3 shadow-red-secondary");
      } else if (isFocused) {
        selectClasses = "".concat(selectClasses, " border-18ab42 shadow-green-secondary");
      } else {
        selectClasses = "".concat(selectClasses, " border-18ab42 hover:shadow-green-secondary hover:border-50eb5d");
      }
      labelClasses = 'text-ffffff';
      errorIconClasses = 'text-f580a3';
      errorTextClasses = 'text-ffffff';
      if (labelVisibility === labelVisibilityState.FLOATING && !value && !isEasyLanguagePage) {
        selectClasses = "".concat(selectClasses, " transition duration-350 ease-in-out ").concat(disabled ? 'text-98a1a6' : 'text-98e692', " focus-visible:text-005e3f");
      } else if (labelVisibility !== labelVisibilityState.FLOATING && !value && !defaultValue) {
        selectClasses = "".concat(selectClasses, " text-98e692");
      } else {
        selectClasses = "".concat(selectClasses, " text-ffffff");
      }
      break;
  }
  var opacityClass = 'opacity-100';
  switch (labelVisibility) {
    case labelVisibilityState.HIDE:
      labelClasses = 'sr-only';
      break;
    case labelVisibilityState.FLOATING:
      if (!value && !isOpen && !isFocused) {
        opacityClass = 'opacity-0';
      }
      labelClasses = "".concat(labelClasses, " transition duration-350 ease-in-out ").concat(opacityClass);
      break;
  }
  useEffect(function () {
    var _window, _window2;
    var userAgent = (_window = window) === null || _window === void 0 ? void 0 : _window.navigator.userAgent;

    // Überprüfen auf allgemeine iOS-Geräte
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !((_window2 = window) !== null && _window2 !== void 0 && _window2.MSStream);

    // Überprüfen auf iOS 13 und später
    var isIOS13 = /Macintosh/.test(userAgent) && 'ontouchend' in document;
    setIsIos(isIOS || isIOS13);
  }, []);
  var handleBlur = function handleBlur(event) {
    setIsOpen(false);
    setIsFocused(false);
    onBlur(event);
  };
  var handleFocus = function handleFocus(event) {
    setIsFocused(true);
    onFocus(event);
  };
  var handleMouseEnter = function handleMouseEnter(event) {
    onMouseEnter(event);
  };
  var handleMouseLeave = function handleMouseLeave(event) {
    onMouseLeave(event);
  };
  var handleClick = function handleClick(event) {
    onDropdownClick(event);
    setIsOpen(!isOpen);
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Enter' || event.key === 'Space' || event.keyCode === 13 || event.keyCode === 32) {
      handleClick(event);
      setIsOpen(!isOpen);
    }
  };
  var handleChange = function handleChange(event) {
    setValue(event.target.value);
    onChange(event);
  };
  useEffect(function () {
    setValue(defaultValue || '');
  }, [defaultValue]);
  useEffect(function () {
    setErrorMessage(error);
  }, [error]);
  useEffect(function () {
    var element = errorRef.current;
    if (element) {
      var elementHeight = element.offsetHeight;
      var lineHeight = parseFloat(getComputedStyle(element).lineHeight);
      var numberOfLines = Math.round(elementHeight / lineHeight);
      setIsMultiline(numberOfLines > 1);
    }
  }, [errorMessage]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " flex flex-col")
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: selectId,
    className: "\n          ".concat(isEasyLanguagePage ? 'mb-8 text-14 leading-26' : 'mb-4 text-12 leading-18', "\n          ").concat(labelClasses, "\n        ")
  }, labelString), /*#__PURE__*/React.createElement("div", {
    className: "flex w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "\n            inline-flex relative flex-1 p-4 -m-4\n            dropdown-wrapper\n            ".concat(hasNoFocusOutline ? 'has-no-focus-outline' : '', "\n          ")
  }, /*#__PURE__*/React.createElement("select", _extends$1({
    id: selectId,
    name: name,
    ref: ref,
    "data-cy": testId,
    "aria-describedby": ariaDescribedbyIds,
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    required: required,
    disabled: disabled,
    value: value,
    className: "dropdown\n              ".concat(variant === bgVariant.DARK ? 'bg-dark' : 'bg-light', "\n              w-full h-48 cursor-pointer border focus:outline-0\n              text-16 leading-24\n              py-12 rounded-4 appearance-none\n              transition duration-350 ease-in-out\n              ").concat(dir === 'rtl' ? 'pl-48 pr-16 ' : 'pr-48 pl-16', "\n              ").concat(isOpen ? 'open' : 'closed', "\n              ").concat(selectClasses, "\n            ")
  }, selectProps), (!value || !required || isIos) && /*#__PURE__*/React.createElement("option", {
    value: "",
    hidden: hidePlaceholderOptionAfterSelection
  }, function () {
    if (labelVisibility === labelVisibilityState.FLOATING) return labelString;
    if (placeholder) return placeholder;
    return 'Bitte wählen';
  }()), options.map(function (option, index) {
    var key = "".concat(index, "_").concat(option.value);
    return /*#__PURE__*/React.createElement("option", _extends$1({
      key: key,
      value: option.value,
      className: "".concat(variant === bgVariant.LIGHT ? 'text-293033' : 'text-ffffff')
    }, option.props), option.label);
  }))), popover && /*#__PURE__*/React.createElement("div", {
    className: "self-center inline"
  }, popover)), !hideErrorMessage && errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "".concat(isMultiline ? "items-start" : "items-center", " flex mt-8")
  }, /*#__PURE__*/React.createElement(AlertCircleFilled, {
    className: "\n                min-w-[16px] w-16 h-16 fill-current transition-opacity duration-350 ease-in-out\n              ".concat(dir === 'rtl' ? 'left-48' : 'right-48', "\n              ").concat(isEasyLanguagePage ? 'mt-3' : '', " \n              ").concat(errorIconClasses, "\n              ").concat(errorMessage && !disabled ? 'opacity-100' : 'opacity-0', "\n            ")
  }), /*#__PURE__*/React.createElement("span", {
    id: errorMessageId,
    ref: errorRef,
    "aria-live": "assertive",
    className: "\n                  transition-opacity duration-350 ease-in-out mx-8\n                  ".concat(dir === 'rtl' ? 'left-48' : 'right-48', "\n                  ").concat(errorTextClasses, "\n                  ").concat(isEasyLanguagePage ? 'text-14 leading-26' : 'text-12 leading-18', "\n                  ").concat(errorMessage && !disabled ? 'opacity-100' : 'opacity-0', "\n                "),
    dangerouslySetInnerHTML: {
      __html: errorMessage
    }
  })));
});
Dropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    props: PropTypes.object
  })),
  name: PropTypes.string,
  label: PropTypes.string,
  testId: PropTypes.string,
  ariaDescribedby: PropTypes.string,
  defaultValue: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  labelVisibility: PropTypes.oneOf(Object.values(labelVisibilityState)),
  variant: PropTypes.oneOf(Object.values(bgVariant)),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onDropdownClick: PropTypes.func,
  className: PropTypes.string,
  popover: PropTypes.node,
  id: PropTypes.string,
  dir: PropTypes.oneOf(['rtl', 'ltr']),
  hidePlaceholderOptionAfterSelection: PropTypes.bool,
  hasTransparentBorder: PropTypes.bool,
  hasNoFocusOutline: PropTypes.bool,
  isEasyLanguagePage: PropTypes.bool
};
Dropdown.defaultProps = {
  options: [{
    value: '0',
    label: 'Options wurden nicht gesetzt'
  }],
  name: 'Name wurde nicht gesetzt',
  label: 'Label wurde nicht gesetzt',
  labelVisibility: labelVisibilityState.FLOATING,
  variant: bgVariant.LIGHT,
  className: '',
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onDropdownClick: function onDropdownClick() {},
  dir: 'ltr',
  hidePlaceholderOptionAfterSelection: false,
  hasTransparentBorder: false,
  hasNoFocusOutline: false,
  isEasyLanguagePage: false
};
var Dropdown$1 = Dropdown;

var _excluded$7 = ["className", "title", "href", "target", "icon", "showTitle", "beforeTitleSlot", "afterIconOrTitleSlot", "iconPosition", "contentAlign", "disabled", "theme", "variant", "hasNoFocusOutline", "linkHasUnderline", "linkSize"];
var LinkTheme = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
var IconPosition = {
  LEFT: 'left',
  RIGHT: 'right',
  RIGHT_SPACE_BETWEEN: 'right_space_between'
};

/**
 * @type React.FC<linkPropTypes>
 */
var Link = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
    title = props.title,
    href = props.href,
    target = props.target,
    icon = props.icon,
    showTitle = props.showTitle,
    beforeTitleSlot = props.beforeTitleSlot,
    afterIconOrTitleSlot = props.afterIconOrTitleSlot,
    iconPosition = props.iconPosition,
    contentAlign = props.contentAlign,
    disabled = props.disabled,
    theme = props.theme,
    variant = props.variant,
    hasNoFocusOutline = props.hasNoFocusOutline,
    linkHasUnderline = props.linkHasUnderline,
    linkSize = props.linkSize,
    rest = _objectWithoutProperties$1(props, _excluded$7);

  // negative margin needed to offset focus border without creating extra space
  var baseClasses = classnames('link inline-block -m-4 font-semibold focus:outline-0', {
    // ... if link is primary
    'text-16 leading-24': linkSize === size.LARGE,
    'text-14 leading-18': linkSize === size.SMALL,
    'primary-light': LinkTheme.PRIMARY && variant === bgVariant.LIGHT,
    'primary-dark': theme === LinkTheme.PRIMARY && variant === bgVariant.DARK,
    'primary-structure': theme === LinkTheme.PRIMARY && variant === bgVariant.STRUCTURE,
    // ... if link is secondary
    'secondary-light': theme === LinkTheme.SECONDARY && variant === bgVariant.LIGHT,
    'secondary-dark': theme === LinkTheme.SECONDARY && variant === bgVariant.DARK,
    'secondary-structure': theme === LinkTheme.SECONDARY && variant === bgVariant.STRUCTURE,
    'secondary-error': theme === LinkTheme.SECONDARY && variant === bgVariant.ERROR,
    'notDisabled': !disabled
  });
  var contentClasses = classnames({
    'items-start': contentAlign === align.START,
    'items-center': contentAlign === align.CENTER,
    'items-end': contentAlign === align.END
  });
  var elementVariants = classnames({
    primary: theme === LinkTheme.PRIMARY,
    secondary: theme === LinkTheme.SECONDARY,
    light: variant === bgVariant.LIGHT,
    dark: variant === bgVariant.DARK,
    structure: variant === bgVariant.STRUCTURE,
    error: variant === bgVariant.ERROR
  });
  var interactivityClasses = classnames({
    // styles for disabled links
    'cursor-default': disabled,
    'text-afb6bc': disabled && bgVariant.LIGHT,
    'text-c7ccd1': disabled && bgVariant.DARK,
    'text-98a1a6': disabled && bgVariant.STRUCTURE,
    // styles for enabled links ...
    'group cursor-pointer outline-0': !disabled,
    // ... if link is primary
    'text-50eb5d': !disabled && theme === LinkTheme.PRIMARY && variant === bgVariant.DARK,
    'text-005e3f': !disabled && theme === LinkTheme.PRIMARY && (variant === bgVariant.LIGHT || bgVariant.STRUCTURE),
    // ... if link is secondary
    'text-6d767c': !disabled && theme === LinkTheme.SECONDARY && variant === bgVariant.LIGHT,
    'text-ffffff': !disabled && theme === LinkTheme.SECONDARY && variant === bgVariant.DARK,
    'text-40484d': !disabled && theme === LinkTheme.SECONDARY && variant === bgVariant.STRUCTURE,
    'text-eb0047': !disabled && theme === LinkTheme.SECONDARY && variant === bgVariant.ERROR
  });
  var iconClasses = classnames({
    'icon-size-14': linkSize === size.SMALL
  });
  var IconWrapper = function IconWrapper(_ref) {
    var className = _ref.className,
      children = _ref.children;
    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(className, " fill-current transition ease-in-out duration-350 group-hover:scale-125")
    }, children);
  };
  var content = /*#__PURE__*/React.createElement("span", {
    className: "".concat(contentClasses, " ").concat(icon && iconPosition === IconPosition.RIGHT ? 'inline-block' : 'flex', " group ").concat(!hasNoFocusOutline ? 'border-18ab42 group-focus-visible:border group-focus-visible:-m-1 rounded-6' : '', "  p-4")
  }, icon && iconPosition === IconPosition.LEFT && /*#__PURE__*/React.createElement(IconWrapper, {
    className: "".concat(iconClasses, " ").concat(title ? 'self-center mr-8' : '')
  }, icon), /*#__PURE__*/React.createElement("span", {
    className: elementVariants
  }, beforeTitleSlot, showTitle && (
  // render title string correctly if it contains any html entities
  typeof title === 'string' ? /*#__PURE__*/React.createElement("span", {
    className: "".concat(!disabled ? linkHasUnderline ? 'link_underline' : '' : ''),
    dangerouslySetInnerHTML: {
      __html: title
    }
  }) :
  /*#__PURE__*/
  // render title directly if it is a React Element or any other non-string type
  React.createElement("span", {
    className: "".concat(!disabled ? linkHasUnderline ? 'link_underline' : '' : '')
  }, title))), icon && iconPosition === IconPosition.RIGHT && /*#__PURE__*/React.createElement(IconWrapper, {
    className: "".concat(iconClasses, " ").concat(title ? 'inline-block ml-8' : '')
  }, icon), icon && iconPosition === IconPosition.RIGHT_SPACE_BETWEEN && /*#__PURE__*/React.createElement(IconWrapper, {
    className: "".concat(iconClasses, " ").concat(title ? 'ml-auto' : '')
  }, icon), afterIconOrTitleSlot);
  return /*#__PURE__*/React.createElement(InteractiveElement$1, _extends$1({
    ref: ref,
    url: disabled ? null : href,
    target: target,
    rel: href && target === '_blank' ? 'noreferrer noopener' : null,
    className: "".concat(baseClasses, " ").concat(interactivityClasses, " ").concat(className),
    disabled: disabled
  }, rest), content);
});
var linkPropTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  href: PropTypes.string,
  target: PropTypes.string,
  icon: PropTypes.node,
  iconPosition: PropTypes.oneOf(Object.values(IconPosition)),
  contentAlign: PropTypes.oneOf(Object.values(align)),
  disabled: PropTypes.bool,
  theme: PropTypes.oneOf(Object.values(LinkTheme)),
  variant: PropTypes.oneOf(Object.values(bgVariant)),
  hasNoFocusOutline: PropTypes.bool,
  beforeTitleSlot: PropTypes.node,
  afterIconOrTitleSlot: PropTypes.node,
  showTitle: PropTypes.bool,
  linkHasUnderline: PropTypes.bool,
  className: PropTypes.string,
  linkSize: PropTypes.oneOf(Object.values(size))
};
Link.propTypes = linkPropTypes;
Link.defaultProps = {
  title: 'Kein Titel gesetzt',
  theme: LinkTheme.PRIMARY,
  variant: bgVariant.LIGHT,
  disabled: false,
  hasNoFocusOutline: false,
  iconPosition: IconPosition.RIGHT,
  contentAlign: align.CENTER,
  showTitle: true,
  linkHasUnderline: true,
  className: '',
  linkSize: size.LARGE
};
var Link$1 = Link;

var DropdownFloating = function DropdownFloating(_ref) {
  var id = _ref.id,
    className = _ref.className,
    selectClassName = _ref.selectClassName,
    dropdownClassName = _ref.dropdownClassName,
    optionClassName = _ref.optionClassName,
    showTitle = _ref.showTitle,
    beforeSelectSlot = _ref.beforeSelectSlot,
    defaultValue = _ref.defaultValue,
    icon = _ref.icon,
    label = _ref.label,
    labelVisibility = _ref.labelVisibility,
    placeholder = _ref.placeholder,
    options = _ref.options,
    selectionMode = _ref.selectionMode,
    onChange = _ref.onChange,
    _onFocus = _ref.onFocus,
    _onBlur = _ref.onBlur,
    _onMouseEnter = _ref.onMouseEnter,
    _onMouseLeave = _ref.onMouseLeave,
    ariaDescribedby = _ref.ariaDescribedby,
    error = _ref.error,
    disabled = _ref.disabled,
    settings = _ref.settings,
    required = _ref.required;
  // get variant out of settings
  var _settings$variant = settings.variant,
    variant = _settings$variant === void 0 ? 'small' : _settings$variant,
    _settings$backgroundV = settings.backgroundVariant,
    backgroundVariant = _settings$backgroundV === void 0 ? bgVariant.LIGHT : _settings$backgroundV,
    _settings$align = settings.align,
    align = _settings$align === void 0 ? position.LEFT : _settings$align,
    _settings$iconPositio = settings.iconPosition,
    iconPosition = _settings$iconPositio === void 0 ? 'right' : _settings$iconPositio,
    _settings$hasNoFocusO = settings.hasNoFocusOutline,
    hasNoFocusOutline = _settings$hasNoFocusO === void 0 ? false : _settings$hasNoFocusO,
    _settings$linkHasUnde = settings.linkHasUnderline,
    linkHasUnderline = _settings$linkHasUnde === void 0 ? true : _settings$linkHasUnde,
    _settings$smallSelect = settings.smallSelectHasActiveStateColors,
    smallSelectHasActiveStateColors = _settings$smallSelect === void 0 ? false : _settings$smallSelect;
  // Refs
  var dropdownButtonRef = useRef(null);
  var dropdownRef = useRef(null);
  var _useState = useState(function () {
      return id || createRandomID('dropdown');
    }),
    _useState2 = _slicedToArray(_useState, 1),
    selectId = _useState2[0];
  // Error handling
  var _useState3 = useState(error),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(function () {
      return id ? "".concat(id, "-error") : createRandomID('error');
    }),
    _useState6 = _slicedToArray(_useState5, 1),
    errorMessageId = _useState6[0];

  // Dropdown state
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isOpen = _useState8[0],
    setIsOpen = _useState8[1];

  // Focus
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isFocused = _useState10[0],
    setIsFocused = _useState10[1];
  var _useState11 = useState(function () {
      if (defaultValue.length > 0) {
        if (selectionMode === 'multiple') {
          return defaultValue.map(function (value) {
            var _options$find;
            return {
              value: value,
              label: (_options$find = options.find(function (option) {
                return option.value === value;
              })) === null || _options$find === void 0 ? void 0 : _options$find.label
            };
          });
        } else {
          var _options$find2;
          return [{
            value: defaultValue[0],
            label: (_options$find2 = options.find(function (option) {
              return option.value === defaultValue[0];
            })) === null || _options$find2 === void 0 ? void 0 : _options$find2.label
          }];
        }
      } else {
        return [];
      }
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    dropdownValue = _useState12[0],
    setDropdownValue = _useState12[1];
  var ariaDescribedbyIds = useMemo(function () {
    switch (true) {
      case !!errorMessage && !!ariaDescribedby:
        return "".concat(ariaDescribedby, " ").concat(errorMessageId);
      case !!errorMessage:
        return errorMessageId;
      default:
        return ariaDescribedby;
    }
  }, [errorMessage, errorMessageId, ariaDescribedby]);
  var labelString = "".concat(label).concat(required ? '*' : '');
  var opacityClass = 'opacity-100';
  var labelClasses;
  switch (labelVisibility) {
    case labelVisibilityState.HIDE:
      labelClasses = 'sr-only';
      break;
    case labelVisibilityState.FLOATING:
      if ((dropdownValue === null || dropdownValue === void 0 ? void 0 : dropdownValue.length) === 0 && !isOpen && !isFocused) {
        opacityClass = 'opacity-0';
      }
      labelClasses = "".concat(labelClasses, " transition duration-350 ease-in-out ").concat(opacityClass);
      break;
  }

  // Classes

  var textColorClassesSmall = classnames({
    'text-dfe3e6': disabled && backgroundVariant === bgVariant.LIGHT,
    'text-6d767c': !disabled && backgroundVariant === bgVariant.LIGHT,
    'text-293033': !disabled && backgroundVariant === bgVariant.STRUCTURE,
    'text-ffffff': !disabled && backgroundVariant === bgVariant.DARK
  });
  var textColorClassesLarge = classnames({
    'text-6d767c': (disabled || dropdownValue.length === 0 && !isOpen && !error) && (backgroundVariant === bgVariant.LIGHT || backgroundVariant === bgVariant.STRUCTURE),
    'text-293033': !disabled && (dropdownValue.length > 0 || isOpen || error) && (backgroundVariant === bgVariant.LIGHT || backgroundVariant === bgVariant.STRUCTURE),
    'text-ffffff': !disabled && (dropdownValue.length > 0 || isOpen || error) && backgroundVariant === bgVariant.DARK
  });
  var backgroundColorClassesLarge = classnames({
    'bg-dfe3e6': disabled && (backgroundVariant === bgVariant.LIGHT || backgroundVariant === bgVariant.STRUCTURE),
    'bg-ffffff': !disabled && (backgroundVariant === bgVariant.LIGHT || backgroundVariant === bgVariant.STRUCTURE)
  });
  var wrapperBorderColorClassesLarge = classnames({
    'border border-ffffff focus-visible:border-18ab42 focus:outline-none': backgroundVariant === bgVariant.LIGHT && !disabled,
    'border border-e8f4f2 focus-visible:border-18ab42 focus:outline-none': backgroundVariant === bgVariant.STRUCTURE && !disabled
  });
  var borderColorClassesLarge = classnames({
    'border-6d767c border group-hover:shadow-green-primary group-hover:border-18ab42 group-focus-visible:shadow-green-primary group-focus-visible:border-18ab42': (backgroundVariant === bgVariant.LIGHT || backgroundVariant === bgVariant.STRUCTURE) && !disabled && !isOpen && !error,
    'border-18ab42 border shadow-green-primary': (backgroundVariant === bgVariant.LIGHT || backgroundVariant === bgVariant.STRUCTURE) && !disabled && isOpen && !error,
    'border-6d767c border': (backgroundVariant === bgVariant.LIGHT || backgroundVariant === bgVariant.STRUCTURE) && disabled,
    'border-eb0047 shadow-red-primary-2': (backgroundVariant === bgVariant.LIGHT || backgroundVariant === bgVariant.STRUCTURE) && error
  });
  var defaultDropdownEntryButtonClasses = classnames({
    'bg-ffffff py-12 px-16 flex flex-row gap-x-20 items-center justify-between group w-full hover:cursor-pointer focus-visible:outline-none focus-visible:bg-eefaea hover:bg-eefaea focus-visible:font-semibold hover:font-semibold': true
  });
  var defaultDropdownClasses = classnames({
    'bg-transparent transition-opacity duration-350 ease-in-out z-10 absolute whitespace-nowrap min-w-full shadow-autocompleteBox rounded-4 overflow-hidden left-0 right-auto ': align === position.LEFT,
    'bg-transparent transition-opacity duration-350 ease-in-out z-10 absolute whitespace-nowrap min-w-full shadow-autocompleteBox rounded-4 overflow-hidden left-auto right-0': align === position.RIGHT,
    '-z-10 opacity-0': !isOpen,
    'z-10 opacity-100': isOpen
  });
  var smallSelectActiveStateClasses = classnames({
    '!text-005e3f': backgroundVariant !== bgVariant.DARK && isOpen,
    '!text-50eb5d': backgroundVariant === bgVariant.DARK && isOpen
  });
  var changeValueSingle = function changeValueSingle(value, label) {
    setDropdownValue([{
      value: value,
      label: label
    }]);
    var event = {
      target: {
        value: value,
        label: label
      }
    };
    onChange(event);
    setIsOpen(false);
    dropdownButtonRef.current.focus();
  };
  var changeValueMultiple = function changeValueMultiple(value, label) {
    var index = dropdownValue.findIndex(function (item) {
      return item.value === value;
    });
    if (index === -1) {
      setDropdownValue([].concat(_toConsumableArray(dropdownValue), [{
        value: value,
        label: label
      }]));
    } else {
      setDropdownValue(dropdownValue.filter(function (item) {
        return item.value !== value;
      }));
    }
    var event = {
      target: {
        value: value,
        label: label
      }
    };
    onChange(event);
  };
  var handleKeyDown = function handleKeyDown(e) {
    var _dropdownRef$current, _dropdownRef$current2, _dropdownRef$current3;
    var focusedOption = dropdownRef === null || dropdownRef === void 0 ? void 0 : (_dropdownRef$current = dropdownRef.current) === null || _dropdownRef$current === void 0 ? void 0 : _dropdownRef$current.querySelector(':focus');
    var firstOption = dropdownRef === null || dropdownRef === void 0 ? void 0 : (_dropdownRef$current2 = dropdownRef.current) === null || _dropdownRef$current2 === void 0 ? void 0 : _dropdownRef$current2.querySelector('button');
    var lastOption = dropdownRef === null || dropdownRef === void 0 ? void 0 : (_dropdownRef$current3 = dropdownRef.current) === null || _dropdownRef$current3 === void 0 ? void 0 : _dropdownRef$current3.querySelector('button:last-child');
    var nextOption = focusedOption ? focusedOption.nextSibling : firstOption;
    var previousOption = focusedOption ? focusedOption.previousSibling : lastOption;
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setIsOpen(true);
        if (nextOption) nextOption.focus();
        break;
      case 'ArrowUp':
        e.preventDefault();
        setIsOpen(true);
        if (previousOption) previousOption.focus();
        break;
      case 'Tab':
      case 'Escape':
        setIsOpen(false);
        dropdownButtonRef.current.focus();
        break;
      case 'Home':
        e.preventDefault();
        setIsOpen(true);
        if (firstOption) firstOption.focus();
        break;
      case 'End':
        e.preventDefault();
        setIsOpen(true);
        if (lastOption) lastOption.focus();
        break;
    }
  };
  var getMultiLabel = function getMultiLabel() {
    return "".concat(placeholder, " ").concat(dropdownValue.length > 0 ? "(".concat(dropdownValue.length, ")") : "");
  };
  var renderSmallSelect = function renderSmallSelect() {
    var _dropdownValue$;
    return /*#__PURE__*/React.createElement(Link$1, {
      ref: dropdownButtonRef,
      type: "button",
      theme: "secondary",
      variant: backgroundVariant,
      title: selectionMode === 'single' ? ((_dropdownValue$ = dropdownValue[0]) === null || _dropdownValue$ === void 0 ? void 0 : _dropdownValue$.label) || placeholder : placeholder,
      onClick: function onClick() {
        setIsOpen(!isOpen);
      },
      onFocus: function onFocus(event) {
        _onFocus(event);
      },
      onBlur: function onBlur(event) {
        _onBlur(event);
      },
      onMouseEnter: function onMouseEnter(event) {
        _onMouseEnter(event);
      },
      onMouseLeave: function onMouseLeave(event) {
        _onMouseLeave(event);
      },
      onKeyDown: handleKeyDown,
      disabled: disabled,
      "aria-label": label,
      "aria-expanded": isOpen,
      beforeTitleSlot: beforeSelectSlot,
      "aria-controls": selectId,
      "aria-describedby": ariaDescribedbyIds,
      showTitle: showTitle,
      className: "".concat(selectClassName, " ").concat(smallSelectHasActiveStateColors ? smallSelectActiveStateClasses : ''),
      icon: /*#__PURE__*/React.createElement(ArrowDown, {
        className: "".concat(textColorClassesSmall, " ").concat(smallSelectHasActiveStateColors ? smallSelectActiveStateClasses : '', " shrink-0 ").concat(isOpen && '-rotate-180', " transform ease-in-out duration-500 fill-current w-16 h-16 shrink-0")
      }),
      iconPosition: iconPosition,
      hasNoFocusOutline: hasNoFocusOutline,
      linkHasUnderline: linkHasUnderline
    });
  };
  var renderLargeSelect = function renderLargeSelect() {
    var _dropdownValue$2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, labelString && /*#__PURE__*/React.createElement("label", {
      htmlFor: "".concat(id, "-button"),
      className: "mb-4 text-12 leading-18 ".concat(labelClasses)
    }, labelString), /*#__PURE__*/React.createElement("button", {
      id: "".concat(id, "-button"),
      ref: dropdownButtonRef,
      disabled: disabled,
      onClick: function onClick() {
        setIsOpen(!isOpen);
      },
      onKeyDown: handleKeyDown,
      onFocus: function onFocus(event) {
        setIsFocused(true);
        _onFocus(event);
      },
      onBlur: function onBlur(event) {
        setIsFocused(false);
        _onBlur(event);
      },
      onMouseEnter: function onMouseEnter(event) {
        _onMouseEnter(event);
      },
      onMouseLeave: function onMouseLeave(event) {
        _onMouseLeave(event);
      },
      className: "w-full relative p-4 -m-4 group transition duration-350 ease-in-out rounded-6 ".concat(wrapperBorderColorClassesLarge, " ").concat(selectClassName),
      "aria-describedby": ariaDescribedbyIds,
      "aria-label": label,
      "aria-expanded": isOpen,
      "aria-controls": selectId
    }, /*#__PURE__*/React.createElement("div", {
      className: "box-border px-16 py-12 text-16 leading-24 flex flex-row gap-x-8 items-center justify-between rounded-4 transition duration-350 ease-in-out ".concat(textColorClassesLarge, " ").concat(backgroundColorClassesLarge, " ").concat(borderColorClassesLarge)
    }, beforeSelectSlot, showTitle && /*#__PURE__*/React.createElement("span", {
      className: "overflow-hidden text-ellipsis whitespace-nowrap"
    }, selectionMode === 'single' ? ((_dropdownValue$2 = dropdownValue[0]) === null || _dropdownValue$2 === void 0 ? void 0 : _dropdownValue$2.label) || placeholder : getMultiLabel()), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row justify-center items-end gap-x-8"
    }, errorMessage && /*#__PURE__*/React.createElement(AlertCircleFilled, {
      className: "\n              w-16 h-16 fill-current text-eb0047 shrink-0\n              transition-opacity duration-350 ease-in-out\n              ".concat(errorMessage && !disabled ? 'opacity-100' : 'opacity-0', "\n            ")
    }), /*#__PURE__*/React.createElement(ArrowDown, {
      className: "".concat(textColorClassesLarge, " shrink-0 ").concat(isOpen && '-rotate-180', " transform ease-in-out duration-500 fill-current w-16 h-16")
    })))));
  };
  var renderSingleSelectionMenu = function renderSingleSelectionMenu() {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(defaultDropdownClasses, " ").concat(dropdownClassName),
      ref: dropdownRef,
      onKeyDown: handleKeyDown,
      role: "listbox",
      id: selectId
    }, options.map(function (option) {
      var _dropdownValue$3;
      return /*#__PURE__*/React.createElement("button", {
        key: option.value,
        className: "".concat(defaultDropdownEntryButtonClasses, " ").concat(optionClassName),
        role: "option",
        onClick: function onClick() {
          changeValueSingle(option.value, option.label);
        },
        "aria-label": option.ariaLabel
      }, /*#__PURE__*/React.createElement("span", {
        "data-label": option.label
      }, option.label), option.value === ((_dropdownValue$3 = dropdownValue[0]) === null || _dropdownValue$3 === void 0 ? void 0 : _dropdownValue$3.value) ? icon ? icon : /*#__PURE__*/React.createElement(Checkmark, {
        className: "w-16 h-16 shrink-0 fill-current text-293033"
      }) : /*#__PURE__*/React.createElement("span", {
        className: "w-16"
      }));
    }));
  };
  var renderMultipleSelectionMenu = function renderMultipleSelectionMenu() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(defaultDropdownClasses, " ").concat(dropdownPositionClasses, " ").concat(dropdownClassName),
      ref: dropdownRef,
      onKeyDown: handleKeyDown,
      role: "listbox"
    }, options.map(function (option) {
      var isOptionSelected = dropdownValue.findIndex(function (item) {
        return item.value === option.value;
      }) >= 0;
      return /*#__PURE__*/React.createElement("button", {
        key: option.value,
        role: "option",
        className: "".concat(defaultDropdownEntryButtonClasses, " ").concat(optionClassName),
        onClick: function onClick() {
          changeValueMultiple(option.value, option.label);
        },
        "aria-label": option.ariaLabel,
        "aria-selected": isOptionSelected
      }, /*#__PURE__*/React.createElement("span", {
        "data-label": option.label
      }, option.label), isOptionSelected ? icon ? icon : /*#__PURE__*/React.createElement(Checkmark, {
        className: "w-16 h-16 shrink-0 fill-current text-293033"
      }) : /*#__PURE__*/React.createElement("span", {
        className: "w-16"
      }));
    })));
  };
  var renderDropdownVariant = function renderDropdownVariant() {
    return /*#__PURE__*/React.createElement("div", null, variant === 'small' ? renderSmallSelect() : renderLargeSelect(), isOpen && (selectionMode === 'single' ? renderSingleSelectionMenu() : renderMultipleSelectionMenu()));
  };
  useEffect(function () {
    setErrorMessage(error);
  }, [error]);

  // Set dropdownValue when defaultValue changes
  useEffect(function () {
    if (defaultValue.length > 0) {
      if (selectionMode === 'multiple') {
        setDropdownValue(defaultValue.map(function (value) {
          var _options$find3;
          return {
            value: value,
            label: (_options$find3 = options.find(function (option) {
              return option.value === value;
            })) === null || _options$find3 === void 0 ? void 0 : _options$find3.label
          };
        }));
      } else {
        var _options$find4;
        setDropdownValue([{
          value: defaultValue[0],
          label: (_options$find4 = options.find(function (option) {
            return option.value === defaultValue[0];
          })) === null || _options$find4 === void 0 ? void 0 : _options$find4.label
        }]);
      }
    } else {
      setDropdownValue([]);
    }
  }, [defaultValue, options, selectionMode]);

  // Close Dropdown when clicking outside
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (dropdownRef !== null && dropdownRef !== void 0 && dropdownRef.current && !(dropdownRef !== null && dropdownRef !== void 0 && dropdownRef.current.contains(event.target)) && !(dropdownButtonRef !== null && dropdownButtonRef !== void 0 && dropdownButtonRef.current.contains(event.target))) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    dropdownPositionClasses = _useState14[0],
    setDropdownPositionClasses = _useState14[1];

  // Handle Dropdownmenu position
  useLayoutEffect(function () {
    var handleScroll = function handleScroll() {
      var dropdownButton = dropdownButtonRef.current;
      var DropdownRect = dropdownButton.getBoundingClientRect();
      var windowHeight = window.innerHeight;
      var scrollTop = window.scrollY || window.pageYOffset;
      var buttonTop = DropdownRect.top + scrollTop;
      var buttonHeight = DropdownRect.height;
      var distanceBetweenSelectAndOptions = 12;
      var optionHeight = 48;
      var optionsCount = options.length;
      if (buttonTop + buttonHeight - scrollTop > windowHeight / 2) {
        if (buttonHeight + distanceBetweenSelectAndOptions + optionHeight * optionsCount > windowHeight / 2) {
          setDropdownPositionClasses('bottom-full h-320 overflow-y-scroll');
        } else {
          setDropdownPositionClasses('bottom-full');
        }
      } else {
        if (buttonHeight + distanceBetweenSelectAndOptions + optionHeight * optionsCount > windowHeight / 2) {
          setDropdownPositionClasses('top-full h-320 overflow-y-scroll');
        } else {
          setDropdownPositionClasses('top-full');
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  // focus dropdown when opening it
  useEffect(function () {
    if (isOpen) {
      var _dropdownRef$current4;
      var firstOption = dropdownRef === null || dropdownRef === void 0 ? void 0 : (_dropdownRef$current4 = dropdownRef.current) === null || _dropdownRef$current4 === void 0 ? void 0 : _dropdownRef$current4.querySelector('button');
      if (firstOption) {
        firstOption.focus();
      }
    }
  }, [isOpen]);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "".concat(className, " dropdown-floating inline-flex flex-col items-start")
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative w-full"
  }, renderDropdownVariant()), errorMessage && /*#__PURE__*/React.createElement("span", {
    id: errorMessageId,
    className: "text-12 leading-16 text-eb0047 mt-4",
    "aria-live": "assertive"
  }, errorMessage));
};
DropdownFloating.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  dropdownClassName: PropTypes.string,
  optionClassName: PropTypes.string,
  beforeSelectSlot: PropTypes.node,
  icon: PropTypes.node,
  showTitle: PropTypes.bool,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    props: PropTypes.object
  })),
  selectionMode: PropTypes.oneOf(['single', 'multiple']),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onBlur: PropTypes.func,
  ariaDescribedby: PropTypes.string,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  settings: PropTypes.shape({
    backgroundVariant: PropTypes.oneOf(Object.values(bgVariant)),
    variant: PropTypes.oneOf(['small', 'large']),
    align: PropTypes.oneOf(Object.values(position)),
    iconPosition: PropTypes.oneOf(['left', 'right', 'right_space_between']),
    hasNoFocusOutline: PropTypes.bool
  })
};
DropdownFloating.defaultProps = {
  className: '',
  dropdownClassName: '',
  placeholder: 'Placeholder wurde nicht gesetzt',
  defaultValue: [],
  options: [{
    value: '0',
    label: 'Options wurden nicht gesetzt',
    iconPosition: 'right'
  }],
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  settings: {
    backgroundVariant: bgVariant.LIGHT,
    variant: 'small',
    align: position.LEFT,
    iconPosition: 'right',
    hasNoFocusOutline: false
  },
  selectionMode: 'single',
  label: '',
  labelVisibility: labelVisibilityState.HIDE,
  required: false,
  showTitle: true,
  optionClassName: '',
  selectClassName: ''
};
var DropdownFloating$1 = DropdownFloating;

var StatusNotification = function StatusNotification(_ref) {
  var variant = _ref.variant,
    theme = _ref.theme,
    message = _ref.message,
    isSimpleText = _ref.isSimpleText,
    className = _ref.className,
    showIcon = _ref.showIcon;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  if (!isVisible) return null;
  var variantClasses = '';
  var icon;
  switch (variant) {
    case StatusNotificationVariant.INFO:
      if (theme === bgVariant.LIGHT || theme === bgVariant.STRUCTURE) {
        icon = /*#__PURE__*/React.createElement(InfoCircleFilled, {
          className: "w-20 h-20 shrink-0 text-40484d fill-current"
        });
        variantClasses = 'border-40484d text-293033 bg-ffffff';
      } else {
        icon = /*#__PURE__*/React.createElement(InfoCircleFilled, {
          className: "w-20 h-20 shrink-0 fill-current"
        });
        variantClasses = 'border-ffffff text-ffffff';
      }
      break;
    case StatusNotificationVariant.ERROR:
      if (theme === bgVariant.LIGHT || theme === bgVariant.STRUCTURE) {
        icon = /*#__PURE__*/React.createElement(AlertCircleFilled, {
          className: "w-20 h-20 shrink-0 text-eb0047 fill-current"
        });
        variantClasses = 'border-eb0047 text-293033 bg-ffffff';
      } else {
        icon = /*#__PURE__*/React.createElement(AlertCircleFilled, {
          className: "w-20 h-20 shrink-0 fill-f580a3"
        });
        variantClasses = 'border-f580a3 text-ffffff';
      }
      break;
    case StatusNotificationVariant.SUCCESS:
      if (theme === bgVariant.LIGHT || theme === bgVariant.STRUCTURE) {
        icon = /*#__PURE__*/React.createElement(CheckmarkCircleFilled, {
          className: "w-20 h-20 shrink-0 text-18ab42 fill-current"
        });
        variantClasses = 'border-18ab42 text-293033 bg-ffffff';
      } else {
        icon = /*#__PURE__*/React.createElement(CheckmarkCircleFilled, {
          className: "w-20 h-20 shrink-0 fill-50eb5d"
        });
        variantClasses = 'border-50eb5d text-ffffff';
      }
      break;
  }
  function isReactElement(element) {
    return /*#__PURE__*/React.isValidElement(element);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(variantClasses, " ").concat(className, " border-l-4 border-t border-r border-b rounded-4 pl-20 pr-23 py-23 flex items-start w-full")
  }, showIcon && icon, isSimpleText ? /*#__PURE__*/React.createElement("p", {
    className: "".concat(showIcon && icon ? 'ml-16 mr-20' : '', " text-16 leading-24 text-left")
  }, message) : isReactElement(message) ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(showIcon && icon ? 'ml-16 mr-20' : '', " text-16 leading-24 text-left")
  }, message) : /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: message
    },
    className: "".concat(showIcon && icon ? 'ml-16 mr-20' : '', " text-16 leading-24 text-left")
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setIsVisible(false);
    },
    className: "relative",
    "aria-label": "Benachrichtigung schlie\xDFen"
  }, /*#__PURE__*/React.createElement(Close, {
    className: "absolute top-23 right-23 w-16 h-16 transition ease-in-out duration-350 ".concat(theme === bgVariant.DARK ? 'fill-ffffff hover:scale-125 ' : 'fill-6d767c hover:scale-125')
  })));
};
StatusNotification.propTypes = {
  variant: PropTypes.oneOf([StatusNotificationVariant.INFO, StatusNotificationVariant.ERROR, StatusNotificationVariant.SUCCESS]),
  theme: PropTypes.oneOf([bgVariant.LIGHT, bgVariant.DARK, bgVariant.STRUCTURE]),
  isSimpleText: PropTypes.bool,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  showIcon: PropTypes.bool
};
StatusNotification.defaultProps = {
  className: '',
  isSimpleText: true,
  message: 'Text nicht gesetzt',
  variant: StatusNotificationVariant.INFO,
  theme: bgVariant.LIGHT,
  showIcon: true
};
var StatusNotification$1 = StatusNotification;

var ErrorView = function ErrorView(_ref) {
  var onClick = _ref.onClick,
    className = _ref.className,
    id = _ref.id,
    description = _ref.description,
    descriptionRTE = _ref.descriptionRTE,
    contactLink = _ref.contactLink,
    shortNotice = _ref.shortNotice,
    reloadLabel = _ref.reloadLabel,
    resultErrorClassName = _ref.resultErrorClassName,
    textClassName = _ref.textClassName,
    buttonClassName = _ref.buttonClassName,
    linkBtnContainerClassName = _ref.linkBtnContainerClassName,
    testId = _ref.testId,
    attributes = _ref.attributes;
  var errorMessage = descriptionRTE ? descriptionRTE : shortNotice;
  return /*#__PURE__*/React.createElement("div", _extends$1({
    id: id,
    className: "".concat(className),
    "data-cy": testId
  }, attributes), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StatusNotification$1, {
    variant: "error",
    message: errorMessage,
    isSimpleText: !descriptionRTE
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(resultErrorClassName)
  }, description && /*#__PURE__*/React.createElement("p", {
    className: "mt-24 text-40484d text-16 leading-24 ".concat(textClassName)
  }, description), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start ".concat(linkBtnContainerClassName)
  }, contactLink && /*#__PURE__*/React.createElement(Link$1, _extends$1({
    title: contactLink.title,
    href: contactLink.url,
    theme: "primary",
    variant: "light",
    className: "mt-16",
    icon: contactLink.target === '_blank' ? /*#__PURE__*/React.createElement(ArrowRoundedRightup, {
      className: "w-16 h-16 fill-current"
    }) : /*#__PURE__*/React.createElement(ArrowRoundedRight, {
      className: "w-16 h-16 fill-current"
    })
  }, contactLink)), /*#__PURE__*/React.createElement(PrimaryButton$1, {
    onClick: onClick,
    className: "inline-block w-full mx-auto 600:w-auto 600:mx-0 ".concat(description ? 'mt-32 600:mt-40' : 'mt-40 1280:mt-48', " ").concat(buttonClassName)
  }, reloadLabel)))));
};
ErrorView.propTypes = {
  onClick: PropTypes.func,
  reloadLabel: PropTypes.string,
  description: PropTypes.string,
  descriptionRTE: PropTypes.string,
  contactLink: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
    target: PropTypes.string
  }),
  shortNotice: PropTypes.string,
  className: PropTypes.string,
  resultErrorClassName: PropTypes.string,
  textClassName: PropTypes.string,
  buttonClassName: PropTypes.string,
  linkBtnContainerClassName: PropTypes.string,
  testId: PropTypes.string
};
ErrorView.defaultProps = {
  onClick: function onClick() {
    var _window, _window$location;
    return (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.reload();
  },
  reloadLabel: 'Kein Button-Label gesetzt',
  shortNotice: 'Kein Fehlertext gesetzt',
  className: '',
  resultErrorClassName: '',
  textClassName: '',
  buttonClassName: '',
  linkBtnContainerClassName: ''
};
var ErrorView$1 = ErrorView;

var InteractiveElementsBoxShadowWrapper = function InteractiveElementsBoxShadowWrapper(_ref) {
  var className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " flex flex-col bg-ffffff pt-12 px-16 pb-16\n        shadow-overlay rounded-4\n        600:pt-20 600:px-24 600:pb-24\n        1000:flex-row 1000:pl-16 1000:py-12 1000:pr-12\n      ")
  }, children);
};
InteractiveElementsBoxShadowWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
InteractiveElementsBoxShadowWrapper.defaultProps = {
  className: ''
};
var InteractiveElementsBoxShadowWrapper$1 = InteractiveElementsBoxShadowWrapper;

function scrollSmoothTo(targetId, offset = 0) {
  if (!targetId) {
    return;
  }
  const bodyRect = document.body.getBoundingClientRect().top;
  const id = getElementId(targetId);
  const element = document.getElementById(id);
  if (!!element && !!window) {
    const elementRect = element.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - offset;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
}
const getElementId = targetId => {
  if (targetId.match(/#/)) {
    return targetId.substring(targetId.indexOf('#') + 1);
  }
  return targetId;
};

var _excluded$6 = ["title", "variant", "disabled", "targetId", "offset", "className", "iconPosition", "arrowDirection", "onClick", "iconClassName"];
var JumpLink = function JumpLink(_ref) {
  var title = _ref.title,
    variant = _ref.variant,
    disabled = _ref.disabled,
    targetId = _ref.targetId,
    offset = _ref.offset,
    className = _ref.className,
    iconPosition = _ref.iconPosition,
    arrowDirection = _ref.arrowDirection,
    _onClick = _ref.onClick,
    iconClassName = _ref.iconClassName,
    rest = _objectWithoutProperties$1(_ref, _excluded$6);
  var executeScroll = function executeScroll() {
    if (!disabled && targetId) {
      scrollSmoothTo(targetId, offset);
    }
  };
  var Icon = function Icon() {
    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(iconClassName, " w-16 h-16 fill-current transition ease-in-out duration-350 group-hover:scale-125")
    }, arrowDirection === direction.UP ? /*#__PURE__*/React.createElement(ArrowRoundedUp, {
      className: "w-16 h-16"
    }) : /*#__PURE__*/React.createElement(ArrowRoundedDown, {
      className: "w-16 h-16"
    }));
  };
  return /*#__PURE__*/React.createElement(Link$1, _extends$1({
    href: disabled ? null : targetId,
    onClick: function onClick(e) {
      if (targetId) {
        e.preventDefault();
        executeScroll();
      } else if (_onClick) _onClick(e);
    },
    icon: /*#__PURE__*/React.createElement(Icon, null),
    title: title,
    theme: "primary",
    variant: variant,
    disabled: disabled,
    iconPosition: iconPosition,
    className: "jumpLink ".concat(className)
  }, rest));
};
JumpLink.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  targetId: PropTypes.string,
  offset: PropTypes.number,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  variant: PropTypes.oneOf(Object.values(bgVariant)),
  iconPosition: PropTypes.oneOf(Object.values(position)),
  arrowDirection: PropTypes.oneOf(Object.values(direction)),
  onClick: PropTypes.func
};
JumpLink.defaultProps = {
  className: '',
  iconClassName: '',
  disabled: false,
  variant: bgVariant.LIGHT,
  title: 'Titel nicht gesetzt',
  iconPosition: position.RIGHT,
  arrowDirection: direction.UP
};
var JumpLink$1 = JumpLink;

var textSizeVariant = {
  SMALL: 'small',
  LARGE: 'large'
};
var LoadingView = function LoadingView(_ref) {
  var text = _ref.text,
    textSize = _ref.textSize,
    className = _ref.className,
    testId = _ref.testId;
  var textClasses = classnames('font-buenos-aires-text font-regular', {
    'text-14 leading-20': textSize === textSizeVariant.SMALL,
    'text-16 leading-24': textSize === textSizeVariant.LARGE
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-y-16 items-center justify-center text-828b91 ".concat(className),
    "data-cy": testId
  }, /*#__PURE__*/React.createElement(Load, {
    className: "loading-icon w-20 h-20 fill-current animate-spin"
  }), /*#__PURE__*/React.createElement("span", {
    className: textClasses
  }, text));
};
LoadingView.propTypes = {
  text: PropTypes.string,
  textSize: PropTypes.oneOf([textSizeVariant.SMALL, textSizeVariant.LARGE]),
  className: PropTypes.string,
  testId: PropTypes.string
};
LoadingView.defaultProps = {
  text: 'Ergebnisse werden geladen',
  textSize: textSizeVariant.LARGE,
  className: ''
};
var LoadingView$1 = LoadingView;

var positionFlag = {
  MIDDLE: 'middle',
  LEFT: 'left',
  RIGHT: 'right'
};
var NumberedPaginationLong = function NumberedPaginationLong(_ref) {
  var className = _ref.className,
    count = _ref.count,
    current = _ref.current,
    onChangeCallback = _ref.onChangeCallback,
    variant = _ref.variant,
    id = _ref.id,
    staticLabels = _ref.staticLabels,
    testId = _ref.testId;
  var navigateForward = function navigateForward() {
    if (current < count) {
      onChangeCallback(current + 1, 'forward');
    }
  };
  var navigateBackward = function navigateBackward() {
    if (current > 1) {
      onChangeCallback(current - 1, 'backward');
    }
  };
  var navClasses = classnames('transition-all focus-visible:shadow-green-outline group', {
    'text-6d767c hover:text-18ab42 focus-visible:text-18ab42': variant === bgVariant.LIGHT || bgVariant.STRUCTURE,
    'text-ffffff hover:text-50eb5d focus-visible:text-50eb5d': variant === bgVariant.DARK
  });
  var disabledNavClasses = classnames({
    'text-afb6bc': variant === bgVariant.LIGHT || bgVariant.STRUCTURE,
    'text-c7ccd1': variant === bgVariant.DARK
  });
  var textClasses = classnames('focus-visible:shadow-green-outline', {
    'text-6d767c hover:text-18ab42 focus-visible:text-18ab42': variant === bgVariant.LIGHT,
    'text-293033 hover:text-18ab42 focus-visible:text-18ab42': variant === bgVariant.STRUCTURE,
    'text-ffffff hover:text-50eb5d focus-visible:text-50eb5d': variant === bgVariant.DARK
  });
  var dotsClasses = classnames({
    'text-6d767c': variant === bgVariant.LIGHT || bgVariant.STRUCTURE,
    'text-ffffff': variant === bgVariant.DARK
  });
  var activeTextClasses = classnames('focus:shadow-none', {
    'text-18ab42': variant === bgVariant.LIGHT || bgVariant.STRUCTURE,
    'text-50eb5d': variant === bgVariant.DARK
  });
  var borderClasses = classnames('inline-block align-middle group-hover:border-b h-23', {
    'border-18ab42': variant === bgVariant.LIGHT || bgVariant.STRUCTURE,
    'border-50eb5d': variant === bgVariant.DARK
  });
  var renderPagination = function renderPagination() {
    var flag;
    var pagination = [];
    if (count > 5) {
      if (current > 3 && current < count - 2) {
        flag = positionFlag.MIDDLE;
        for (var i = current - 2; i <= current + 2; i++) {
          pagination.push(i);
        }
      } else if (current > 3 && current >= count - 2) {
        flag = positionFlag.LEFT;
        for (var _i = count - 4; _i <= count; _i++) {
          pagination.push(_i);
        }
      } else {
        flag = positionFlag.RIGHT;
        for (var _i2 = 1; _i2 <= 5; _i2++) {
          pagination.push(_i2);
        }
      }
    } else {
      for (var _i3 = 1; _i3 <= count; _i3++) {
        pagination.push(_i3);
      }
    }
    var renderDots = function renderDots() {
      return /*#__PURE__*/React.createElement("button", {
        tabIndex: "-1",
        disabled: true,
        className: "".concat(dotsClasses, " w-30 h-30 self-center inline-block align-middle cursor-default")
      }, "...");
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, (positionFlag.LEFT === flag || positionFlag.MIDDLE === flag) && renderDots(), pagination.map(function (i, index) {
      return /*#__PURE__*/React.createElement("button", {
        key: "".concat(id, "-").concat(i),
        onClick: function onClick() {
          return onChangeCallback(i);
        },
        title: "Navigation zur Seite ".concat(i),
        "aria-label": "Navigation zur Seite ".concat(i),
        tabIndex: "".concat(i === current ? -1 : 0),
        className: "".concat(i === current ? activeTextClasses : textClasses, " ").concat(index === pagination.length ? 'mr-0' : 'mr-4', " transition-all self-center w-30 h-30 rounded-3 focus:outline-0 group font-semibold")
      }, /*#__PURE__*/React.createElement("span", {
        className: "block ".concat(borderClasses)
      }, i));
    }), (positionFlag.RIGHT === flag || positionFlag.MIDDLE === flag) && renderDots());
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, count > 0 && current > 0 && /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " flex"),
    "data-cy": testId
  }, /*#__PURE__*/React.createElement("button", {
    className: "".concat(current === 1 ? disabledNavClasses : navClasses, " w-30 h-30 mr-2 rounded-3 outline-0"),
    disabled: current === 1 ? true : '',
    onClick: navigateBackward,
    title: staticLabels.paginationLeftTitle,
    "aria-label": staticLabels.paginationLeftTitle
  }, /*#__PURE__*/React.createElement(ArrowRoundedLeft, {
    className: "w-16 h-16\n              ".concat(current - 1 === 0 ? '' : 'group-hover:scale-125 group-focus-visible:scale-125', " fill-current transition-all ml-6")
  })), renderPagination(), /*#__PURE__*/React.createElement("button", {
    className: "".concat(current === count ? disabledNavClasses : navClasses, " w-30 h-30 rounded-3 ml-2 outline-0"),
    onClick: navigateForward,
    title: staticLabels.paginationRightTitle,
    "aria-label": staticLabels.paginationRightTitle,
    disabled: current === count ? true : ''
  }, /*#__PURE__*/React.createElement(ArrowRoundedRight, {
    className: "w-16 h-16 fill-current transition-all group-hover:scale-125 group-focus-visible:scale-125 ml-6"
  }))));
};
NumberedPaginationLong.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  onChangeCallback: PropTypes.func,
  count: PropTypes.number,
  current: PropTypes.number,
  id: PropTypes.string,
  staticLabels: PropTypes.shape({
    paginationLeftTitle: PropTypes.string,
    paginationRightTitle: PropTypes.string,
    paginationDotTitle: PropTypes.string
  }),
  testId: PropTypes.string
};
NumberedPaginationLong.defaultProps = {
  className: '',
  variant: bgVariant.LIGHT,
  onChangeCallback: function onChangeCallback() {},
  id: 'clickable-numbered-pagination',
  staticLabels: {
    paginationLeftTitle: 'Navigation zur vorherigen Seite',
    paginationRightTitle: 'Navigation zur nächsten Seite',
    paginationDotTitle: 'Navigation zu Seite'
  }
};
var NumberedPaginationLong$1 = NumberedPaginationLong;

function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }
  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement(element) ? getWindow(element) : window,
    visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument :
  // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
    overflow = _getComputedStyle.overflow,
    overflowX = _getComputedStyle.overflowX,
    overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' ||
    // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }
  return (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot ||
    // step into the shadow DOM of the parent of a slotted node
    element.parentNode || (
    // DOM Element detected
    isShadowRoot(element) ? element.host : null) ||
    // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback
  );
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList :
  // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) ||
  // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }
  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block

function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);
    if (elementCss.position === 'fixed') {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.

function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }
    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      } // $FlowFixMe[prop-missing]: need a better way to handle this...

      next = next.parentNode || next.host;
    } while (next);
  } // Give up, the result is false

  return false;
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`

function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414

  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents

function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

function getVariation(placement) {
  return placement.split('-')[1];
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
    element = _ref.element,
    placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$placement = _options.placement,
    placement = _options$placement === void 0 ? state.placement : _options$placement,
    _options$strategy = _options.strategy,
    strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
    _options$boundary = _options.boundary,
    boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
    _options$rootBoundary = _options.rootBoundary,
    rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
    _options$elementConte = _options.elementContext,
    elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
    _options$altBoundary = _options.altBoundary,
    altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
    _options$padding = _options.padding,
    padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }
  return overflowOffsets;
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions,
    _generatorOptions$def = _generatorOptions.defaultModifiers,
    defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
    _generatorOptions$def2 = _generatorOptions.defaultOptions,
    defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements,
          reference = _state$elements.reference,
          popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers

        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index],
            fn = _state$orderedModifie.fn,
            _state$orderedModifie2 = _state$orderedModifie.options,
            _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
            name = _state$orderedModifie.name;
          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference, popper)) {
      return instance;
    }
    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
          _ref$options = _ref.options,
          options = _ref$options === void 0 ? {} : _ref$options,
          effect = _ref.effect;
        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });
          var noopFn = function noopFn() {};
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}

var passive = {
  passive: true
};
function effect$2(_ref) {
  var state = _ref.state,
    instance = _ref.instance,
    options = _ref.options;
  var _options$scroll = options.scroll,
    scroll = _options$scroll === void 0 ? true : _options$scroll,
    _options$resize = options.resize,
    resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }
  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }
  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }
    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules

var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect$2,
  data: {}
};

function popperOffsets(_ref) {
  var state = _ref.state,
    name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules

var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
    y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper = _ref2.popper,
    popperRect = _ref2.popperRect,
    placement = _ref2.placement,
    variation = _ref2.variation,
    offsets = _ref2.offsets,
    position = _ref2.position,
    gpuAcceleration = _ref2.gpuAcceleration,
    adaptive = _ref2.adaptive,
    roundOffsets = _ref2.roundOffsets,
    isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
    x = _offsets$x === void 0 ? 0 : _offsets$x,
    _offsets$y = offsets.y,
    y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';
    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);
      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height :
      // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width :
      // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state,
    options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
    gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
    _options$adaptive = options.adaptive,
    adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
    _options$roundOffsets = options.roundOffsets,
    roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules

var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]

    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];
      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}
function effect$1(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules

var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$1,
  requires: ['computeStyles']
};

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1];

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    placement = _options.placement,
    boundary = _options.boundary,
    rootBoundary = _options.rootBoundary,
    padding = _options.padding,
    flipVariations = _options.flipVariations,
    _options$allowedAutoP = _options.allowedAutoPlacements,
    allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...

  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
    specifiedFallbackPlacements = options.fallbackPlacements,
    padding = options.padding,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    _options$flipVariatio = options.flipVariations,
    flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
    allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];
  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);
        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break") break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules

var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state,
    name = _ref.name,
    options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';
  if (!arrowElement || !popperOffsets) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
  var state = _ref2.state,
    options = _ref2.options;
  var _options$element = options.element,
    arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
  if (arrowElement == null) {
    return;
  } // CSS selector

  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules

var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    padding = options.padding,
    _options$tether = options.tether,
    tether = _options$tether === void 0 ? true : _options$tether,
    _options$tetherOffset = options.tetherOffset,
    tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === 'x' ? top : left;
    var _altSide = mainAxis === 'x' ? bottom : right;
    var _offset = popperOffsets[altAxis];
    var _len = altAxis === 'y' ? 'height' : 'width';
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules

var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
      placement: placement
    })) : offset,
    skidding = _ref[0],
    distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state,
    options = _ref2.options,
    name = _ref2.name;
  var _options$offset = options.offset,
    offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
    x = _data$state$placement.x,
    y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules

var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

var _excluded$5 = ["children", "headline", "textContent", "image", "button", "id", "variant", "isError", "hasContentSize", "placement", "className", "forceVisibility", "margin", "overflowPadding", "innerClassName", "ariaLabel", "ariaLabelPopOverButton", "popOverButtonTitle", "ariaDescribedBy", "isCloseable"];
var visibilityState = {
  SHOW: 'show',
  HIDE: 'hide'
};
var Popover = function Popover(_ref) {
  var children = _ref.children,
    headline = _ref.headline,
    textContent = _ref.textContent,
    image = _ref.image,
    button = _ref.button,
    id = _ref.id,
    variant = _ref.variant,
    isError = _ref.isError,
    hasContentSize = _ref.hasContentSize,
    placement = _ref.placement,
    className = _ref.className,
    forceVisibility = _ref.forceVisibility,
    margin = _ref.margin,
    overflowPadding = _ref.overflowPadding,
    innerClassName = _ref.innerClassName,
    ariaLabel = _ref.ariaLabel,
    ariaLabelPopOverButton = _ref.ariaLabelPopOverButton,
    popOverButtonTitle = _ref.popOverButtonTitle,
    ariaDescribedBy = _ref.ariaDescribedBy,
    isCloseable = _ref.isCloseable,
    rest = _objectWithoutProperties$1(_ref, _excluded$5);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    tooltipAttributeList = _useState2[0],
    setTooltipAttributeList = _useState2[1];
  var triggerRef = useRef(null);
  var isClickedRef = useRef(false);
  var tooltipRef = useRef(null);
  var arrowRef = useRef(null);
  var popper;
  var triggerRefValue;
  var show = useCallback(function () {
    if (forceVisibility === visibilityState.HIDE) return;

    // Make the tooltip visible
    setTooltipAttributeList({
      'data-show': ''
    });

    // Enable the event listeners
    popper.setOptions({
      modifiers: [{
        name: 'eventListeners',
        enabled: true
      }]
    });

    // Update its position
    // Timeout workaround since React 18 update, popperjs no longer maintained,
    // couldn't figure out why popover positioning is initially off, while reference was correct
    // I hate it, you should too
    setTimeout(function () {
      popper.update();
    }, 1);
  }, [forceVisibility, setTooltipAttributeList]);
  var hide = useCallback(function () {
    if (forceVisibility === visibilityState.SHOW) return;
    if (!isClickedRef.current) {
      // Hide the tooltip
      setTooltipAttributeList({});

      // Disable the event listeners
      popper.setOptions({
        modifiers: [{
          name: 'eventListeners',
          enabled: false
        }]
      });
    }
  }, [forceVisibility, setTooltipAttributeList]);

  // checks if mouse has clicked inside bounding rect
  var intersect = function intersect(clientX, clientY, boundingRect) {
    return boundingRect.right > clientX && boundingRect.top < clientY && boundingRect.left < clientX && boundingRect.bottom > clientY;
  };
  useEffect(function () {
    var createPopper = popperGenerator({
      defaultModifiers: [].concat(_toConsumableArray(defaultModifiers), [_objectSpread2$1(_objectSpread2$1({}, flip$1), {}, {
        options: {
          fallbackPlacements: ['top', 'bottom']
        }
      }), _objectSpread2$1(_objectSpread2$1({}, arrow$1), {}, {
        options: _objectSpread2$1(_objectSpread2$1({}, arrow$1.options), {}, {
          padding: '16 16 16 16',
          element: arrowRef.current
        })
      }), _objectSpread2$1(_objectSpread2$1({}, preventOverflow$1), {}, {
        options: {
          padding: overflowPadding
        }
      }), _objectSpread2$1(_objectSpread2$1({}, offset$1), {}, {
        options: {
          offset: margin
        }
      })])
    });
    var handleRefClick = function handleRefClick(e) {
      var _triggerRef$current;
      var popperIsVisible = ((_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.getAttribute('aria-expanded')) === 'true';
      if (popperIsVisible && !isCloseable) {
        e.stopPropagation();
        hide();
      } else {
        e.stopPropagation();
        show();
      }
    };
    var handleRefKeyDown = function handleRefKeyDown(e) {
      if (e.key === 'Enter' || e.code === 'Space') {
        e.preventDefault();
        show();
      } else if (e.key === 'Escape' && !isCloseable) {
        e.preventDefault();
        hide();
      }
    };
    var handleClick = function handleClick(e) {
      if (triggerRef !== null && triggerRef !== void 0 && triggerRef.current) {
        var bR = triggerRef.current.getBoundingClientRect();
        if (intersect(e.clientX, e.clientY, bR)) {
          isClickedRef.current = true;
        } else if (e.detail === 0 && triggerRef.current.contains(e.target)) {
          // if space or enter was hit
          if (isClickedRef.current && !isCloseable) {
            isClickedRef.current = false;
            hide(popper);
          } else {
            isClickedRef.current = true;
            show(popper);
          }
        } else {
          isClickedRef.current = false;
          hide(popper);
        }
      }
    };
    if (triggerRef.current) {
      popper = createPopper(triggerRef.current, tooltipRef.current, {
        placement: placement
      });
      if (!forceVisibility && !isCloseable) {
        triggerRef.current.addEventListener('click', handleRefClick);
        triggerRef.current.addEventListener('keydown', handleRefKeyDown);
        document.body.addEventListener('click', hide);
        document.addEventListener('click', handleClick);
        triggerRefValue = triggerRef.current;
      }
      if (isCloseable) {
        triggerRef.current.addEventListener('click', handleRefClick);
        // triggerRef.current.addEventListener('keydown', handleRefKeyDown)
        // document.addEventListener('click', handleClick)
        triggerRefValue = triggerRef.current;
      }
    }

    // allow overwriting of show/hide mechanism
    if (forceVisibility === visibilityState.SHOW) show(popper);
    if (forceVisibility === visibilityState.HIDE) hide(popper);
    return function () {
      if (triggerRefValue) {
        triggerRefValue.removeEventListener('click', handleRefClick);
        triggerRefValue.removeEventListener('keydown', handleRefKeyDown);
        document.removeEventListener('click', handleClick);
        document.body.removeEventListener('click', hide);
      }
    };
  }, [margin, placement, forceVisibility, hide, show]);
  var popoverClasses = classnames({
    'bg-ffffff border-18ab42 text-40484d': variant === bgVariant.LIGHT && !isError,
    'bg-005e3f border-50eb5d text-ffffff': variant === bgVariant.DARK && !isError,
    'bg-eb0047 border-eb0047 text-ffffff': isError
  });
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("button", _extends$1({
    className: innerClassName,
    "aria-label": ariaLabelPopOverButton,
    ref: triggerRef,
    "aria-expanded": 'data-show' in tooltipAttributeList,
    title: popOverButtonTitle,
    type: "button",
    "aria-describedby": ariaDescribedBy
  }, rest), children), /*#__PURE__*/React.createElement("div", _extends$1({
    ref: tooltipRef
  }, tooltipAttributeList, {
    id: id,
    role: "tooltip",
    "aria-label": ariaLabel,
    className: "\n          popover ".concat(isError && 'errorPopover', "\n          ").concat(hasContentSize ? 'w-full' : 'w-screen 720:w-348', "\n          relative z-30\n        ")
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(variant === bgVariant.LIGHT ? 'bgLight' : 'bgDark', " arrow-popover"),
    ref: arrowRef,
    "data-popper-arrow": true
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner-arrow"
  })), /*#__PURE__*/React.createElement("div", {
    className: "border-2 rounded-4 p-16 ".concat(popoverClasses, " ").concat(hasContentSize ? '' : 'mx-16 720:mx-0')
  }, isCloseable && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row"
  }, /*#__PURE__*/React.createElement("div", null, headline && isCloseable && /*#__PURE__*/React.createElement("div", {
    className: "popover-headline flex justify-between text-16 mb-8 leading-24 font-semibold"
  }, /*#__PURE__*/React.createElement("span", null, headline), "  "), headline && !isCloseable && /*#__PURE__*/React.createElement("div", {
    className: "popover-headline flex justify-between text-16 mb-8 leading-24 font-semibold"
  }, headline), textContent && /*#__PURE__*/React.createElement("div", {
    className: "popover-text text-16 leading-24"
  }, textContent)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Close, {
    onClick: function onClick() {
      setTooltipAttributeList({});
    },
    className: "fill-6d767c w-[15.3px] h-[15.3px]"
  }))), !isCloseable && /*#__PURE__*/React.createElement("div", null, headline && isCloseable && /*#__PURE__*/React.createElement("div", {
    className: "popover-headline flex justify-between text-16 mb-8 leading-24 font-semibold"
  }, /*#__PURE__*/React.createElement("span", null, headline), "  "), headline && !isCloseable && /*#__PURE__*/React.createElement("div", {
    className: "popover-headline flex justify-between text-16 mb-8 leading-24 font-semibold"
  }, headline), textContent && /*#__PURE__*/React.createElement("div", {
    className: "popover-text text-16 leading-24"
  }, textContent), " "), image && /*#__PURE__*/React.createElement("div", {
    className: "mt-16"
  }, /*#__PURE__*/React.createElement(Picture, image)), button && /*#__PURE__*/React.createElement("div", {
    className: "mt-16"
  }, /*#__PURE__*/React.createElement(PrimaryButton$1, button)))));
};
Popover.propTypes = {
  variant: PropTypes.oneOf(Object.values(bgVariant)),
  isError: PropTypes.bool,
  hasContentSize: PropTypes.bool,
  className: PropTypes.string,
  isCloseable: PropTypes.bool,
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  headline: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  textContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  image: PropTypes.shape({
    variants: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string,
      breakpoint: PropTypes.number
    })),
    alt: PropTypes.string,
    copyright: PropTypes.string
  }),
  id: PropTypes.string,
  forceVisibility: PropTypes.oneOf(Object.values(visibilityState)),
  margin: PropTypes.arrayOf(PropTypes.number),
  overflowPadding: PropTypes.number,
  innerClassName: PropTypes.string,
  ariaLabel: PropTypes.string,
  ariaLabelPopOverButton: PropTypes.string,
  popOverButtonTitle: PropTypes.string,
  ariaDescribedBy: PropTypes.string
};
Popover.defaultProps = {
  className: '',
  variant: bgVariant.LIGHT,
  isError: false,
  hasContentSize: false,
  placement: 'bottom',
  margin: [0, 16],
  overflowPadding: 0,
  isCloseable: false
};
var Popover$1 = Popover;

var _excluded$4 = ["backgroundVariant", "theme", "variant", "children", "className", "isDisabled", "isLoading", "dataTrackingButtonAction"];
var ButtonTheme$1 = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  PRIMARYFLOATING: 'primaryFloating',
  SECONDARYFLOATING: 'secondaryFloating'
};

/**
 * @type React.FC<PrimaryFloatingButtonPropTypes>
 */
var PrimaryFloatingButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var backgroundVariant = props.backgroundVariant,
    theme = props.theme,
    variant = props.variant,
    children = props.children,
    className = props.className,
    isDisabled = props.isDisabled,
    isLoading = props.isLoading,
    dataTrackingButtonAction = props.dataTrackingButtonAction,
    rest = _objectWithoutProperties$1(props, _excluded$4);
  var wrapChildrenInSpan = function wrapChildrenInSpan(children) {
    return React.Children.map(children, function (child) {
      if ( /*#__PURE__*/React.isValidElement(child)) {
        if (child.type === 'p') {
          return /*#__PURE__*/React.createElement("span", {
            className: "containerSpan"
          }, wrapChildrenInSpan(child.props.children));
        }
        return /*#__PURE__*/React.cloneElement(child, {
          children: wrapChildrenInSpan(child.props.children)
        });
      }
      if (typeof child === 'string' || typeof child === 'number') {
        return /*#__PURE__*/React.createElement("span", null, child);
      }
      return child;
    });
  };
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    backGroundClass = _useState2[0],
    setBackgroundClass = _useState2[1];
  var primaryFloatingClasses = classnames('outline-none rounded-100 focus-visible:ring-1 focus-visible:ring-18ab42 focus-visible:ring-offset-2', {
    'primaryFloatingGreen': backgroundVariant === 'green',
    'primaryFloatingDefault': backgroundVariant !== 'green' && variant !== bgVariant.DARK,
    'baseState': !isDisabled && !isLoading,
    'bg-dfe3e6 text-98a1a6 shadow-[0_2px_8px_rgba(0,0,0,0.04),0_12px_32px_rgba(0,0,0,0.1)]': isDisabled && backgroundVariant !== 'green' && variant !== bgVariant.DARK,
    'bg-586167': isDisabled && variant === bgVariant.DARK,
    'text-004730 hover:bg-ffffff shadow-primaryFloatingButtonHover': !isDisabled && !isLoading,
    'bg-91f54a text-004730 focus-visible:ring-offset-007141 hover:bg-transparent hover:text-ffffff shadow-primaryFloatingButtonHover': !isDisabled && !isLoading && backgroundVariant === 'green',
    'bg-91f54a text-004730 shadow-primaryFloatingButtonHover': backgroundVariant !== 'green' && !isDisabled && isLoading,
    'text-ffffff shadow-primaryFloatingButtonHover focus-visible:ring-offset-005e3f': backgroundVariant === 'green' && !isDisabled && isLoading
  });
  var elementVariants = classnames({
    primary: theme === ButtonTheme$1.PRIMARY,
    secondary: theme === ButtonTheme$1.SECONDARY,
    primaryfloating: theme === ButtonTheme$1.PRIMARYFLOATING,
    secondaryfloating: theme === ButtonTheme$1.SECONDARYFLOATING,
    light: variant === bgVariant.LIGHT,
    dark: variant === bgVariant.DARK,
    structure: variant === bgVariant.STRUCTURE
  });
  var interactivityClasses = classnames({
    // styles for disabled
    'cursor-default ': isDisabled,
    'bg-dfe3e6 text-98a1a6': isDisabled && variant === bgVariant.STRUCTURE,
    'bg-586167 text-98a1a6': isDisabled && variant === bgVariant.DARK,
    // styles for enabled ...
    'group cursor-pointer outline-0': !isDisabled,
    'bg-91f54a text-004730 focus-visible:ring-offset-trasparent': (variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE) && !isDisabled && !isLoading,
    'focus-visible:ring-offset-eefaea': !isDisabled && variant === bgVariant.STRUCTURE,
    'bg-91f54a text-004730 focus-visible:text-004730 focus-visible:ring-offset-007141 shadow-primaryFloatingButtonHover primaryFloatingGreen': !isDisabled && !isLoading && variant === bgVariant.DARK,
    'bg-91f54a text-004730 shadow-primaryFloatingButtonHover': isLoading && variant === bgVariant.DARK && !isDisabled
  });
  return /*#__PURE__*/React.createElement(ButtonPrototype$1, _extends$1({
    ref: ref,
    backgroundVariant: backgroundVariant,
    variant: variant,
    className: "".concat(primaryFloatingClasses, " ").concat(elementVariants, " ").concat(interactivityClasses, " ").concat(className, " ").concat(backGroundClass),
    isDisabled: isDisabled,
    isLoading: isLoading,
    "data-tracking-button-action": dataTrackingButtonAction,
    onMouseEnter: function onMouseEnter() {
      setBackgroundClass('background-animation');
    }
  }, rest), wrapChildrenInSpan(children));
});
var primaryFloatingButtonPropTypes = {
  backgroundVariant: PropTypes.oneOf(['default', 'green']),
  children: PropTypes.node,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  dataTrackingButtonAction: PropTypes.string,
  theme: PropTypes.oneOf(Object.values(ButtonTheme$1)),
  variant: PropTypes.oneOf(Object.values(bgVariant))
};
PrimaryFloatingButton.propTypes = primaryFloatingButtonPropTypes;
PrimaryFloatingButton.defaultProps = {
  backgroundVariant: 'default',
  children: 'Floating Button',
  className: '',
  isDisabled: false,
  isLoading: false,
  dataTrackingButtonAction: null,
  variant: bgVariant.LIGHT
};
var PrimaryFloatingButton$1 = PrimaryFloatingButton;

var RadioIndicator = function RadioIndicator(_ref) {
  var variant = _ref.variant,
    dir = _ref.dir,
    errorMessage = _ref.errorMessage,
    disabled = _ref.disabled,
    className = _ref.className;
  var radioBtnBorder = classnames({
    'error': !disabled && errorMessage,
    'border-828b91': (variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE) && !errorMessage && !disabled,
    'border-transparent': (variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE || variant === bgVariant.DARK) && !errorMessage && disabled,
    'border-98e692': variant === bgVariant.DARK && !disabled
  });
  var radioBtnBackground = classnames({
    'bg-dfe3e6': (variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE) && disabled,
    'bg-ffffff': (variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE) && !disabled,
    'bg-586167': variant === bgVariant.DARK && disabled,
    'bg-005e3f': variant === bgVariant.DARK && !disabled
  });
  var radioBtnInnerColor = classnames({
    'bg-afb6bc': (variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE) && disabled,
    'bg-40484d': (variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE) && !disabled,
    'bg-98a1a6': variant === bgVariant.DARK && disabled,
    'bg-ffffff': variant === bgVariant.DARK && !disabled
  });
  return /*#__PURE__*/React.createElement("span", {
    className: "radio-btn border rounded-12 absolute w-24 h-24\n        ".concat(radioBtnBorder, " \n        ").concat(radioBtnBackground, " \n        ").concat(className, "\n  ")
  }, /*#__PURE__*/React.createElement("span", {
    className: "radio-btn-inner rounded-12 absolute top-6 w-10 h-10\n          ".concat(dir === 'rtl' ? 'right-6' : 'left-6', " \n          ").concat(radioBtnInnerColor, "\n    ")
  }));
};
RadioIndicator.propTypes = {
  variant: PropTypes.oneOf(Object.values(bgVariant)),
  dir: PropTypes.oneOf(['rtl', 'ltr']),
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  disabled: PropTypes.bool,
  className: PropTypes.string
};
RadioIndicator.defaultProps = {
  className: '',
  dir: 'ltr',
  variant: bgVariant.LIGHT
};
var RadioIndicator$1 = RadioIndicator;

var ClickableCardRadioButton = function ClickableCardRadioButton(_ref) {
  var ariaDescribedby = _ref.ariaDescribedby,
    buttonWrapperClassName = _ref.buttonWrapperClassName,
    defaultSelection = _ref.defaultSelection,
    dir = _ref.dir,
    disabled = _ref.disabled,
    errorMessage = _ref.errorMessage,
    globalErrorMessageId = _ref.globalErrorMessageId,
    groupName = _ref.groupName,
    id = _ref.id,
    _onBlur = _ref.onBlur,
    _onChange = _ref.onChange,
    radioButton = _ref.radioButton,
    radioIndex = _ref.radioIndex,
    variant = _ref.variant,
    checked = _ref.checked,
    isEasyLanguagePage = _ref.isEasyLanguagePage;
  var _useState = useState(typeof checked === 'boolean'),
    _useState2 = _slicedToArray(_useState, 1),
    isControlled = _useState2[0];
  var _useState3 = useState(function () {
      return id || createRandomID('radio');
    }),
    _useState4 = _slicedToArray(_useState3, 1),
    radioButtonId = _useState4[0];
  var ariaDescribedbyIds = useMemo(function () {
    switch (true) {
      case !!errorMessage && !!ariaDescribedby:
        return "".concat(ariaDescribedby, " ").concat(globalErrorMessageId);
      case !!errorMessage:
        return globalErrorMessageId;
      default:
        return ariaDescribedby;
    }
  }, [errorMessage, globalErrorMessageId, ariaDescribedby]);
  return /*#__PURE__*/React.createElement("li", {
    className: "".concat(buttonWrapperClassName, " h-full clickable-card-radio-button flex flex-col")
  }, isControlled ? /*#__PURE__*/React.createElement("input", _extends$1({
    id: "".concat(radioButtonId, "-").concat(radioIndex),
    className: "sr-only peer",
    "aria-describedby": ariaDescribedbyIds,
    type: "radio",
    value: radioButton.value,
    checked: checked,
    name: groupName,
    required: radioButton.required,
    onChange: function onChange(event) {
      return _onChange(event);
    },
    onBlur: function onBlur(event) {
      return _onBlur(event);
    },
    disabled: disabled
  }, radioButton.props)) : /*#__PURE__*/React.createElement("input", _extends$1({
    id: "".concat(radioButtonId, "-").concat(radioIndex),
    className: "sr-only peer",
    "aria-describedby": ariaDescribedbyIds,
    type: "radio",
    value: radioButton.value,
    defaultChecked: defaultSelection === radioButton.value,
    name: groupName,
    required: radioButton.required,
    onChange: function onChange(event) {
      return _onChange(event);
    },
    onBlur: function onBlur(event) {
      return _onBlur(event);
    },
    disabled: disabled
  }, radioButton.props)), /*#__PURE__*/React.createElement("label", {
    className: "relative outline\n          flex flex-col flex-wrap flex-1\n          min-h-32 w-full\n          rounded-6 \n          text-16 p-24 \n          peer-checked:bg-eefaea\n          peer-focus-visible:ring-1 peer-focus-visible:ring-18ab42 peer-focus-visible:ring-offset-4\n          ".concat(isEasyLanguagePage ? 'leading-32' : 'leading-24', "\n          ").concat(radioButton.icon ? 'items-center' : '', "\n          ").concat(disabled ? 'cursor-not-allowed' : 'cursor-pointer peer-hover:outline-18ab42 peer-hover:outline-2', "\n          ").concat(errorMessage ? 'shadow-red-primary border border-eb0047 outline-none' : 'outline-c7ccd1 outline-1 peer-checked:outline-18ab42', "\n        "),
    htmlFor: "".concat(radioButtonId, "-").concat(radioIndex)
  }, radioButton.icon && /*#__PURE__*/React.createElement(Icon, {
    className: "fill-current p-12 w-64 h-64 overflow-visible rounded-full ".concat(disabled ? 'text-6d767c' : 'text-005e3f'),
    name: radioButton.icon
  }), /*#__PURE__*/React.createElement("p", {
    className: "font-semibold ".concat(radioButton.icon ? ' mt-16' : '', " ").concat(disabled ? 'text-6d767c' : 'text-293033'),
    dangerouslySetInnerHTML: {
      __html: radioButton.label
    }
  }), radioButton["abstract"] && /*#__PURE__*/React.createElement("p", {
    className: "mt-8 ".concat(disabled ? 'text-6d767c' : 'text-586167')
  }, radioButton["abstract"]), /*#__PURE__*/React.createElement(RadioIndicator$1, {
    dir: dir,
    disabled: disabled,
    errorMessage: errorMessage,
    variant: variant,
    className: "right-24 top-24"
  })));
};
ClickableCardRadioButton.propTypes = {
  ariaDescribedby: PropTypes.string,
  buttonWrapperClassName: PropTypes.string,
  defaultSelection: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dir: PropTypes.oneOf(['rtl', 'ltr']),
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  errorMessage: PropTypes.string,
  globalErrorMessageId: PropTypes.string,
  groupName: PropTypes.string,
  id: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  radioButton: radioButtonPropTypes,
  radioIndex: PropTypes.number,
  variant: PropTypes.oneOf(Object.values(bgVariant)),
  isEasyLanguagePage: PropTypes.bool
};
ClickableCardRadioButton.defaultProps = {
  buttonWrapperClassName: '',
  dir: 'ltr',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  radioButtons: [],
  variant: bgVariant.LIGHT,
  checked: null,
  radioButton: {},
  radioIndex: 0,
  isEasyLanguagePage: false
};
var ClickableCardRadioButton$1 = ClickableCardRadioButton;

var RadioButton = function RadioButton(_ref) {
  var additionalLabelGrey = _ref.additionalLabelGrey,
    ariaDescribedby = _ref.ariaDescribedby,
    buttonWrapperClassName = _ref.buttonWrapperClassName,
    defaultSelection = _ref.defaultSelection,
    dir = _ref.dir,
    disabled = _ref.disabled,
    errorMessage = _ref.errorMessage,
    globalErrorMessageId = _ref.globalErrorMessageId,
    groupName = _ref.groupName,
    id = _ref.id,
    _onBlur = _ref.onBlur,
    _onChange = _ref.onChange,
    radioButton = _ref.radioButton,
    radioIndex = _ref.radioIndex,
    variant = _ref.variant,
    checked = _ref.checked,
    isEasyLanguagePage = _ref.isEasyLanguagePage;
  var _useState = useState(typeof checked === 'boolean'),
    _useState2 = _slicedToArray(_useState, 1),
    isControlled = _useState2[0];
  var _useState3 = useState(function () {
      return id || createRandomID('radio');
    }),
    _useState4 = _slicedToArray(_useState3, 1),
    radioButtonId = _useState4[0];
  var ariaDescribedbyIds = useMemo(function () {
    switch (true) {
      case !!errorMessage && !!ariaDescribedby:
        return "".concat(ariaDescribedby, " ").concat(globalErrorMessageId);
      case !!errorMessage:
        return globalErrorMessageId;
      default:
        return ariaDescribedby;
    }
  }, [errorMessage, globalErrorMessageId, ariaDescribedby]);
  var radioBtnTextColor = classnames({
    'text-98a1a6': (variant === bgVariant.STRUCTURE || variant === bgVariant.DARK) && disabled,
    'text-afb6bc': variant === bgVariant.LIGHT && disabled,
    'text-40484d': variant === bgVariant.LIGHT && !disabled,
    'text-293033': variant === bgVariant.STRUCTURE && !disabled || variant === bgVariant.LIGHT && isEasyLanguagePage && !disabled,
    'text-ffffff': variant === bgVariant.DARK && !disabled
  });
  var radioBtnAddTextColor = classnames({
    'text-6D767C': !disabled && !additionalLabelGrey,
    'text-586167': !disabled && additionalLabelGrey,
    'text-828b91': (variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE) && disabled,
    'text-98a1a6': variant === bgVariant.DARK && disabled,
    'text-98e692': variant === bgVariant.DARK && !disabled
  });
  var additionalLabelClasses = classnames({
    'text-14 leading-20': !additionalLabelGrey,
    'text-12 leading-18': additionalLabelGrey,
    'text-14 leading-26': isEasyLanguagePage && (!additionalLabelGrey || additionalLabelGrey)
  });
  return /*#__PURE__*/React.createElement("li", {
    className: " ".concat(buttonWrapperClassName, " mb-8 ")
  }, isControlled ? /*#__PURE__*/React.createElement("input", _extends$1({
    id: "".concat(radioButtonId, "-").concat(radioIndex),
    className: "sr-only",
    "aria-describedby": ariaDescribedbyIds,
    type: "radio",
    value: radioButton.value,
    checked: checked,
    name: groupName,
    required: radioButton.required,
    onChange: function onChange(event) {
      _onChange(event);
    },
    onBlur: function onBlur(event) {
      return _onBlur(event);
    },
    disabled: disabled
  }, radioButton.props)) : /*#__PURE__*/React.createElement("input", _extends$1({
    id: "".concat(radioButtonId, "-").concat(radioIndex),
    className: "sr-only",
    "aria-describedby": ariaDescribedbyIds,
    type: "radio",
    value: radioButton.value,
    defaultChecked: defaultSelection ? defaultSelection === radioButton.value : null,
    name: groupName,
    required: radioButton.required,
    onChange: function onChange(event) {
      _onChange(event);
    },
    onBlur: function onBlur(event) {
      return _onBlur(event);
    },
    disabled: disabled
  }, radioButton.props)), /*#__PURE__*/React.createElement("label", {
    className: "relative flex items-center flex-wrap min-h-32 w-full rounded-6 cursor-pointer text-16\n          ".concat(isEasyLanguagePage ? 'leading-32' : 'leading-24', "\n        "),
    htmlFor: "".concat(radioButtonId, "-").concat(radioIndex)
  }, /*#__PURE__*/React.createElement(RadioIndicator$1, {
    dir: dir,
    disabled: disabled,
    errorMessage: errorMessage,
    radioButton: radioButton,
    variant: variant,
    className: "".concat(dir === 'rtl' ? 'right-4' : 'left-4', "  top-4")
  }), /*#__PURE__*/React.createElement("span", {
    className: radioButton.additionalLabel ? 'flex flex-col' : ''
  }, /*#__PURE__*/React.createElement("span", {
    className: radioButton.popover ? 'flex' : ''
  }, /*#__PURE__*/React.createElement("span", {
    className: "py-4 pr-4 flex items-center\n              ".concat(dir === 'rtl' ? 'mr-36' : 'ml-36', " \n              ").concat(radioBtnTextColor),
    dangerouslySetInnerHTML: {
      __html: radioButton.label
    }
  }), radioButton.popover), radioButton.additionalLabel && /*#__PURE__*/React.createElement("span", {
    className: "pl-4 w-full font-regular\n                ".concat(dir === 'rtl' ? 'mr-32' : 'ml-32', "\n                ").concat(additionalLabelClasses, "\n                ").concat(radioBtnAddTextColor, "\n              ")
  }, radioButton.additionalLabel))));
};
RadioButton.propTypes = {
  additionalLabelGrey: PropTypes.bool,
  ariaDescribedby: PropTypes.string,
  buttonWrapperClassName: PropTypes.string,
  defaultSelection: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dir: PropTypes.oneOf(['rtl', 'ltr']),
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  globalErrorMessageId: PropTypes.string,
  groupName: PropTypes.string,
  id: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  radioButton: radioButtonPropTypes,
  radioIndex: PropTypes.number,
  variant: PropTypes.oneOf(Object.values(bgVariant)),
  isEasyLanguagePage: PropTypes.bool
};
RadioButton.defaultProps = {
  radioIndex: 0,
  radioButton: {},
  additionalLabelGrey: false,
  buttonWrapperClassName: '',
  className: '',
  dir: 'ltr',
  groupLabelClassName: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  variant: bgVariant.LIGHT,
  checked: null,
  isEasyLanguagePage: false
};
var RadioButton$1 = RadioButton;

var RadioButtonGroup = function RadioButtonGroup(_ref) {
  var additionalLabelGrey = _ref.additionalLabelGrey,
    ariaDescribedby = _ref.ariaDescribedby,
    buttonOuterClasses = _ref.buttonOuterClasses,
    buttonWrapperClassName = _ref.buttonWrapperClassName,
    className = _ref.className,
    defaultSelection = _ref.defaultSelection,
    dir = _ref.dir,
    disabled = _ref.disabled,
    errorMessage = _ref.errorMessage,
    errorMessageClassName = _ref.errorMessageClassName,
    groupLabel = _ref.groupLabel,
    groupLabelClassName = _ref.groupLabelClassName,
    groupName = _ref.groupName,
    id = _ref.id,
    labelVisibility = _ref.labelVisibility,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    popover = _ref.popover,
    popoverInline = _ref.popoverInline,
    radioButtons = _ref.radioButtons,
    radioButtonType = _ref.radioButtonType,
    testId = _ref.testId,
    variant = _ref.variant,
    isEasyLanguagePage = _ref.isEasyLanguagePage;
  var _useState = useState(function () {
      return id ? "".concat(id, "-error-global") : createRandomID('error');
    }),
    _useState2 = _slicedToArray(_useState, 1),
    globalErrorMessageId = _useState2[0];
  var _useState3 = useState((defaultSelection === null || defaultSelection === void 0 ? void 0 : defaultSelection.toString()) || ''),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isMultiline = _useState6[0],
    setIsMultiline = _useState6[1];
  var errorRef = useRef(null);
  var radioGroupLabel = 'string' === typeof groupLabel ? "".concat(groupLabel).concat(radioButtons[0].required ? '*' : '') : groupLabel;
  var radioGroupClassName = classnames({
    'radio-group-bglight': variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE,
    'radio-group-bgdark': variant === bgVariant.DARK
  });
  var groupLabelClasses = classnames({
    'text-40484d': variant === bgVariant.LIGHT,
    'text-293033': variant === bgVariant.STRUCTURE,
    'text-ffffff': variant === bgVariant.DARK,
    'relative': labelVisibility === labelVisibilityState.SHOW,
    'sr-only': labelVisibility === labelVisibilityState.HIDE
  });
  var errorMsgClasses = classnames({
    'text-eb0047': variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE,
    'text-ffffff': variant === bgVariant.DARK
  });
  var iconErrorClass = classnames({
    'text-eb0047': variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE,
    'text-f580a3': variant === bgVariant.DARK
  });
  var handleOnChange = function handleOnChange(e) {
    setValue(e.target.value);
    onChange(e);
  };
  useEffect(function () {
    setValue((defaultSelection === null || defaultSelection === void 0 ? void 0 : defaultSelection.toString()) || '');
  }, [defaultSelection]);
  useEffect(function () {
    var element = errorRef.current;
    if (element) {
      var elementHeight = element.offsetHeight;
      var lineHeight = parseFloat(getComputedStyle(element).lineHeight);
      var numberOfLines = Math.round(elementHeight / lineHeight);
      setIsMultiline(numberOfLines > 1);
    }
  }, [errorMessage]);
  var elementProps = {
    additionalLabelGrey: additionalLabelGrey,
    ariaDescribedby: ariaDescribedby,
    buttonWrapperClassName: buttonWrapperClassName,
    dir: dir,
    disabled: disabled,
    errorMessage: errorMessage,
    globalErrorMessageId: globalErrorMessageId,
    groupName: groupName,
    id: id,
    onBlur: onBlur,
    variant: variant,
    onChange: handleOnChange
  };
  return /*#__PURE__*/React.createElement("fieldset", {
    className: "".concat(className, " ").concat(radioGroupClassName, " flex flex-col"),
    "data-cy": testId
  }, groupLabel && /*#__PURE__*/React.createElement("div", {
    className: "\n        flex text-16\n        ".concat(isEasyLanguagePage ? 'leading-32' : 'leading-24', "\n        ").concat(groupLabelClasses, "\n        ").concat(groupLabelClassName, "\n      ")
  }, /*#__PURE__*/React.createElement("legend", null, radioGroupLabel, " ", popoverInline), popover), /*#__PURE__*/React.createElement("ul", {
    className: "\n        ".concat(buttonOuterClasses || '', "\n        ").concat(dir === 'rtl' ? '-mr-4' : '-ml-4', "\n      ")
  }, radioButtons.map(function (radioButton, radioIndex) {
    var radioKey = "".concat(radioIndex, "_").concat(radioButton.value);
    if (radioButtonType === RadioButtonType.DEFAULT) {
      return /*#__PURE__*/React.createElement(RadioButton$1, _extends$1({
        key: radioKey,
        radioButton: radioButton,
        radioIndex: radioIndex,
        checked: value === radioButton.value.toString()
      }, elementProps));
    } else {
      return /*#__PURE__*/React.createElement(ClickableCardRadioButton$1, _extends$1({
        key: radioKey,
        radioButton: radioButton,
        radioIndex: radioIndex,
        checked: value === radioButton.value.toString()
      }, elementProps));
    }
  })), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "".concat(isMultiline ? 'items-start' : 'items-center', " flex mt-8")
  }, /*#__PURE__*/React.createElement(AlertCircleFilled, {
    className: "\n              min-w-[16px] w-16 h-16 fill-current transition-opacity duration-350 ease-in-out\n              ".concat(dir === 'rtl' ? 'left-48' : 'right-48', "\n              ").concat(iconErrorClass, "\n              ").concat(errorMessage && !disabled ? 'opacity-100' : 'opacity-0', "\n              ").concat(isEasyLanguagePage ? 'mt-4' : '', "\n            ")
  }), /*#__PURE__*/React.createElement("p", {
    id: globalErrorMessageId,
    ref: errorRef,
    className: " t-4 mx-8 \n                ".concat(isEasyLanguagePage ? 'text-14 leading-26' : 'text-12 leading-18', "\n                ").concat(errorMsgClasses, " \n                ").concat(errorMessageClassName, "\n              "),
    dangerouslySetInnerHTML: typeof errorMessage === 'string' ? {
      __html: errorMessage
    } : undefined
  }, typeof errorMessage !== 'string' ? errorMessage : undefined)));
};
RadioButtonGroup.propTypes = {
  additionalLabelGrey: PropTypes.bool,
  ariaDescribedby: PropTypes.string,
  buttonOuterClasses: PropTypes.string,
  buttonWrapperClassName: PropTypes.string,
  className: PropTypes.string,
  defaultSelection: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dir: PropTypes.oneOf(['rtl', 'ltr']),
  disabled: PropTypes.bool,
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  errorMessageClassName: PropTypes.string,
  groupLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  groupLabelClassName: PropTypes.string,
  groupName: PropTypes.string,
  id: PropTypes.string,
  labelVisibility: PropTypes.oneOf(Object.values(labelVisibilityState)),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  popover: PropTypes.element,
  popoverInline: PropTypes.element,
  radioButtons: PropTypes.arrayOf(radioButtonPropTypes),
  radioButtonType: PropTypes.oneOf([RadioButtonType.CARD, RadioButtonType.DEFAULT]),
  testId: PropTypes.string,
  variant: PropTypes.oneOf(Object.values(bgVariant)),
  isEasyLanguagePage: PropTypes.bool
};
RadioButtonGroup.defaultProps = {
  additionalLabelGrey: false,
  buttonWrapperClassName: '',
  className: '',
  dir: 'ltr',
  errorMessageClassName: '',
  groupLabelClassName: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  radioButtons: [],
  radioButtonType: RadioButtonType.DEFAULT,
  variant: bgVariant.LIGHT,
  isEasyLanguagePage: false
};
var RadioButtonGroup$1 = RadioButtonGroup;

var SliderTrack = function SliderTrack(_ref) {
  var length = _ref.length,
    progress = _ref.progress,
    colorClassName = _ref.colorClassName,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full h-full gap-x-2"
  }, _toConsumableArray(Array(length)).map(function (_segment, i) {
    if (progress <= i) {
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "w-full h-full bg-transparent"
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "".concat(colorClassName, " w-full h-full ").concat(i === 0 ? 'rounded-bl-4 rounded-tl-4' : '', " ").concat(i === length - 1 ? 'rounded-br-4 rounded-tr-4' : '')
    });
  })));
};
SliderTrack.propTypes = {
  length: PropTypes.number,
  progress: PropTypes.number,
  colorClassName: PropTypes.string,
  className: PropTypes.string
};
SliderTrack.defaultProps = {
  length: 0,
  progress: 0,
  colorClassName: 'bg-afb6bc',
  className: ''
};
var SliderTrack$1 = SliderTrack;

var RangeSlider = function RangeSlider(_ref) {
  var id = _ref.id,
    step = _ref.step,
    min = _ref.min,
    max = _ref.max,
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    name = _ref.name,
    label = _ref.label,
    labelVisibility = _ref.labelVisibility,
    bgVariant$1 = _ref.bgVariant,
    onChange = _ref.onChange,
    className = _ref.className;
  var _useState = useState(value !== undefined),
    _useState2 = _slicedToArray(_useState, 1),
    isControlled = _useState2[0];

  // controls how much of the slider track is "filled"
  var _useState3 = useState(value !== null && value !== void 0 ? value : defaultValue),
    _useState4 = _slicedToArray(_useState3, 2),
    progress = _useState4[0],
    setProgress = _useState4[1];
  var inputId = useMemo(function () {
    return id || createRandomID('range-slider');
  }, [id]);
  var marks = [];
  var arrayLength = (max - min + 1) / step;
  if (arrayLength % 1 !== 0) {
    console.error("<RangeSlider/> with ID ".concat(inputId, " has invalid props: (max - min + 1) must be evenly divisible by step"));
    arrayLength = Math.ceil(arrayLength);
  }
  marks = Array.from(Array(arrayLength).keys());
  var handleInputChange = function handleInputChange(e) {
    setProgress(parseInt(e.target.value));
    onChange(e);
  };
  useEffect(function () {
    if (!isControlled) {
      return;
    }
    if (!Number.isInteger(value) || value < min || value > max) {
      console.error("<RangeSlider/> with ID ".concat(inputId, " has invalid props: value must be an integer between min and max"));
      return;
    }
    setProgress(value);
  }, [value]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className)
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: inputId,
    className: "\n          font-semibold block text-center text-16 leading-24\n          ".concat(labelVisibility === labelVisibilityState.HIDE ? 'sr-only' : 'mb-8', "\n          ").concat(bgVariant$1 === bgVariant.DARK ? 'text-ffffff' : 'text-293033', "\n        ")
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "relative w-full h-40 "
  }, /*#__PURE__*/React.createElement(SliderTrack$1, {
    length: marks.length - 1,
    progress: marks.length - 1,
    colorClassName: "".concat(bgVariant$1 === bgVariant.DARK ? 'bg-dfe3e6' : 'bg-afb6bc'),
    className: "absolute h-8 top-1/2 -translate-y-1/2 left-16 right-16 mx-auto"
  }), /*#__PURE__*/React.createElement(SliderTrack$1, {
    length: marks.length - 1,
    progress: progress,
    colorClassName: "".concat(bgVariant$1 === bgVariant.DARK ? 'bg-50eb5d' : 'bg-005e3f'),
    className: "absolute h-8 top-1/2 -translate-y-1/2 left-16 right-16 mx-auto"
  }), /*#__PURE__*/React.createElement("input", {
    id: inputId,
    className: "range",
    type: "range",
    step: step,
    min: min,
    max: max,
    onChange: handleInputChange,
    defaultValue: isControlled ? undefined : defaultValue,
    value: value,
    name: name
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-4 relative mx-16 flex justify-between ".concat(bgVariant$1 === bgVariant.DARK ? 'text-ffffff' : 'text-293033')
  }, marks.map(function (mark, i) {
    return /*#__PURE__*/React.createElement("span", {
      key: i
    }, mark);
  })));
};
RangeSlider.propTypes = {
  id: PropTypes.string,
  step: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  defaultValue: PropTypes.number,
  value: PropTypes.number,
  name: PropTypes.string,
  label: PropTypes.string.isRequired,
  labelVisibility: PropTypes.oneOf([labelVisibilityState.SHOW, labelVisibilityState.HIDE]),
  bgVariant: PropTypes.oneOf([bgVariant.LIGHT, bgVariant.DARK, bgVariant.STRUCTURE]),
  onChange: PropTypes.func,
  className: PropTypes.string
};
RangeSlider.defaultProps = {
  min: 0,
  max: 4,
  step: 1,
  defaultValue: 0,
  label: 'Label nicht gesetzt',
  labelVisibility: labelVisibilityState.SHOW,
  bgVariant: bgVariant.LIGHT,
  onChange: function onChange() {},
  className: ''
};
var RangeSlider$1 = RangeSlider;

var MOBILE_BREAKPOINT = 600;

/**
 * @type React.FC<searchFieldPropTypes>
 */
var SearchField = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var label = _ref.label,
    inputProps = _ref.inputProps,
    ariaDescribedby = _ref.ariaDescribedby,
    error = _ref.error,
    variant = _ref.variant,
    buttonIsDisabled = _ref.buttonIsDisabled,
    labelVisibility = _ref.labelVisibility,
    isLoading = _ref.isLoading,
    onDeleteButtonClick = _ref.onDeleteButtonClick,
    onBlurInput = _ref.onBlurInput,
    onChangeInput = _ref.onChangeInput,
    onFocusInput = _ref.onFocusInput,
    onKeyDownInput = _ref.onKeyDownInput,
    onKeyUpInput = _ref.onKeyUpInput,
    onSubmitButtonClick = _ref.onSubmitButtonClick,
    popover = _ref.popover,
    hideErrorMessage = _ref.hideErrorMessage,
    className = _ref.className,
    id = _ref.id,
    searchButtonVariant = _ref.searchButtonVariant,
    hasVerticalAlignedElems = _ref.hasVerticalAlignedElems,
    isLocationSearch = _ref.isLocationSearch,
    isEmptyInputAllowed = _ref.isEmptyInputAllowed,
    submitButtonLabel = _ref.submitButtonLabel,
    hasSearchButton = _ref.hasSearchButton,
    handleErrorExternally = _ref.handleErrorExternally;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    inputIsFocused = _useState2[0],
    setInputIsFocused = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    inputIsEmpty = _useState4[0],
    setInputIsEmpty = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showIconButton = _useState6[0],
    setShowIconButton = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    errorMessage = _useState8[0],
    setErrorMessage = _useState8[1];
  var inputRef = ref ? ref : useRef(null);
  var searchIconClasses = classnames({
    'group-hover:text-40484d': variant === bgVariant.LIGHT,
    'text-40484d': variant === bgVariant.LIGHT && inputIsFocused,
    'text-6d767c': variant === bgVariant.LIGHT && !inputIsFocused,
    'group-hover:text-ffffff': variant === bgVariant.DARK,
    'text-ffffff': variant === bgVariant.DARK && inputIsFocused || variant === bgVariant.DARK && !inputIsFocused && !inputIsEmpty,
    'text-98e692': variant === bgVariant.DARK && !inputIsFocused && inputIsEmpty
  });
  var handleInputBlur = function handleInputBlur(event) {
    setInputIsFocused(false);
    onBlurInput(event);
  };
  var handleInputChange = function handleInputChange(event) {
    var _event$target;
    var inputVal = (event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) || '';
    var isEmpty = inputVal.length === 0 || !inputVal.trim();
    setInputIsEmpty(isEmpty);
    onChangeInput(event);
    if (!isEmpty && !handleErrorExternally) {
      setErrorMessage(null);
    }
  };
  var handleInputFocus = function handleInputFocus(event) {
    setInputIsFocused(true);
    onFocusInput(event);
  };
  var handleDeleteButtonClick = function handleDeleteButtonClick(event) {
    setInputIsEmpty(true);
    onDeleteButtonClick(event);
    if (!handleErrorExternally) {
      setErrorMessage(null);
    }
  };
  useEffect(function () {
    if (searchButtonVariant === size.SMALL) {
      var onResize = function onResize() {
        setShowIconButton(window.innerWidth < MOBILE_BREAKPOINT);
      };
      onResize();
      window.addEventListener('resize', onResize);
      return function () {
        window.removeEventListener('resize', onResize);
      };
    }
  }, []);

  // check initial input value (subsequent state changes are leveraged in onChange handler)
  useEffect(function () {
    setInputIsEmpty(!inputProps.value);
  }, [inputProps.value]);
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (!inputIsEmpty) {
        onSubmitButtonClick();
        inputRef.current.blur();
      } else {
        if (!handleErrorExternally) {
          setErrorMessage(error);
        }
      }
    }
    onKeyDownInput(e);
  };
  return /*#__PURE__*/React.createElement(InputField$1, {
    id: id,
    ref: inputRef,
    variant: variant,
    label: label,
    error: handleErrorExternally ? error : errorMessage,
    inputProps: inputProps,
    ariaDescribedby: ariaDescribedby,
    labelVisibility: labelVisibility,
    hideErrorMessage: hideErrorMessage,
    onFocus: handleInputFocus,
    onBlur: handleInputBlur,
    onChange: handleInputChange,
    onKeyDown: handleKeyDown,
    onKeyUp: onKeyUpInput,
    onDeleteButtonClick: handleDeleteButtonClick,
    hasVerticalAlignedElems: hasVerticalAlignedElems,
    beforeInputSlot: isLocationSearch ? /*#__PURE__*/React.createElement(Location, {
      className: "\n              mr-8 shrink-0 w-16 h-16 fill-current self-center\n              transition duration-350 ease-in-out\n              ".concat(searchIconClasses, "\n            "),
      onClick: function onClick() {
        inputRef.current.focus();
      }
    }) : /*#__PURE__*/React.createElement(Search, {
      className: "\n              mr-8 shrink-0 w-16 h-16 fill-current self-center\n              transition duration-350 ease-in-out\n              ".concat(searchIconClasses, "\n            "),
      onClick: function onClick() {
        inputRef.current.focus();
      }
    }),
    afterInputSlot: hasSearchButton && /*#__PURE__*/React.createElement(PrimaryButton$1, {
      "aria-label": "Suchen",
      backgroundVariant: variant === bgVariant.DARK ? 'green' : 'default',
      buttonSize: !hasVerticalAlignedElems ? 'small' : 'large',
      isIconButton: showIconButton,
      className: "\n                whitespace-nowrap\n                ".concat(!hasVerticalAlignedElems ? 'ml-16 justify-self-end self-center search-button' : 'mt-14 760:mt-0 760:ml-16 760:justify-self-end 760:self-center 760:search-button', "\n              "),
      isDisabled: buttonIsDisabled || inputIsEmpty && !isEmptyInputAllowed,
      isLoading: isLoading,
      onMouseDown: function onMouseDown(e) {
        return e.preventDefault();
      },
      onClick: function onClick(event) {
        if (!handleErrorExternally) {
          if (inputIsEmpty) {
            setErrorMessage(error);
          } else {
            setErrorMessage(null);
          }
        }
        onSubmitButtonClick(event);
        event.target.focus();
      }
    }, showIconButton ? /*#__PURE__*/React.createElement(Search, {
      className: "fill-current w-16 h-16"
    }) : submitButtonLabel),
    enableDeleteButton: true,
    popover: popover,
    className: "search-field group flex flex-col ".concat(className),
    outerClassName: !hasVerticalAlignedElems ? 'pl-16 pr-4' : 'pl-16 pr-12'
  });
});
SearchField.propTypes = _objectSpread2$1({}, searchFieldPropTypes);
SearchField.defaultProps = _objectSpread2$1({}, searchFieldDefaultProps);
var SearchField$1 = SearchField;

var _excluded$3 = ["backgroundVariant", "theme", "variant", "children", "className", "isDisabled", "isLoading", "dataTrackingButtonAction"];
var ButtonTheme = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  PRIMARYFLOATING: 'primaryFloating',
  SECONDARYFLOATING: 'secondaryFloating'
};

/**
 * @type React.FC<SecondaryFloatingButtonPropTypes>
 */
var SecondaryFloatingButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var backgroundVariant = props.backgroundVariant,
    theme = props.theme,
    variant = props.variant,
    children = props.children,
    className = props.className,
    isDisabled = props.isDisabled,
    isLoading = props.isLoading,
    dataTrackingButtonAction = props.dataTrackingButtonAction,
    rest = _objectWithoutProperties$1(props, _excluded$3);
  var wrapChildrenInSpan = function wrapChildrenInSpan(children) {
    return React.Children.map(children, function (child) {
      if ( /*#__PURE__*/React.isValidElement(child)) {
        if (child.type === 'p') {
          return /*#__PURE__*/React.createElement("span", {
            className: "containerSpan"
          }, wrapChildrenInSpan(child.props.children));
        }
        return /*#__PURE__*/React.cloneElement(child, {
          children: wrapChildrenInSpan(child.props.children)
        });
      }
      if (typeof child === 'string' || typeof child === 'number') {
        return /*#__PURE__*/React.createElement("span", null, child);
      }
      return child;
    });
  };
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    backGroundClass = _useState2[0],
    setBackgroundClass = _useState2[1];
  var secondaryFloatingClasses = classnames('outline-none rounded-100 focus-visible:ring-1 shadow-secondaryFloatingButtonHover', {
    'baseState secondaryFloatingGreen': !isDisabled && !isLoading && variant === bgVariant.DARK,
    'baseState secondaryFloatingDefault': !isDisabled && !isLoading && variant !== bgVariant.DARK,
    'focus-visible:ring-offset-4': (variant === bgVariant.DARK || variant === bgVariant.STRUCTURE) && !isDisabled && !isLoading,
    'focus-visible:ring-offset-0': variant === bgVariant.LIGHT && !isDisabled && !isLoading,
    'text-004730 bg-ffffff': (variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE) && !isDisabled && isLoading && backgroundVariant !== 'green',
    'cursor-default bg-dfe3e6 text-98a1a6': isDisabled && (variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE),
    'cursor-default bg-586167 text-98a1a6': isDisabled && variant === bgVariant.DARK,
    'text-ffffff bg-007141': !isDisabled && variant === bgVariant.DARK
  });
  var elementVariants = classnames({
    primary: theme === ButtonTheme.PRIMARY,
    secondary: theme === ButtonTheme.SECONDARY,
    primaryfloating: theme === ButtonTheme.PRIMARYFLOATING,
    secondaryfloating: theme === ButtonTheme.SECONDARYFLOATING,
    light: variant === bgVariant.LIGHT,
    dark: variant === bgVariant.DARK,
    structure: variant === bgVariant.STRUCTURE
  });
  var interactivityClasses = classnames({
    'hover:text-18ab42 focus-visible:text-18ab42 focus-visible:ring-18ab42': (variant === bgVariant.LIGHT || variant === bgVariant.STRUCTURE) && !isDisabled && !isLoading,
    'focus-visible:ring-offset-white': !isDisabled && !isLoading && variant === bgVariant.LIGHT,
    'focus-visible:ring-offset-eefaea': !isDisabled && !isLoading && variant === bgVariant.STRUCTURE,
    'hover:text-50eb5d focus-visible:text-50eb5d focus-visible:ring-50eb5d focus-visible:ring-offset-005e3f': !isDisabled && !isLoading && variant === bgVariant.DARK
  });
  return /*#__PURE__*/React.createElement(ButtonPrototype$1, _extends$1({
    ref: ref,
    backgroundVariant: backgroundVariant,
    variant: variant,
    className: "".concat(secondaryFloatingClasses, " ").concat(elementVariants, " ").concat(interactivityClasses, " ").concat(className, " ").concat(backGroundClass),
    isDisabled: isDisabled,
    isLoading: isLoading,
    "data-tracking-button-action": dataTrackingButtonAction,
    onMouseEnter: function onMouseEnter() {
      setBackgroundClass('background-animation');
    }
  }, rest), wrapChildrenInSpan(children));
});
var secondaryFloatingButtonPropTypes = {
  backgroundVariant: PropTypes.oneOf(['default', 'green']),
  children: PropTypes.node,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  dataTrackingButtonAction: PropTypes.string,
  theme: PropTypes.oneOf(Object.values(ButtonTheme)),
  variant: PropTypes.oneOf(Object.values(bgVariant))
};
SecondaryFloatingButton.propTypes = secondaryFloatingButtonPropTypes;
SecondaryFloatingButton.defaultProps = {
  backgroundVariant: 'default',
  children: 'Floating Button',
  className: '',
  isDisabled: false,
  isLoading: false,
  dataTrackingButtonAction: null,
  variant: bgVariant.LIGHT
};
var SecondaryFloatingButton$1 = SecondaryFloatingButton;

var Slider = function Slider(_ref) {
  var sliderSettings = _ref.sliderSettings,
    children = _ref.children,
    onSliderCreated = _ref.onSliderCreated,
    onSlideChanged = _ref.onSlideChanged,
    className = _ref.className,
    slideClassName = _ref.slideClassName;
  if (!children) {
    return null;
  }
  var _useKeenSlider = useKeenSlider(_objectSpread2$1(_objectSpread2$1({}, sliderSettings), {}, {
      created: function created(slider) {
        if (onSliderCreated) onSliderCreated(slider);
      },
      slideChanged: function slideChanged(slider) {
        if (onSlideChanged) onSlideChanged(slider);
      }
    })),
    _useKeenSlider2 = _slicedToArray(_useKeenSlider, 1),
    sliderRef = _useKeenSlider2[0];
  return /*#__PURE__*/React.createElement("div", {
    ref: sliderRef,
    className: "keen-slider ".concat(className)
  }, typeof children.map === 'function' ? children.map(function (element, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "slider-".concat(index),
      className: "keen-slider__slide ".concat(slideClassName)
    }, element);
  }) : /*#__PURE__*/React.createElement("div", {
    className: "keen-slider__slide"
  }, children));
};
Slider.propTypes = {
  sliderSettings: PropTypes.object,
  children: PropTypes.node,
  onSlideChanged: PropTypes.func,
  onSliderCreated: PropTypes.func
};
Slider.defaultProps = {
  className: '',
  slideClassName: '',
  onSlideChanged: function onSlideChanged() {},
  onSliderCreated: function onSliderCreated() {}
};
var Slider$1 = Slider;

var _excluded$2 = ["type", "className"];
var SocialMediaLink = function SocialMediaLink(_ref) {
  var type = _ref.type,
    className = _ref.className,
    rest = _objectWithoutProperties$1(_ref, _excluded$2);
  var getTypeIcon = function getTypeIcon(type) {
    var iconClassName = 'w-16 h-16 fill-current text-6d767c';
    switch (type) {
      case SocialMediaChannel.FACEBOOK:
        return /*#__PURE__*/React.createElement(SocialFacebook, {
          className: iconClassName
        });
      case SocialMediaChannel.TWITTER:
      case SocialMediaChannel.X:
        return /*#__PURE__*/React.createElement(SocialX, {
          className: iconClassName
        });
      case SocialMediaChannel.WHATSAPP:
        return /*#__PURE__*/React.createElement(SocialWhatsapp, {
          className: iconClassName
        });
      case SocialMediaChannel.SMS:
        return /*#__PURE__*/React.createElement(Sms, {
          className: iconClassName
        });
      case SocialMediaChannel.MAIL:
        return /*#__PURE__*/React.createElement(Mail, {
          className: iconClassName
        });
      default:
        return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
  };
  var getTypeText = function getTypeText(type) {
    switch (type) {
      case SocialMediaChannel.TWITTER:
      case SocialMediaChannel.X:
        return 'Teilen';
      case SocialMediaChannel.MAIL:
        return 'via E-Mail';
      case SocialMediaChannel.SMS:
        return 'via SMS';
      case SocialMediaChannel.FACEBOOK:
      case SocialMediaChannel.WHATSAPP:
      default:
        return 'Teilen';
    }
  };
  return /*#__PURE__*/React.createElement(Link$1, _extends$1({}, rest, {
    theme: "secondary",
    icon: getTypeIcon(type),
    title: /*#__PURE__*/React.createElement("span", {
      className: "ml-4"
    }, getTypeText(type)),
    className: "social-media-button ".concat(className),
    iconPosition: "left"
  }));
};
SocialMediaLink.propTypes = {
  type: PropTypes.oneOf(Object.values(SocialMediaChannel)),
  className: PropTypes.string
};
SocialMediaLink.defaultProps = {
  className: ''
};
var SocialMediaLink$1 = SocialMediaLink;

var Tab = function Tab(_ref) {
  var title = _ref.title,
    variant = _ref.variant,
    tabIndex = _ref.tabIndex,
    currentTab = _ref.currentTab,
    onClick = _ref.onClick,
    ariaSelected = _ref.ariaSelected,
    ariaControls = _ref.ariaControls;
  var isActive = tabIndex === currentTab;
  var tabClasses = classnames({
    'pb-14 border-b-4': isActive,
    'pb-16 border-b-2': !isActive,
    'border-50eb5d text-50eb5d': isActive && variant === bgVariant.DARK,
    'border-005e3f text-005e3f': isActive && variant === bgVariant.LIGHT,
    'border-4d7e6e text-ffffff hover:border-ffffff active:border-50eb5d active:text-50eb5d': !isActive && variant === bgVariant.DARK,
    'border-dfe3e6 text-6d767c hover:border-6d767c active:border-005e3f active:text-005e3f': !isActive && variant === bgVariant.LIGHT
  });
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    role: "tab",
    "aria-selected": ariaSelected,
    "aria-controls": ariaControls,
    onClick: onClick,
    className: "\n        keen-slider__slide min-w-fit\n        px-24 pt-16\n        cursor-pointer whitespace-nowrap\n        focus-visible:border-2 focus-visible:border-18ab42\n        font-semibold\n        ".concat(tabClasses, "\n      ")
  }, title);
};
Tab.propTypes = {
  tabIndex: PropTypes.number,
  onClick: PropTypes.func,
  currentTab: PropTypes.number,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  variant: PropTypes.string,
  ariaSelected: PropTypes.bool,
  ariaControls: PropTypes.string
};
Tab.defaultProps = {
  variant: bgVariant.LIGHT,
  onClick: function onClick() {}
};
var Tab$1 = Tab;

var Tabs = function Tabs(_ref) {
  var variant = _ref.variant,
    tabs = _ref.tabs,
    onChange = _ref.onChange,
    staticLabels = _ref.staticLabels,
    rightNavButtonClasses = _ref.rightNavButtonClasses,
    leftNavButtonClasses = _ref.leftNavButtonClasses,
    ariaLabelledby = _ref.ariaLabelledby;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentTab = _useState2[0],
    setCurrentTab = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showPagination = _useState4[0],
    setShowPagination = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    maxIdx = _useState6[0],
    setMaxIdx = _useState6[1];
  var _useKeenSlider = useKeenSlider({
      centered: true,
      slides: {
        perView: 'auto'
      },
      created: function created(s) {
        var _s$track, _s$track$details;
        if (s !== null && s !== void 0 && (_s$track = s.track) !== null && _s$track !== void 0 && (_s$track$details = _s$track.details) !== null && _s$track$details !== void 0 && _s$track$details.maxIdx) {
          setMaxIdx(s.track.details.maxIdx);
        }
      }
    }),
    _useKeenSlider2 = _slicedToArray(_useKeenSlider, 2),
    sliderRef = _useKeenSlider2[0],
    slider = _useKeenSlider2[1];
  var handleTabChange = useCallback(function (index) {
    setCurrentTab(index);
    onChange(index);
    if (index <= maxIdx) {
      var _slider$current;
      (_slider$current = slider.current) === null || _slider$current === void 0 ? void 0 : _slider$current.moveToIdx(index);
    } else {
      var _slider$current2;
      (_slider$current2 = slider.current) === null || _slider$current2 === void 0 ? void 0 : _slider$current2.moveToIdx(maxIdx);
    }
  }, [slider, maxIdx]);
  var handleResize = function handleResize() {
    var _document$querySelect, _slider$current3;
    var tabsWrapperWidth = (_document$querySelect = document.querySelector('div.tabsWrapper')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.offsetWidth;

    // pagination button size - 32px
    if (((_slider$current3 = slider.current) === null || _slider$current3 === void 0 ? void 0 : _slider$current3.size) >= tabsWrapperWidth - 32) {
      setShowPagination(true);
    } else {
      setShowPagination(false);
    }
  };
  useEffect(function () {
    handleResize();
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [currentTab, tabs]);
  return /*#__PURE__*/React.createElement("div", {
    className: "tabsWrapper relative"
  }, /*#__PURE__*/React.createElement("div", {
    ref: sliderRef,
    role: "tablist",
    "aria-labelledby": ariaLabelledby,
    className: "keen-slider relative"
  }, tabs.map(function (tab, tabIndex) {
    return /*#__PURE__*/React.createElement(Tab$1, _extends$1({
      key: tabIndex,
      tabIndex: tabIndex,
      currentTab: currentTab,
      variant: variant,
      onClick: function onClick() {
        return handleTabChange(tabIndex);
      }
    }, tab));
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full h-2 block -mt-2\n          ".concat(variant === bgVariant.DARK ? 'bg-4d7e6e' : '', "\n          ").concat(variant === bgVariant.LIGHT ? 'bg-dfe3e6' : '', "\n        ")
  }), currentTab !== 0 && showPagination && /*#__PURE__*/React.createElement("button", {
    title: staticLabels === null || staticLabels === void 0 ? void 0 : staticLabels.paginationLeftTitle,
    "aria-label": staticLabels === null || staticLabels === void 0 ? void 0 : staticLabels.paginationLeftTitle,
    onClick: function onClick() {
      return handleTabChange(currentTab - 1);
    },
    className: "absolute top-1/2 -translate-y-1/4 text-ffffff z-10 rounded-full bg-ffffff p-8 1000:p-12 -mt-12 group shadow-blackTransparent \n            focus-visible:rounded-full focus-visible:ring-1 focus-visible:ring-18ab42 focus-visible:ring-offset-4 focus-visible:ring-offset-ffffff\n            ".concat(leftNavButtonClasses, "\n          ")
  }, /*#__PURE__*/React.createElement(ArrowRoundedLeft, {
    className: "text-004730 fill-current w-16 h-16 transform group-hover:scale-110 ease-in-out"
  })), currentTab !== tabs.length - 1 && showPagination && /*#__PURE__*/React.createElement("button", {
    title: staticLabels === null || staticLabels === void 0 ? void 0 : staticLabels.paginationRightTitle,
    "aria-label": staticLabels === null || staticLabels === void 0 ? void 0 : staticLabels.paginationRightTitle,
    onClick: function onClick() {
      return handleTabChange(currentTab + 1);
    },
    className: "absolute top-1/2 -translate-y-1/4 text-ffffff z-10 rounded-full bg-ffffff p-8 1000:p-12 -mt-12 group shadow-blackTransparent \n            focus-visible:rounded-full focus-visible:ring-1 focus-visible:ring-18ab42 focus-visible:ring-offset-4 focus-visible:ring-offset-ffffff\n            ".concat(rightNavButtonClasses, "\n          ")
  }, /*#__PURE__*/React.createElement(ArrowRoundedRight, {
    className: "text-004730 fill-current w-16 h-16 transform group-hover:scale-110 transition duration-300 ease-in-out"
  })));
};
Tabs.propTypes = {
  variant: PropTypes.string,
  onChange: PropTypes.func,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    ariaSelected: PropTypes.bool,
    ariaControls: PropTypes.string
  })),
  currentTab: PropTypes.number,
  staticLabels: PropTypes.shape({
    paginationLeftTitle: PropTypes.string,
    paginationRightTitle: PropTypes.string
  }),
  rightNavButtonClasses: PropTypes.string,
  leftNavButtonClasses: PropTypes.string,
  ariaLabelledby: PropTypes.string
};
Tabs.defaultProps = {
  variant: bgVariant.LIGHT,
  onChange: function onChange() {},
  tabs: [],
  rightNavButtonClasses: 'right-0',
  leftNavButtonClasses: 'left-0'
};
var Tabs$1 = Tabs;

var Textarea = function Textarea(_ref) {
  var label = _ref.label,
    textareaProps = _ref.textareaProps,
    ariaDescribedby = _ref.ariaDescribedby,
    errorMessage = _ref.errorMessage,
    _onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    variant = _ref.variant,
    labelVisibility = _ref.labelVisibility,
    className = _ref.className,
    textareaClassName = _ref.textareaClassName,
    popover = _ref.popover,
    id = _ref.id,
    isEasyLanguagePage = _ref.isEasyLanguagePage;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focus = _useState2[0],
    setFocus = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    currentInputText = _useState4[0],
    setCurrentInputText = _useState4[1];
  var _useState5 = useState(textareaProps === null || textareaProps === void 0 ? void 0 : textareaProps.placeholder),
    _useState6 = _slicedToArray(_useState5, 2),
    placeholder = _useState6[0],
    setPlaceholder = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    keyboardFocus = _useState8[0],
    setKeyboardFocus = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isMultiline = _useState10[0],
    setIsMultiline = _useState10[1];
  var errorRef = useRef(null);
  var isKeyboard = useKeyboardFocusHelper();
  var textareaRef = useRef(null);
  var _useState11 = useState(function () {
      return id || createRandomID('textarea');
    }),
    _useState12 = _slicedToArray(_useState11, 1),
    textareaId = _useState12[0];
  var _useState13 = useState(function () {
      return id ? "".concat(id, "-error") : createRandomID('error');
    }),
    _useState14 = _slicedToArray(_useState13, 1),
    errorMessageId = _useState14[0];
  var ariaDescribedbyIds = useMemo(function () {
    switch (true) {
      case !!errorMessage && !!ariaDescribedby:
        return "".concat(ariaDescribedby, " ").concat(errorMessageId);
      case !!errorMessage:
        return errorMessageId;
      default:
        return ariaDescribedby;
    }
  }, [errorMessage, errorMessageId, ariaDescribedby]);
  var textareaClasses = classnames({
    'placeholder-6d767c': variant === bgVariant.LIGHT,
    'bg-transparent': variant === bgVariant.DARK,
    'bg-ffffff': variant === bgVariant.LIGHT && !disabled,
    'text-6d767c ': variant === bgVariant.LIGHT && disabled,
    'text-40484d hover:placeholder-40484d': variant === bgVariant.LIGHT && !disabled,
    'placeholder-ffffff': variant === bgVariant.LIGHT && !disabled && focus,
    'text-98a1a6 placeholder-98a1a6': variant === bgVariant.DARK && disabled,
    'text-ffffff placeholder-98e692 hover:placeholder-ffffff': variant === bgVariant.DARK && !disabled,
    'placeholder-005e3f': variant === bgVariant.DARK && !disabled && focus
  });
  var showLabel = labelVisibility === labelVisibilityState.SHOW || currentInputText || focus;
  var labelClasses = classnames('transition-colors duration-350 ease-in-out', {
    'text-40484d': variant === bgVariant.LIGHT && showLabel,
    'text-ffffff': variant === bgVariant.DARK && showLabel,
    'text-transparent': !showLabel
  });
  var outerClasses = 'transition duration-350 ease-in-out';
  if (variant === bgVariant.LIGHT) {
    outerClasses = classnames(outerClasses, 'textarea-primary', {
      'bg-ffffff': !disabled,
      'border-dfe3e6 bg-dfe3e6': disabled,
      'border-eb0047 border shadow-red-primary': !disabled && errorMessage,
      'border-18ab42 border shadow-green-primary': !disabled && !errorMessage && focus,
      'border-6d767c border hover:shadow-green-primary hover:border-18ab42': !disabled && !errorMessage && !focus
    });
  } else {
    outerClasses = classnames(outerClasses, 'textarea-secondary', {
      'border-586167 bg-586167': disabled,
      'border-f580a3 border shadow-red-secondary': !disabled && errorMessage,
      'border-50eb5d border shadow-green-secondary': !disabled && !errorMessage && focus,
      'border-98e692 border hover:shadow-green-secondary hover:border-50eb5d': !disabled && !errorMessage && !focus
    });
  }
  var errorClasses = variant === bgVariant.LIGHT ? 'text-eb0047' : 'text-ffffff';
  var errorFill = variant === bgVariant.LIGHT ? 'text-eb0047' : 'text-f580a3';
  var onTextareaChange = function onTextareaChange(e) {
    setCurrentInputText(e.target.value);
    onChange(e);
  };
  useEffect(function () {
    if (labelVisibility === labelVisibilityState.FLOATING) {
      setPlaceholder(label);
    } else {
      setPlaceholder(textareaProps === null || textareaProps === void 0 ? void 0 : textareaProps.placeholder);
    }
  }, [textareaProps, label, labelVisibility]);
  useEffect(function () {
    var element = errorRef.current;
    if (element) {
      var elementHeight = element.offsetHeight;
      var lineHeight = parseFloat(getComputedStyle(element).lineHeight);
      var numberOfLines = Math.round(elementHeight / lineHeight);
      setIsMultiline(numberOfLines > 1);
    }
  }, [errorMessage]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className)
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: textareaId,
    className: "block\n          ".concat(labelClasses, " \n          ").concat(labelVisibility === labelVisibilityState.HIDE ? 'sr-only' : '', "\n          ").concat(isEasyLanguagePage ? 'mb-8 leading-26 text-14' : 'mb-4 leading-18 text-12', "\n        ")
  }, "".concat(label).concat(textareaProps.required ? '*' : '')), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row items-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full shrink-1 ".concat(keyboardFocus ? 'shadow-green-outline rounded-4 p-4 -m-4' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "\n              ".concat(outerClasses, "\n              ").concat(disabled ? 'cursor-default' : 'cursor-text px-1 py-1', "\n              relative flex rounded-4\n            ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "grabber first"
  }), /*#__PURE__*/React.createElement("div", {
    className: "grabber second"
  }), /*#__PURE__*/React.createElement("textarea", _extends$1({}, textareaProps, {
    "aria-describedby": ariaDescribedbyIds,
    className: "\n                ".concat(textareaClassName, "\n                ").concat(textareaClasses, "\n                ").concat(disabled ? 'py-12 px-16' : 'py-10 px-14', "\n                ").concat(errorMessage ? 'pr-40' : '', "\n                border-none outline-0 leading-24 grow appearance-none\n              "),
    disabled: disabled,
    id: textareaId,
    onFocus: function onFocus() {
      setFocus(true);
      if (isKeyboard) {
        setKeyboardFocus(true);
      }
    },
    onChange: onTextareaChange,
    onBlur: function onBlur(e) {
      _onBlur(e);
      setFocus(false);
      setKeyboardFocus(false);
    },
    placeholder: placeholder,
    ref: textareaRef
  })))), popover), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "".concat(isMultiline ? "items-start" : "items-center", " flex mt-8")
  }, errorMessage && /*#__PURE__*/React.createElement(AlertCircleFilled, {
    className: "min-w-[16px] w-16 h-16 fill-current ".concat(errorFill)
  }), /*#__PURE__*/React.createElement("span", {
    id: errorMessageId,
    ref: errorRef,
    "aria-live": "assertive",
    className: "block mx-8 \n            ".concat(isEasyLanguagePage ? 'leading-26 text-14' : 'leading-18 text-12', "\n            ").concat(errorClasses, " \n          "),
    dangerouslySetInnerHTML: {
      __html: errorMessage
    }
  })));
};
Textarea.propTypes = {
  label: PropTypes.string,
  textareaProps: PropTypes.shape({
    name: PropTypes.string,
    placeholder: PropTypes.string,
    maxlength: PropTypes.number,
    required: PropTypes.bool,
    rows: PropTypes.number
  }),
  ariaDescribedby: PropTypes.string,
  errorMessage: PropTypes.string,
  // holds error message
  onBlur: PropTypes.func,
  // triggers input validation
  onChange: PropTypes.func,
  labelVisibility: PropTypes.oneOf(Object.values(labelVisibilityState)),
  variant: PropTypes.oneOf(Object.values(bgVariant)),
  className: PropTypes.string,
  textareaClassName: PropTypes.string,
  id: PropTypes.string,
  isEasyLanguagePage: PropTypes.bool
};
Textarea.defaultProps = {
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  label: 'Label nicht gesetzt',
  textareaProps: {
    name: 'Name nicht gesetzt',
    rows: 5
  },
  labelVisibility: labelVisibilityState.FLOATING,
  variant: bgVariant.LIGHT,
  className: '',
  textareaClassName: '',
  isEasyLanguagePage: false
};
var Textarea$1 = Textarea;

var UploadField = function UploadField(_ref) {
  var ariaDescribedby = _ref.ariaDescribedby,
    browseFilesText = _ref.browseFilesText,
    className = _ref.className,
    deleteFileText = _ref.deleteFileText,
    dir = _ref.dir,
    disabled = _ref.disabled,
    dragAndDropText = _ref.dragAndDropText,
    error = _ref.error,
    hint = _ref.hint,
    id = _ref.id,
    inputProps = _ref.inputProps,
    label = _ref.label,
    multiple = _ref.multiple,
    onChange = _ref.onChange,
    randomId = _ref.randomId,
    resetFileInput = _ref.resetFileInput,
    value = _ref.value,
    variant = _ref.variant;
  var dragZoneRef = useRef(null);
  var fileInputRef = useRef(null);
  var _useState = useState(Math.random().toString(36)),
    _useState2 = _slicedToArray(_useState, 2),
    internalRandomId = _useState2[0],
    setInternalRandomId = _useState2[1];
  var triggerFileUpload = function triggerFileUpload() {
    fileInputRef.current.click();
  };
  var handleFileUpload = function handleFileUpload(e) {
    if (!multiple) {
      setInternalRandomId(Math.random().toString(36));
      onChange(e);
      return;
    }
    var newValue;
    if (Array.isArray(value)) {
      newValue = {
        target: {
          files: [].concat(_toConsumableArray(value), _toConsumableArray(Array.from(e.target.files)))
        }
      };
    } else if (value) {
      newValue = {
        target: {
          files: [value].concat(_toConsumableArray(Array.from(e.target.files)))
        }
      };
    } else {
      newValue = {
        target: {
          files: Array.from(e.target.files)
        }
      };
    }
    onChange(newValue);
  };
  var clearFileUpload = function clearFileUpload(event) {
    setInternalRandomId(Math.random().toString(36));
    resetFileInput(event);
  };
  var deleteFileFromList = function deleteFileFromList(index) {
    if ((value === null || value === void 0 ? void 0 : value.length) > 1) {
      var newUploadValue = {
        target: {
          files: [].concat(_toConsumableArray(value.slice(0, index)), _toConsumableArray(value.slice(index + 1, value.length)))
        }
      };
      onChange(newUploadValue);
    } else {
      setInternalRandomId(Math.random().toString(36));
      resetFileInput();
    }
  };
  var dropHandler = function dropHandler(e) {
    var _e$dataTransfer, _e$dataTransfer$files, _e$dataTransfer2;
    e.preventDefault();
    if (!multiple) {
      setInternalRandomId(Math.random().toString(36));
      onChange(e);
      return;
    }
    if (((_e$dataTransfer = e.dataTransfer) === null || _e$dataTransfer === void 0 ? void 0 : (_e$dataTransfer$files = _e$dataTransfer.files) === null || _e$dataTransfer$files === void 0 ? void 0 : _e$dataTransfer$files.length) > 0 && ((_e$dataTransfer2 = e.dataTransfer) === null || _e$dataTransfer2 === void 0 ? void 0 : _e$dataTransfer2.files) instanceof FileList) {
      var newValue;
      if (Array.isArray(value)) {
        newValue = {
          target: {
            files: [].concat(_toConsumableArray(value), _toConsumableArray(Array.from(e.dataTransfer.files)))
          }
        };
      } else if (value) {
        newValue = {
          target: {
            files: [value].concat(_toConsumableArray(Array.from(e.dataTransfer.files)))
          }
        };
      } else {
        newValue = {
          target: {
            files: Array.from(e.dataTransfer.files)
          }
        };
      }
      onChange(newValue);
    }
  };
  var muteEvent = function muteEvent(e) {
    e.preventDefault();
    e.stopPropagation();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "\n        ".concat(className, "\n        ").concat(variant === bgVariant.LIGHT ? '' : 'text-ffffff', "\n      ")
  }, /*#__PURE__*/React.createElement("input", _extends$1({}, inputProps, {
    id: id,
    key: randomId ? randomId : internalRandomId,
    className: "hidden",
    onChange: handleFileUpload,
    ref: fileInputRef,
    type: "file",
    multiple: multiple
  })), /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: "font-semibold flex items-start"
  }, label, (inputProps === null || inputProps === void 0 ? void 0 : inputProps.required) === true && '*'), /*#__PURE__*/React.createElement("div", {
    ref: dragZoneRef,
    className: "drag-zone\n          -outline-offset-2 outline-1  outline-6d767c rounded-4\n          flex flex-col items-center justify-center\n          h-192 840:h-320\n          ".concat(error ? 'outline-solid outline-eb0047' : "outline-dashed ".concat(variant === bgVariant.LIGHT ? 'outline-6d767c' : 'outline-ffffff'), "\n        "),
    onDrop: function onDrop(e) {
      dropHandler(e);
      dragZoneRef.current.classList.remove('-outline-offset-8');
      dragZoneRef.current.classList.remove('bg-d8ece8');
      dragZoneRef.current.classList.add('-outline-offset-2');
    },
    onDragOver: muteEvent,
    onDragEnter: function onDragEnter(e) {
      muteEvent(e);
      dragZoneRef.current.classList.remove('-outline-offset-2');
      dragZoneRef.current.classList.add('-outline-offset-8');
      dragZoneRef.current.classList.add('bg-d8ece8');
    },
    onDragLeave: function onDragLeave(e) {
      muteEvent(e);
      dragZoneRef.current.classList.remove('-outline-offset-8');
      dragZoneRef.current.classList.remove('bg-d8ece8');
      dragZoneRef.current.classList.add('-outline-offset-2');
    }
  }, /*#__PURE__*/React.createElement(File, {
    className: "w-32 h-32 fill-current ".concat(variant === bgVariant.LIGHT ? 'text-005e3f' : 'text-ffffff')
  }), /*#__PURE__*/React.createElement("span", {
    className: "mt-16"
  }), " ", /*#__PURE__*/React.createElement("p", {
    className: "sr-only 840:not-sr-only"
  }, dragAndDropText), /*#__PURE__*/React.createElement("span", {
    className: "mt-8"
  }), " ", /*#__PURE__*/React.createElement(SecondaryButton$1, {
    type: "button",
    backgroundVariant: variant === bgVariant.DARK ? 'green' : 'default',
    buttonSize: "small",
    className: "upload-button justify-self-end self-center",
    isDisabled: disabled,
    onClick: triggerFileUpload,
    "aria-describedby": ariaDescribedby
  }, browseFilesText)), error && /*#__PURE__*/React.createElement("p", {
    className: "text-eb0047 mt-8"
  }, error), hint && /*#__PURE__*/React.createElement("p", {
    className: "text-6d767c mt-16"
  }, hint), value && /*#__PURE__*/React.createElement(React.Fragment, null, value.length ? /*#__PURE__*/React.createElement(React.Fragment, null, Array.from(value).map(function (file, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "bg-e8f4f2 flex justify-between mt-8 first-of-type:mt-24 py-16 840:py-24 px-16 720:px-24 1000:px-32"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement(File$1, {
      className: "w-16 h-16 fill-current text-6d767c ".concat(dir === 'rtl' ? 'ml-8' : 'mr-8')
    }), /*#__PURE__*/React.createElement("p", {
      className: "text-40484d"
    }, file.name)), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return deleteFileFromList(index);
      },
      type: "button",
      className: "flex items-center text-293033"
    }, /*#__PURE__*/React.createElement(Delete, {
      className: "w-16 h-16 fill-current ".concat(dir === 'rtl' ? '840:ml-8' : '840:mr-8')
    }), /*#__PURE__*/React.createElement("span", {
      className: "sr-only 840:not-sr-only font-semibold"
    }, deleteFileText)));
  })) : /*#__PURE__*/React.createElement("div", {
    className: "bg-e8f4f2 flex justify-between mt-24 py-16 840:py-24 px-16 720:px-24 1000:px-32"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(File$1, {
    className: "w-16 h-16 fill-current text-6d767c ".concat(dir === 'rtl' ? 'ml-8' : 'mr-8')
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-40484d"
  }, value.name)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: clearFileUpload,
    className: "flex items-center text-293033"
  }, /*#__PURE__*/React.createElement(Delete, {
    className: "w-16 h-16 fill-current ".concat(dir === 'rtl' ? '840:ml-8' : '840:mr-8')
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only 840:not-sr-only font-semibold"
  }, deleteFileText)))));
};
UploadField.propTypes = {
  label: PropTypes.string,
  inputProps: PropTypes.shape({
    name: PropTypes.string,
    placeholder: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    required: PropTypes.bool
  }),
  ariaDescribedby: PropTypes.string,
  error: PropTypes.string,
  variant: PropTypes.oneOf([bgVariant.LIGHT, bgVariant.DARK]),
  disabled: PropTypes.bool,
  browseFilesText: PropTypes.string,
  dragAndDropText: PropTypes.string,
  deleteFileText: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  hint: PropTypes.node,
  randomId: PropTypes.string,
  resetFileInput: PropTypes.func,
  id: PropTypes.string,
  dir: PropTypes.oneOf(['rtl', 'ltr']),
  multiple: PropTypes.bool
};
UploadField.defaultProps = {
  label: 'Label nicht gesetzt',
  inputProps: {
    name: 'Name nicht gesetzt'
  },
  browseFilesText: 'Datei auswählen',
  dragAndDropText: 'Zum Hochladen die Datei per Drag & Drop hier ablegen oder',
  deleteFileText: 'Löschen',
  variant: bgVariant.LIGHT,
  className: '',
  onChange: function onChange() {},
  resetFileInput: function resetFileInput() {},
  dir: 'ltr',
  multiple: false
};
var UploadField$1 = UploadField;

var _excluded$1 = ["url", "title", "className", "theme", "underline", "target", "hasDefaultFontSize", "hasIconAtBorder", "asHeadline", "children", "showIcon"];
var ColorScheme$1 = {
  LIGHT: 'light',
  DARK: 'dark',
  STRUCTURE: 'structure'
};
var LinkHeadline = function LinkHeadline(_ref) {
  var url = _ref.url,
    title = _ref.title,
    className = _ref.className,
    theme = _ref.theme,
    underline = _ref.underline,
    target = _ref.target,
    hasDefaultFontSize = _ref.hasDefaultFontSize,
    hasIconAtBorder = _ref.hasIconAtBorder,
    asHeadline = _ref.asHeadline,
    children = _ref.children,
    showIcon = _ref.showIcon,
    rest = _objectWithoutProperties$1(_ref, _excluded$1);
  var textClasses = classnames({
    'text-005e3f group-hover:text-18ab42 focus:text-18ab42': theme === ColorScheme$1.LIGHT,
    'text-ffffff group-hover:text-50eb5d focus:text-50eb5d': theme === ColorScheme$1.DARK,
    'hyphens': /&shy/g.test(title) === false
  });
  var borderClasses = classnames({
    'border-b border-005e3f group-hover:border-18ab42 focus-visible:border-18ab42': theme === ColorScheme$1.LIGHT,
    'border-b border-ffffff group-hover:border-50eb5d focus-visible:border-50eb5d': theme === ColorScheme$1.DARK
  });
  var iconClasses = "w-16 h-16 ml-3 fill-current inline transition ease-in-out duration-350 group-hover:scale-120\n    ".concat(hasDefaultFontSize ? 'mb-4' : 'mb-2', " ").concat(hasIconAtBorder ? 'mt-5' : '');
  return /*#__PURE__*/React.createElement(InteractiveElement$1, _extends$1({
    url: url,
    rel: target === '_blank' ? 'noopener noreferrer' : null,
    target: target,
    className: "font-buenos-aires font-semibold\n      ".concat(className, "\n      ").concat(textClasses, "\n      ").concat(children ? 'flex items-center' : '', "\n      ").concat(hasDefaultFontSize ? 'text-20 leading-28' : '', "\n    ")
  }, rest), children, /*#__PURE__*/React.createElement(ContextHeadline, {
    tag: asHeadline ? null : 'p',
    className: hasIconAtBorder ? 'w-full' : ''
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(children ? 'ml-16' : '', " ").concat(hasIconAtBorder ? 'flex justify-between items-start' : 'block')
  }, /*#__PURE__*/React.createElement("span", {
    className: underline ? "".concat(borderClasses) : '',
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), showIcon && /*#__PURE__*/React.createElement("span", {
    className: "whitespace-nowrap"
  }, /*#__PURE__*/React.createElement("span", null, "\xA0"), target === '_blank' ? /*#__PURE__*/React.createElement(ArrowRoundedRightup, {
    className: iconClasses
  }) : /*#__PURE__*/React.createElement(ArrowRoundedRight, {
    className: iconClasses
  })))));
};
LinkHeadline.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any,
  underline: PropTypes.bool,
  target: PropTypes.oneOf(['_blank', '_self']),
  hasDefaultFontSize: PropTypes.bool,
  hasIconAtBorder: PropTypes.bool,
  theme: PropTypes.oneOf([ColorScheme$1.LIGHT, ColorScheme$1.DARK]),
  asHeadline: PropTypes.bool,
  showIcon: PropTypes.bool
};
LinkHeadline.defaultProps = {
  theme: 'light',
  underline: false,
  title: 'Titel wurde nicht gesetzt',
  hasDefaultFontSize: true,
  hasIconAtBorder: false,
  className: '',
  asHeadline: true,
  showIcon: true
};
var LinkHeadline$1 = LinkHeadline;

/**
 * @type React.FC<swiperGeneralPaginationPropTypes>
 */
var SwiperGeneralPagination = /*#__PURE__*/React.forwardRef(function (_ref, paginationRef) {
  var currentSlide = _ref.currentSlide,
    onChangeCallback = _ref.onChangeCallback,
    paginationClasses = _ref.paginationClasses,
    paginationCount = _ref.paginationCount,
    paginationIsLoop = _ref.paginationIsLoop,
    paginationOuterClasses = _ref.paginationOuterClasses,
    paginationSettings = _ref.paginationSettings;
  return /*#__PURE__*/React.createElement("div", {
    ref: paginationRef,
    className: "slider-pagination ".concat(paginationOuterClasses)
  }, /*#__PURE__*/React.createElement("div", {
    className: paginationClasses
  }, paginationCount <= 3 ? /*#__PURE__*/React.createElement(DottedPagination$1, {
    count: paginationCount,
    current: currentSlide,
    onChangeCallback: onChangeCallback,
    variant: paginationSettings.colorScheme,
    mode: paginationIsLoop ? 'loop' : 'default'
  }) : /*#__PURE__*/React.createElement(NumberedPaginationShort$1, {
    count: paginationCount,
    current: currentSlide,
    onChangeCallback: onChangeCallback,
    variant: paginationSettings.colorScheme,
    mode: paginationIsLoop ? 'loop' : 'default'
  })));
});
var swiperGeneralPaginationPropTypes = {
  currentSlide: PropTypes.number,
  onChangeCallback: PropTypes.func,
  paginationClasses: PropTypes.string,
  paginationCount: PropTypes.number,
  paginationIsLoop: PropTypes.bool,
  paginationOuterClasses: PropTypes.string,
  paginationSettings: PropTypes.shape({
    colorScheme: PropTypes.string
  })
};
SwiperGeneralPagination.propTypes = swiperGeneralPaginationPropTypes;
SwiperGeneralPagination.defaultProps = {
  paginationClasses: '',
  paginationIsLoop: false,
  paginationOuterClasses: '',
  paginationSettings: {
    colorScheme: 'light'
  }
};
var SwiperGeneralPagination$1 = SwiperGeneralPagination;

/**
 * @type React.FC<swiperGlobalPaginationPropTypes>
 */
var SwiperGlobalPagination = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    currentSlide = _ref.currentSlide,
    nextButtonClassName = _ref.nextButtonClassName,
    nextStepTitle = _ref.nextStepTitle,
    onChangeCallback = _ref.onChangeCallback,
    paginationCount = _ref.paginationCount,
    prevButtonClassName = _ref.prevButtonClassName,
    prevStepTitle = _ref.prevStepTitle,
    iconClassName = _ref.iconClassName,
    staticLabels = _ref.staticLabels;
  var iconClasses = 'w-16 h-16 fill-current text-004730';
  var buttonClasses = "absolute top-0 focus-visible:rounded-full focus-visible:ring-1 focus-visible:ring-18ab42 focus-visible:ring-offset-4 focus-visible:ring-offset-e8f4f2 rounded-full inline-flex justify-center items-center shadow-blackTransparent bg-ffffff";
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: "".concat(className)
  }, currentSlide > 1 && /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return onChangeCallback(currentSlide - 1);
    },
    title: "Zum vorigen Schritt ".concat(prevStepTitle),
    className: "".concat(buttonClasses, " ").concat(prevButtonClassName),
    "aria-label": staticLabels.paginationLeftAriaLabel
  }, /*#__PURE__*/React.createElement(ArrowRoundedLeft, {
    className: "".concat(iconClasses, " ").concat(iconClassName)
  })), currentSlide < paginationCount && /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return onChangeCallback(currentSlide + 1);
    },
    title: "Zum n\xE4chsten Schritt ".concat(nextStepTitle),
    className: "".concat(buttonClasses, " ").concat(nextButtonClassName),
    "aria-label": staticLabels.paginationRightAriaLabel
  }, /*#__PURE__*/React.createElement(ArrowRoundedRight, {
    className: "".concat(iconClasses, " ").concat(iconClassName)
  })));
});
var swiperGlobalPaginationPropTypes = {
  className: PropTypes.string,
  nextButtonClassName: PropTypes.string,
  nextStepTitle: PropTypes.string,
  onChangeCallback: PropTypes.func,
  prevButtonClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  prevStepTitle: PropTypes.string,
  staticLabels: PropTypes.shape({
    paginationLeftAriaLabel: PropTypes.string,
    paginationRightAriaLabel: PropTypes.string
  })
};
SwiperGlobalPagination.propTypes = swiperGlobalPaginationPropTypes;
SwiperGlobalPagination.defaultProps = {
  className: '',
  nextButtonClassName: 'w-48 h-48',
  nextStepTitle: '',
  onChangeCallback: function onChangeCallback() {},
  prevButtonClassName: 'w-48 h-48',
  prevStepTitle: '',
  iconClassName: '',
  staticLabels: {
    paginationLeftAriaLabel: 'zurückblättern',
    paginationRightAriaLabel: 'vorblättern'
  }
};
var SwiperGlobalPagination$1 = SwiperGlobalPagination;

/**
 * @type React.FC<swiperSliderPropTypes>
 */
var SwiperSliderWithPagination = function SwiperSliderWithPagination(_ref) {
  var children = _ref.children,
    className = _ref.className,
    generalPagination = _ref.generalPagination,
    globalPagination = _ref.globalPagination,
    id = _ref.id,
    _onInit = _ref.onInit,
    onResizeCallback = _ref.onResizeCallback,
    onSlideChangeCallback = _ref.onSlideChangeCallback,
    onSnapIndexChangeCallback = _ref.onSnapIndexChangeCallback,
    paginationCurrentPage = _ref.paginationCurrentPage,
    slideTag = _ref.slideTag,
    swiperProps = _ref.swiperProps,
    renderPaginationAboveSlider = _ref.renderPaginationAboveSlider,
    tag = _ref.tag,
    wrapperTag = _ref.wrapperTag;
  if (!children) {
    return null;
  }
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentSlide = _useState2[0],
    setCurrentSlide = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    paginationCount = _useState4[0],
    setPaginationCount = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    swiperInstance = _useState6[0],
    setSwiperInstance = _useState6[1];
  var onPaginationCallback = function onPaginationCallback(index) {
    var currentSlidesPerGroup;
    if (swiperInstance.currentBreakpoint) {
      var _swiperProps$breakpoi;
      if (swiperProps.breakpoints && (_swiperProps$breakpoi = swiperProps.breakpoints[swiperInstance.currentBreakpoint]) !== null && _swiperProps$breakpoi !== void 0 && _swiperProps$breakpoi.slidesPerGroup) {
        var _swiperProps$breakpoi2;
        currentSlidesPerGroup = (_swiperProps$breakpoi2 = swiperProps.breakpoints[swiperInstance.currentBreakpoint]) === null || _swiperProps$breakpoi2 === void 0 ? void 0 : _swiperProps$breakpoi2.slidesPerGroup;
      } else {
        currentSlidesPerGroup = swiperProps.slidesPerGroup;
      }
    } else {
      currentSlidesPerGroup = swiperProps.slidesPerGroup;
    }
    if (currentSlidesPerGroup) {
      swiperInstance.slideTo((index - 1) * currentSlidesPerGroup);
    } else {
      swiperInstance.slideTo(index - 1);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "sr-only",
    role: "region",
    "aria-live": "polite"
  }, "".concat(paginationCount > 1 ? paginationCurrentPage + ' ' + (currentSlide + 1) : '')), globalPagination && /*#__PURE__*/React.cloneElement(globalPagination, {
    currentSlide: currentSlide + 1,
    paginationCount: paginationCount,
    onChangeCallback: onPaginationCallback
  }), renderPaginationAboveSlider && generalPagination && paginationCount > 1 && /*#__PURE__*/React.cloneElement(generalPagination, {
    currentSlide: currentSlide + 1,
    paginationCount: paginationCount,
    onChangeCallback: onPaginationCallback
  }), /*#__PURE__*/React.createElement(Swiper, _extends$1({}, swiperProps, {
    tag: tag,
    wrapperTag: wrapperTag,
    onInit: function onInit(swiper) {
      setPaginationCount(swiper.snapGrid.length);
      setSwiperInstance(swiper);
      _onInit(swiper);
    },
    onSnapIndexChange: function onSnapIndexChange(swiper) {
      onSnapIndexChangeCallback(swiper.snapIndex);
      setCurrentSlide(swiper.snapIndex);
    },
    onResize: function onResize(swiper) {
      setPaginationCount(swiper.snapGrid.length);
      onResizeCallback(swiper);
      setCurrentSlide(swiper.snapIndex);
    },
    onSlidesLengthChange: function onSlidesLengthChange(swiper) {
      setPaginationCount(swiper.snapGrid.length);
      setCurrentSlide(swiper.snapIndex);
    },
    onSnapGridLengthChange: function onSnapGridLengthChange(swiper) {
      setPaginationCount(swiper.snapGrid.length);
      setCurrentSlide(swiper.snapIndex);
    },
    onSlideChange: function onSlideChange(swiper) {
      onSlideChangeCallback(swiper);
    }
  }), children.map(function (child, index) {
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      key: "".concat(id, "-").concat(index),
      tag: slideTag
    }, child);
  })), !renderPaginationAboveSlider && generalPagination && paginationCount > 1 && /*#__PURE__*/React.cloneElement(generalPagination, {
    currentSlide: currentSlide + 1,
    paginationCount: paginationCount,
    onChangeCallback: onPaginationCallback
  }));
};
var swiperSliderPropTypes = {
  className: PropTypes.string,
  generalPagination: PropTypes.node,
  globalPagination: PropTypes.node,
  id: PropTypes.string,
  onInit: PropTypes.func,
  onResizeCallback: PropTypes.func,
  onSlideChangeCallback: PropTypes.func,
  onSnapIndexChangeCallback: PropTypes.func,
  paginationCurrentPage: PropTypes.string,
  slideTag: PropTypes.string,
  swiperProps: PropTypes.object,
  renderPaginationAboveSlider: PropTypes.bool,
  tag: PropTypes.string,
  wrapperTag: PropTypes.string,
  children: PropTypes.node
};
SwiperSliderWithPagination.propTypes = swiperSliderPropTypes;
SwiperSliderWithPagination.defaultProps = {
  className: '',
  id: 'swiper-slider',
  onSnapIndexChangeCallback: function onSnapIndexChangeCallback() {},
  paginationCurrentPage: 'Aktuell auf Seite:',
  renderPaginationAboveSlider: false,
  onInit: function onInit() {},
  onResizeCallback: function onResizeCallback() {},
  onSlideChangeCallback: function onSlideChangeCallback() {}
};
var SwiperSliderWithPagination$1 = SwiperSliderWithPagination;

var ProgressBar = function ProgressBar(_ref) {
  var currentStep = _ref.currentStep,
    _onClick = _ref.onClick,
    steps = _ref.steps,
    className = _ref.className;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    swiper = _useState2[0],
    setSwiper = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    activeSlide = _useState4[0],
    setActiveSlide = _useState4[1];
  var _useState5 = useState({
      watchSlidesProgress: true,
      slidesPerView: 2.2,
      centeredSlides: true,
      initialSlide: 1,
      breakpoints: {
        600: {
          slidesPerView: (steps === null || steps === void 0 ? void 0 : steps.length) <= 5 ? steps === null || steps === void 0 ? void 0 : steps.length : 5,
          initialSlide: 0,
          centeredSlides: false
        }
      }
    }),
    _useState6 = _slicedToArray(_useState5, 1),
    swiperProps = _useState6[0];
  var _useWindowSize = useWindowSize(),
    _useWindowSize2 = _slicedToArray(_useWindowSize, 1),
    windowWidth = _useWindowSize2[0];
  var visibleSlides = useMemo(function () {
    var _swiper$slides$map$fi, _swiper$slides, _swiper$slides$map;
    return (_swiper$slides$map$fi = swiper === null || swiper === void 0 ? void 0 : (_swiper$slides = swiper.slides) === null || _swiper$slides === void 0 ? void 0 : (_swiper$slides$map = _swiper$slides.map(function (slide, index) {
      return {
        slideIndex: index,
        slideElement: slide
      };
    })) === null || _swiper$slides$map === void 0 ? void 0 : _swiper$slides$map.filter(function (slide) {
      return slide.slideElement.className.includes('swiper-slide-visible');
    })) !== null && _swiper$slides$map$fi !== void 0 ? _swiper$slides$map$fi : [];
  }, [swiper === null || swiper === void 0 ? void 0 : swiper.activeIndex, currentStep]);

  // slides to step index while not moving the active slide to the most left/right position but to the first position where it is visible
  var slideToStepIndex = function slideToStepIndex(stepIndex) {
    if (!stepIndex) return;
    if (windowWidth >= 600) {
      var _visibleSlides$, _visibleSlides;
      if (stepIndex <= ((_visibleSlides$ = visibleSlides[0]) === null || _visibleSlides$ === void 0 ? void 0 : _visibleSlides$.slideIndex) || stepIndex >= ((_visibleSlides = visibleSlides[visibleSlides.length - 1]) === null || _visibleSlides === void 0 ? void 0 : _visibleSlides.slideIndex)) {
        // user swiped left
        if (stepIndex <= swiper.activeIndex) {
          swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(stepIndex - 1);
        }
        // user swiped right
        else {
          var visibleSlideOffset = visibleSlides.length - 2;
          swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(stepIndex - visibleSlideOffset);
        }
      }
    } else {
      swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(stepIndex);
    }
  };
  useEffect(function () {
    slideToStepIndex(currentStep);
  }, [currentStep, swiper]);
  return /*#__PURE__*/React.createElement("div", {
    "data-cy": "progress-bar",
    className: "relative progress-bar ".concat(className)
  }, /*#__PURE__*/React.createElement(SwiperSliderWithPagination$1, {
    wrapperTag: "ul",
    slideTag: "li",
    globalPagination: /*#__PURE__*/React.createElement(SwiperGlobalPagination$1, {
      className: "absolute w-full flex justify-between top-8",
      prevButtonClassName: "w-40 h-40 left-0  group ".concat(activeSlide <= 1 ? 'hidden 600:inline-flex' : '', " z-20"),
      nextButtonClassName: "w-40 h-40 right-0  z-20 group ".concat(activeSlide === (steps === null || steps === void 0 ? void 0 : steps.length) - 2 ? 'hidden 600:inline-flex' : ''),
      iconClassName: "transition ease-in-out duration-350 transform group-hover:scale-125"
    }),
    onSnapIndexChangeCallback: function onSnapIndexChangeCallback(id) {
      setActiveSlide(id);
    },
    onResizeCallback: function onResizeCallback(swiper) {
      // reset slider to first slide on resizing to mobile
      if (windowWidth < 600) {
        swiper.slideTo(1);
      }
    },
    onSlideChangeCallback: function onSlideChangeCallback() {
      // on mobile: prevent progress bar form centering first/last slide by snapping to second/second to last slide
      if (windowWidth < 600) {
        if ((swiper === null || swiper === void 0 ? void 0 : swiper.activeIndex) === 0) {
          swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(1);
        } else if ((swiper === null || swiper === void 0 ? void 0 : swiper.activeIndex) === (swiper === null || swiper === void 0 ? void 0 : swiper.slides.length) - 1) {
          swiper === null || swiper === void 0 ? void 0 : swiper.slideTo((swiper === null || swiper === void 0 ? void 0 : swiper.slides.length) - 2);
        }
      }
    },
    swiperProps: swiperProps,
    onInit: function onInit(swiper) {
      setSwiper(swiper);

      // disable swiper navigation on mobile if there are only 3 slides
      if (windowWidth < 600) {
        if (swiper.slides.length === 3) {
          swiper.allowSlidePrev = false;
          swiper.allowSlideNext = false;
        }
      }
    },
    className: "swiper-container --visible-slide-count-".concat(visibleSlides === null || visibleSlides === void 0 ? void 0 : visibleSlides.length)
  }, steps === null || steps === void 0 ? void 0 : steps.map(function (step, index) {
    var _step$completed, _step$disabled;
    var completed = (_step$completed = step === null || step === void 0 ? void 0 : step.completed) !== null && _step$completed !== void 0 ? _step$completed : false;
    var disabled = (_step$disabled = step === null || step === void 0 ? void 0 : step.disabled) !== null && _step$disabled !== void 0 ? _step$disabled : true;
    var active = index === currentStep;
    var anyNextStepEnabled = steps.slice(index + 1).find(function (step) {
      return !(step !== null && step !== void 0 && step.disabled);
    });
    var stepClasses = classnames({
      'border-2 border-c7ccd1 text-005e3f bg-faf8eb w-24 h-24 transform transition-transform group-hover:scale-125 group-focus-visible:scale-125': !disabled && !completed && !active,
      'border-2 border-005e3f text-005e3f bg-faf8eb w-24 h-24 transform transition-transform group-hover:scale-125 group-focus-visible:scale-125': !disabled && completed && !active,
      'outline outline-f8f5e3 outline-4 bg-005e3f text-ffffff w-32 h-32': active,
      'border-2 border-c7ccd1 text-828b91 w-24 h-24 bg-faf8eb transform transition-transform': disabled
    });
    return /*#__PURE__*/React.createElement("div", {
      key: step === null || step === void 0 ? void 0 : step.id,
      "data-cy": "step-".concat(index),
      className: "w-full flex flex-col justify-between items-center  relative px-16\n              ".concat(completed || anyNextStepEnabled ? 'render-line-active' : '')
    }, /*#__PURE__*/React.createElement("button", {
      "data-cy": "step-".concat(index, "-button"),
      disabled: disabled,
      onClick: function onClick() {
        return _onClick(index);
      },
      onFocus: function onFocus() {
        return slideToStepIndex(index);
      },
      "aria-current": active ? 'step' : null
      // max-w prevents labels to become too wide on desktop; with max-w-424 every label can grow until 224px in width
      ,
      className: "w-full max-w-424 group outline-none flex flex-col items-center ".concat(index === 0 ? 'text-left' : index === steps.length - 1 ? 'text-right' : 'text-center', "\n                ")
    }, /*#__PURE__*/React.createElement("span", {
      className: "\n                    font-buenos-aires-text font-semibold text-14 leading-20 rounded-full flex justify-center items-center\n                    before:empty-content before:absolute before:inset-0 before:bg-transparent \n                    group-focus-visible:ring-1 group-focus-visible:ring-offset-4 group-focus-visible:ring-18ab42 \n                    group-focus-visible:ring-offset-faf8eb\n                    ".concat(stepClasses, " ").concat(active ? 'mt-4' : 'mt-8', "\n                  ")
    }, /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, 'Schritt ' + (index + 1)), /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true",
      className: "relative top-1"
    }, index + 1)), /*#__PURE__*/React.createElement("span", {
      className: "break-words w-[calc(50%+12px)] inline-block ".concat(active ? 'font-semibold mt-8' : 'mt-12', " text-14 font-buenos-aires-text  \n                ").concat(index === 0 ? 'mr-0 ml-auto' : index === steps.length - 1 ? 'ml-0 mr-auto' : '')
    }, step.label)));
  })));
};
ProgressBar.propTypes = {
  currentStep: PropTypes.number,
  onClick: PropTypes.func,
  steps: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
    completed: PropTypes.bool,
    disabled: PropTypes.bool
  })),
  className: PropTypes.string
};
ProgressBar.defaultProps = {
  currentStep: 0,
  steps: [{
    id: 0,
    label: 'Schritt nicht gesetzt'
  }],
  className: '',
  onClick: function onClick() {}
};
var ProgressBar$1 = ProgressBar;

var _excluded = ["url", "className", "theme", "target", "size", "variant", "isDisabled"];
var ColorScheme = {
  LIGHT: 'light',
  DARK: 'dark'
};
var BackgroundScheme = {
  LIGHT: 'light',
  DARK: 'dark',
  STRUCTURE: 'structure'
};
var IconSize = {
  MEDIUM: 'medium',
  SMALL: 'small'
};
var Toggle = function Toggle(_ref) {
  var url = _ref.url,
    className = _ref.className,
    theme = _ref.theme,
    target = _ref.target,
    size = _ref.size,
    variant = _ref.variant,
    isDisabled = _ref.isDisabled,
    rest = _objectWithoutProperties$1(_ref, _excluded);
  var textClasses = classnames('rounded-100 border-2 flex justify-center items-center transition ease-in-out duration-350', {
    'w-48 h-48': size === IconSize.MEDIUM,
    'w-40 h-40': size === IconSize.SMALL,
    // Klassen für LIGHT und STRUCTURE Variants
    'text-004730 border-afb6bc group-hover:text-004730 hover:bg-dfe3e6': theme === ColorScheme.LIGHT && (variant === BackgroundScheme.LIGHT || variant === BackgroundScheme.STRUCTURE) && !isDisabled,
    'text-ffffff bg-005e3f border-005e3f hover:bg-004730 hover:border-004730': theme === ColorScheme.DARK && (variant === BackgroundScheme.LIGHT || variant === BackgroundScheme.STRUCTURE) && !isDisabled,
    // Klassen für DARK Variant
    'text-ffffff border-ffffff group-hover:text-dfe3e6 hover:bg-007141': theme === ColorScheme.LIGHT && variant === BackgroundScheme.DARK && !isDisabled,
    'text-004730 bg-ffffff border-ffffff hover:bg-dfe3e6 hover:border-dfe3e6': theme === ColorScheme.DARK && variant === BackgroundScheme.DARK && !isDisabled,
    // Klassen für LIGHT und STRUCTURE Variants im Disabled-Zustand
    'bg-transparent text-afb6bc border-dfe3e6': theme === ColorScheme.LIGHT && (variant === BackgroundScheme.LIGHT || variant === BackgroundScheme.STRUCTURE) && isDisabled,
    'bg-dfe3e6 text-98a1a6 border-dfe3e6': theme === ColorScheme.DARK && (variant === BackgroundScheme.LIGHT || variant === BackgroundScheme.STRUCTURE) && isDisabled,
    // Klassen für DARK Variant im Disabled-Zustand
    'bg-transparent text-98a1a6 border-6d767c': theme === ColorScheme.LIGHT && variant === BackgroundScheme.DARK && isDisabled,
    'bg-586167 text-98a1a6 border-586167': theme === ColorScheme.DARK && variant === BackgroundScheme.DARK && isDisabled
  });
  var iconClasses = classnames('w-16 h-16 fill-current transition-transform duration-350', {
    'group-hover:scale-125': !isDisabled
  });
  var IconComponent = theme === ColorScheme.DARK ? BookmarkFilled : Bookmark;
  var content = /*#__PURE__*/React.createElement("div", {
    className: "".concat(textClasses)
  }, /*#__PURE__*/React.createElement(IconComponent, {
    className: iconClasses
  }));
  return /*#__PURE__*/React.createElement(InteractiveElement$1, _extends$1({
    url: !isDisabled ? url : undefined,
    rel: !isDisabled && target === '_blank' ? 'noopener noreferrer' : null,
    target: !isDisabled ? target : undefined,
    className: classnames('group', className, {
      'outline-none focus-visible:rounded-100 focus-visible:ring-1 focus-visible:ring-18ab42 focus-visible:ring-offset-4': !isDisabled,
      'focus-visible:ring-offset-007141 focus-visible:bg-007141': variant === BackgroundScheme.DARK && !isDisabled,
      'focus-visible:ring-offset-eefaea': variant === BackgroundScheme.STRUCTURE && !isDisabled,
      'cursor-not-allowed': isDisabled
    })
  }, rest), content);
};
Toggle.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any,
  target: PropTypes.oneOf(['_blank', '_self']),
  isDisabled: PropTypes.bool,
  theme: PropTypes.oneOf([ColorScheme.LIGHT, ColorScheme.DARK]),
  size: PropTypes.oneOf([IconSize.MEDIUM, IconSize.SMALL]),
  variant: PropTypes.oneOf([BackgroundScheme.LIGHT, BackgroundScheme.DARK, BackgroundScheme.STRUCTURE])
};
Toggle.defaultProps = {
  theme: ColorScheme.LIGHT,
  title: 'Titel wurde nicht gesetzt',
  isDisabled: false,
  className: '',
  size: IconSize.MEDIUM,
  variant: BackgroundScheme.LIGHT
};
var Toggle$1 = Toggle;

export { Accordion$1 as Accordion, AccordionElement$1 as AccordionElement, AutocompleteList$1 as AutocompleteList, Checkbox$1 as Checkbox, CheckboxButtonGroup$1 as CheckboxButtonGroup, Chip$1 as Chip, CombinedPagination$1 as CombinedPagination, Datepicker$1 as Datepicker, Dialog$1 as Dialog, DottedPagination$1 as DottedPagination, Dropdown$1 as Dropdown, DropdownFloating$1 as DropdownFloating, ErrorView$1 as ErrorView, InputField$1 as InputField, InteractiveElement$1 as InteractiveElement, InteractiveElementsBoxShadowWrapper$1 as InteractiveElementsBoxShadowWrapper, JumpLink$1 as JumpLink, Link$1 as Link, LinkHeadline$1 as LinkHeadline, LoadingView$1 as LoadingView, NumberedPaginationLong$1 as NumberedPaginationLong, NumberedPaginationShort$1 as NumberedPaginationShort, Overlay$1 as Overlay, Popover$1 as Popover, PrimaryButton$1 as PrimaryButton, PrimaryFloatingButton$1 as PrimaryFloatingButton, ProgressBar$1 as ProgressBar, RadioButtonGroup$1 as RadioButtonGroup, RangeSlider$1 as RangeSlider, SearchField$1 as SearchField, SecondaryButton$1 as SecondaryButton, SecondaryFloatingButton$1 as SecondaryFloatingButton, Slider$1 as Slider, SocialMediaLink$1 as SocialMediaLink, StatusNotification$1 as StatusNotification, SwiperGeneralPagination$1 as SwiperGeneralPagination, SwiperGlobalPagination$1 as SwiperGlobalPagination, SwiperSliderWithPagination$1 as SwiperSliderWithPagination, Tabs$1 as Tabs, Textarea$1 as Textarea, Toggle$1 as Toggle, UploadField$1 as UploadField };
